import { ITable } from './lib/types';

/**
 * Wikipedia:繁简处理/简繁单字
 * https://zh.wikipedia.org/wiki/Wikipedia:%E7%B9%81%E7%AE%80%E5%A4%84%E7%90%86/%E7%AE%80%E7%B9%81%E5%8D%95%E5%AD%97
 */
export const wiki_s2t: ITable = {
	"䌶": "䊷",
	"䜥": "𧩙",
	"专": "專",
	"业": "業",
	"丛": "叢",
	"东": "東",
	"丝": "絲",
	"丢": "丟",
	"两": "兩",
	"严": "嚴",
	"丧": "喪",
	"个": "個",
	"临": "臨",
	"丽": "麗",
	"举": "舉",
	"义": "義",
	"乌": "烏",
	"乐": "樂",
	"乔": "喬",
	"习": "習",
	"乡": "鄉",
	"书": "書",
	"买": "買",
	"乱": "亂",
	"争": "爭",
	"亏": "虧",
	"亚": "亞",
	"亩": "畝",
	"亲": "親",
	"亵": "褻",
	"亸": "嚲",
	"亿": "億",
	"仅": "僅",
	"从": "從",
	"仑": "侖",
	"仓": "倉",
	"仪": "儀",
	"们": "們",
	"优": "優",
	"会": "會",
	"伛": "傴",
	"伞": "傘",
	"伟": "偉",
	"传": "傳",
	"伣": "俔",
	"伤": "傷",
	"伥": "倀",
	"伦": "倫",
	"伧": "傖",
	"伫": "佇",
	"佥": "僉",
	"侠": "俠",
	"侣": "侶",
	"侥": "僥",
	"侦": "偵",
	"侧": "側",
	"侨": "僑",
	"侩": "儈",
	"侪": "儕",
	"侬": "儂",
	"俣": "俁",
	"俦": "儔",
	"俨": "儼",
	"俩": "倆",
	"俪": "儷",
	"俫": "倈",
	"俭": "儉",
	"债": "債",
	"倾": "傾",
	"偬": "傯",
	"偻": "僂",
	"偾": "僨",
	"偿": "償",
	"傥": "儻",
	"傧": "儐",
	"储": "儲",
	"傩": "儺",
	"兑": "兌",
	"兖": "兗",
	"兰": "蘭",
	"关": "關",
	"兴": "興",
	"兹": "茲",
	"养": "養",
	"兽": "獸",
	"冁": "囅",
	"内": "內",
	"冈": "岡",
	"册": "冊",
	"写": "寫",
	"军": "軍",
	"农": "農",
	"冯": "馮",
	"决": "決",
	"况": "況",
	"冻": "凍",
	"净": "凈",
	"凉": "涼",
	"减": "減",
	"凑": "湊",
	"凛": "凜",
	"凤": "鳳",
	"凯": "凱",
	"击": "擊",
	"凿": "鑿",
	"刍": "芻",
	"刘": "劉",
	"则": "則",
	"刚": "剛",
	"创": "創",
	"删": "刪",
	"刬": "剗",
	"刭": "剄",
	"刹": "剎",
	"刽": "劊",
	"刿": "劌",
	"剀": "剴",
	"剂": "劑",
	"剐": "剮",
	"剑": "劍",
	"剥": "剝",
	"剧": "劇",
	"劝": "勸",
	"办": "辦",
	"务": "務",
	"劢": "勱",
	"动": "動",
	"励": "勵",
	"劲": "勁",
	"劳": "勞",
	"势": "勢",
	"勋": "勛",
	"勚": "勩",
	"匀": "勻",
	"匦": "匭",
	"匮": "匱",
	"区": "區",
	"医": "醫",
	"华": "華",
	"协": "協",
	"单": "單",
	"卖": "賣",
	"卢": "盧",
	"卫": "衛",
	"却": "卻",
	"厅": "廳",
	"厉": "厲",
	"压": "壓",
	"厌": "厭",
	"厍": "厙",
	"厐": "龎",
	"厘": "釐",
	"厢": "廂",
	"厣": "厴",
	"厦": "廈",
	"厨": "廚",
	"厩": "廄",
	"厮": "廝",
	"县": "縣",
	"叁": "叄",
	"参": "參",
	"双": "雙",
	"变": "變",
	"叙": "敘",
	"叠": "疊",
	"号": "號",
	"叹": "嘆",
	"叽": "嘰",
	"吓": "嚇",
	"吕": "呂",
	"吗": "嗎",
	"吣": "唚",
	"吨": "噸",
	"听": "聽",
	"吴": "吳",
	"呐": "吶",
	"呒": "嘸",
	"呓": "囈",
	"呕": "嘔",
	"呖": "嚦",
	"呗": "唄",
	"员": "員",
	"呙": "咼",
	"呛": "嗆",
	"呜": "嗚",
	"咏": "詠",
	"咙": "嚨",
	"咛": "嚀",
	"咝": "噝",
	"咤": "吒",
	"响": "響",
	"哑": "啞",
	"哒": "噠",
	"哓": "嘵",
	"哔": "嗶",
	"哕": "噦",
	"哗": "嘩",
	"哙": "噲",
	"哜": "嚌",
	"哝": "噥",
	"哟": "喲",
	"唛": "嘜",
	"唝": "嗊",
	"唠": "嘮",
	"唡": "啢",
	"唢": "嗩",
	"唤": "喚",
	"啧": "嘖",
	"啬": "嗇",
	"啭": "囀",
	"啮": "嚙",
	"啴": "嘽",
	"啸": "嘯",
	"㖞": "喎",
	"喷": "噴",
	"喽": "嘍",
	"喾": "嚳",
	"嗫": "囁",
	"嗳": "噯",
	"嘘": "噓",
	"嘤": "嚶",
	"嘱": "囑",
	"噜": "嚕",
	"嚣": "囂",
	"园": "園",
	"囱": "囪",
	"围": "圍",
	"囵": "圇",
	"国": "國",
	"图": "圖",
	"圆": "圓",
	"圣": "聖",
	"圹": "壙",
	"场": "場",
	"坂": "阪",
	"块": "塊",
	"坚": "堅",
	"坜": "壢",
	"坝": "壩",
	"坞": "塢",
	"坟": "墳",
	"坠": "墜",
	"垄": "壟",
	"垅": "壠",
	"垆": "壚",
	"垒": "壘",
	"垦": "墾",
	"垩": "堊",
	"垫": "墊",
	"垭": "埡",
	"垱": "壋",
	"垲": "塏",
	"垴": "堖",
	"埘": "塒",
	"埙": "塤",
	"埚": "堝",
	"埯": "垵",
	"堑": "塹",
	"堕": "墮",
	"𡒄": "壈",
	"壮": "壯",
	"声": "聲",
	"壶": "壺",
	"壸": "壼",
	"处": "處",
	"备": "備",
	"够": "夠",
	"头": "頭",
	"夹": "夾",
	"夺": "奪",
	"奁": "奩",
	"奂": "奐",
	"奋": "奮",
	"奥": "奧",
	"妆": "妝",
	"妇": "婦",
	"妈": "媽",
	"妩": "嫵",
	"妪": "嫗",
	"姗": "姍",
	"姹": "奼",
	"娄": "婁",
	"娅": "婭",
	"娆": "嬈",
	"娇": "嬌",
	"娈": "孌",
	"娱": "娛",
	"娲": "媧",
	"娴": "嫻",
	"婳": "嫿",
	"婴": "嬰",
	"婵": "嬋",
	"婶": "嬸",
	"媪": "媼",
	"嫒": "嬡",
	"嫔": "嬪",
	"嫱": "嬙",
	"嬷": "嬤",
	"孙": "孫",
	"学": "學",
	"孪": "孿",
	"宝": "寶",
	"实": "實",
	"宠": "寵",
	"审": "審",
	"宪": "憲",
	"宫": "宮",
	"宽": "寬",
	"宾": "賓",
	"寝": "寢",
	"对": "對",
	"寻": "尋",
	"导": "導",
	"寿": "壽",
	"将": "將",
	"尔": "爾",
	"尘": "塵",
	"尝": "嘗",
	"尧": "堯",
	"尴": "尷",
	"尸": "屍",
	"层": "層",
	"屃": "屓",
	"屉": "屜",
	"届": "屆",
	"属": "屬",
	"屡": "屢",
	"屦": "屨",
	"屿": "嶼",
	"岁": "歲",
	"岂": "豈",
	"岖": "嶇",
	"岗": "崗",
	"岘": "峴",
	"岙": "嶴",
	"岚": "嵐",
	"岛": "島",
	"岭": "嶺",
	"岽": "崬",
	"岿": "巋",
	"峄": "嶧",
	"峡": "峽",
	"峣": "嶢",
	"峤": "嶠",
	"峥": "崢",
	"峦": "巒",
	"崂": "嶗",
	"崃": "崍",
	"崄": "嶮",
	"崭": "嶄",
	"嵘": "嶸",
	"嵚": "嶔",
	"嵝": "嶁",
	"巅": "巔",
	"巩": "鞏",
	"巯": "巰",
	"币": "幣",
	"帅": "帥",
	"师": "師",
	"帏": "幃",
	"帐": "帳",
	"帜": "幟",
	"带": "帶",
	"帧": "幀",
	"帮": "幫",
	"帱": "幬",
	"帻": "幘",
	"帼": "幗",
	"幂": "冪",
	"幺": "么",
	"庄": "莊",
	"庆": "慶",
	"庐": "廬",
	"庑": "廡",
	"库": "庫",
	"应": "應",
	"庙": "廟",
	"庞": "龐",
	"废": "廢",
	"廪": "廩",
	"开": "開",
	"异": "異",
	"弃": "棄",
	"弑": "弒",
	"张": "張",
	"弪": "弳",
	"弯": "彎",
	"弹": "彈",
	"强": "強",
	"归": "歸",
	"彝": "彞",
	"彦": "彥",
	"彻": "徹",
	"径": "徑",
	"徕": "徠",
	"忆": "憶",
	"忏": "懺",
	"忧": "憂",
	"忾": "愾",
	"怀": "懷",
	"态": "態",
	"怂": "慫",
	"怃": "憮",
	"怄": "慪",
	"怅": "悵",
	"怆": "愴",
	"怜": "憐",
	"总": "總",
	"怼": "懟",
	"怿": "懌",
	"恋": "戀",
	"恒": "恆",
	"恳": "懇",
	"恸": "慟",
	"恹": "懨",
	"恺": "愷",
	"恻": "惻",
	"恼": "惱",
	"恽": "惲",
	"悦": "悅",
	"悬": "懸",
	"悭": "慳",
	"悮": "悞",
	"悯": "憫",
	"惊": "驚",
	"惧": "懼",
	"惨": "慘",
	"惩": "懲",
	"惫": "憊",
	"惬": "愜",
	"惭": "慚",
	"惮": "憚",
	"惯": "慣",
	"愠": "慍",
	"愤": "憤",
	"愦": "憒",
	"慑": "懾",
	"懑": "懣",
	"懒": "懶",
	"懔": "懍",
	"戆": "戇",
	"戋": "戔",
	"戏": "戲",
	"戗": "戧",
	"战": "戰",
	"戬": "戩",
	"戯": "戱",
	"户": "戶",
	"扑": "撲",
	"执": "執",
	"扩": "擴",
	"扪": "捫",
	"扫": "掃",
	"扬": "揚",
	"扰": "擾",
	"抚": "撫",
	"抛": "拋",
	"抟": "摶",
	"抠": "摳",
	"抡": "掄",
	"抢": "搶",
	"护": "護",
	"报": "報",
	"拟": "擬",
	"拢": "攏",
	"拣": "揀",
	"拥": "擁",
	"拦": "攔",
	"拧": "擰",
	"拨": "撥",
	"择": "擇",
	"挂": "掛",
	"挚": "摯",
	"挛": "攣",
	"挜": "掗",
	"挝": "撾",
	"挞": "撻",
	"挟": "挾",
	"挠": "撓",
	"挡": "擋",
	"挢": "撟",
	"挣": "掙",
	"挤": "擠",
	"挥": "揮",
	"挦": "撏",
	"挽": "輓",
	"捝": "挩",
	"捞": "撈",
	"损": "損",
	"捡": "撿",
	"换": "換",
	"捣": "搗",
	"掳": "擄",
	"掴": "摑",
	"掷": "擲",
	"掸": "撣",
	"掺": "摻",
	"掼": "摜",
	"揽": "攬",
	"揾": "搵",
	"揿": "撳",
	"搀": "攙",
	"搁": "擱",
	"搂": "摟",
	"搅": "攪",
	"携": "攜",
	"摄": "攝",
	"摅": "攄",
	"摆": "擺",
	"摇": "搖",
	"摈": "擯",
	"摊": "攤",
	"撄": "攖",
	"撑": "撐",
	"㧑": "撝",
	"撵": "攆",
	"撷": "擷",
	"撸": "擼",
	"撺": "攛",
	"㧟": "擓",
	"擞": "擻",
	"攒": "攢",
	"敌": "敵",
	"敛": "斂",
	"数": "數",
	"斋": "齋",
	"斓": "斕",
	"斩": "斬",
	"断": "斷",
	"无": "無",
	"旧": "舊",
	"时": "時",
	"旷": "曠",
	"旸": "暘",
	"昙": "曇",
	"昼": "晝",
	"昽": "曨",
	"显": "顯",
	"晋": "晉",
	"晒": "曬",
	"晓": "曉",
	"晔": "曄",
	"晕": "暈",
	"晖": "暉",
	"暂": "暫",
	"暧": "曖",
	"机": "機",
	"杀": "殺",
	"杂": "雜",
	"权": "權",
	"杆": "桿",
	"条": "條",
	"来": "來",
	"杨": "楊",
	"杩": "榪",
	"杰": "傑",
	"构": "構",
	"枞": "樅",
	"枢": "樞",
	"枣": "棗",
	"枥": "櫪",
	"枧": "梘",
	"枨": "棖",
	"枪": "槍",
	"枫": "楓",
	"枭": "梟",
	"柠": "檸",
	"柽": "檉",
	"栀": "梔",
	"栅": "柵",
	"标": "標",
	"栈": "棧",
	"栉": "櫛",
	"栊": "櫳",
	"栋": "棟",
	"栌": "櫨",
	"栎": "櫟",
	"栏": "欄",
	"树": "樹",
	"栖": "棲",
	"栗": "慄",
	"样": "樣",
	"栾": "欒",
	"桠": "椏",
	"桡": "橈",
	"桢": "楨",
	"档": "檔",
	"桤": "榿",
	"桥": "橋",
	"桦": "樺",
	"桧": "檜",
	"桨": "槳",
	"桩": "樁",
	"梦": "夢",
	"梼": "檮",
	"梾": "棶",
	"梿": "槤",
	"检": "檢",
	"棁": "梲",
	"棂": "欞",
	"椁": "槨",
	"椟": "櫝",
	"椠": "槧",
	"椤": "欏",
	"椭": "橢",
	"楼": "樓",
	"榄": "欖",
	"榅": "榲",
	"榇": "櫬",
	"榈": "櫚",
	"榉": "櫸",
	"槚": "檟",
	"槛": "檻",
	"槟": "檳",
	"槠": "櫧",
	"横": "橫",
	"樯": "檣",
	"樱": "櫻",
	"橥": "櫫",
	"橱": "櫥",
	"橹": "櫓",
	"橼": "櫞",
	"檩": "檁",
	"欢": "歡",
	"欤": "歟",
	"欧": "歐",
	"歼": "殲",
	"殁": "歿",
	"殇": "殤",
	"残": "殘",
	"殒": "殞",
	"殓": "殮",
	"殚": "殫",
	"殡": "殯",
	"㱮": "殨",
	"殴": "毆",
	"毁": "毀",
	"毂": "轂",
	"毕": "畢",
	"毙": "斃",
	"毡": "氈",
	"毵": "毿",
	"氇": "氌",
	"气": "氣",
	"氢": "氫",
	"氩": "氬",
	"氲": "氳",
	"汉": "漢",
	"汤": "湯",
	"汹": "洶",
	"沟": "溝",
	"没": "沒",
	"沣": "灃",
	"沤": "漚",
	"沥": "瀝",
	"沦": "淪",
	"沧": "滄",
	"沪": "滬",
	"泞": "濘",
	"泪": "淚",
	"泶": "澩",
	"泷": "瀧",
	"泸": "瀘",
	"泺": "濼",
	"泻": "瀉",
	"泼": "潑",
	"泽": "澤",
	"泾": "涇",
	"洁": "潔",
	"洒": "灑",
	"洼": "窪",
	"浃": "浹",
	"浅": "淺",
	"浆": "漿",
	"浇": "澆",
	"浈": "湞",
	"浊": "濁",
	"测": "測",
	"浍": "澮",
	"济": "濟",
	"浏": "瀏",
	"浐": "滻",
	"浑": "渾",
	"浒": "滸",
	"浓": "濃",
	"浔": "潯",
	"涛": "濤",
	"涝": "澇",
	"涞": "淶",
	"涟": "漣",
	"涠": "潿",
	"涡": "渦",
	"涣": "渙",
	"涤": "滌",
	"润": "潤",
	"涧": "澗",
	"涨": "漲",
	"涩": "澀",
	"渊": "淵",
	"渌": "淥",
	"渍": "漬",
	"渎": "瀆",
	"渐": "漸",
	"渑": "澠",
	"渔": "漁",
	"渖": "瀋",
	"渗": "滲",
	"温": "溫",
	"湾": "灣",
	"湿": "濕",
	"溃": "潰",
	"溅": "濺",
	"溆": "漵",
	"滗": "潷",
	"滚": "滾",
	"滞": "滯",
	"滟": "灧",
	"滠": "灄",
	"满": "滿",
	"滢": "瀅",
	"滤": "濾",
	"滥": "濫",
	"滦": "灤",
	"滨": "濱",
	"滩": "灘",
	"滪": "澦",
	"漤": "灠",
	"潆": "瀠",
	"潇": "瀟",
	"潋": "瀲",
	"潍": "濰",
	"潜": "潛",
	"潴": "瀦",
	"澜": "瀾",
	"濑": "瀨",
	"濒": "瀕",
	"灏": "灝",
	"灭": "滅",
	"灯": "燈",
	"灵": "靈",
	"灶": "竈",
	"灾": "災",
	"灿": "燦",
	"炀": "煬",
	"炉": "爐",
	"炖": "燉",
	"炜": "煒",
	"炝": "熗",
	"点": "點",
	"炼": "煉",
	"炽": "熾",
	"烁": "爍",
	"烂": "爛",
	"烃": "烴",
	"烛": "燭",
	"烟": "煙",
	"烦": "煩",
	"烧": "燒",
	"烨": "燁",
	"烩": "燴",
	"烫": "燙",
	"烬": "燼",
	"热": "熱",
	"焕": "煥",
	"焖": "燜",
	"焘": "燾",
	"煴": "熅",
	"爱": "愛",
	"爷": "爺",
	"牍": "牘",
	"牦": "氂",
	"牵": "牽",
	"牺": "犧",
	"犊": "犢",
	"状": "狀",
	"犷": "獷",
	"犸": "獁",
	"犹": "猶",
	"狈": "狽",
	"狝": "獮",
	"狞": "獰",
	"独": "獨",
	"狭": "狹",
	"狮": "獅",
	"狯": "獪",
	"狰": "猙",
	"狱": "獄",
	"狲": "猻",
	"猃": "獫",
	"猎": "獵",
	"猕": "獼",
	"猡": "玀",
	"猪": "豬",
	"猫": "貓",
	"猬": "蝟",
	"献": "獻",
	"獭": "獺",
	"玑": "璣",
	"玚": "瑒",
	"玛": "瑪",
	"玮": "瑋",
	"环": "環",
	"现": "現",
	"玱": "瑲",
	"玺": "璽",
	"珐": "琺",
	"珑": "瓏",
	"珰": "璫",
	"珲": "琿",
	"琏": "璉",
	"琐": "瑣",
	"琼": "瓊",
	"瑶": "瑤",
	"瑷": "璦",
	"璎": "瓔",
	"瓒": "瓚",
	"瓯": "甌",
	"电": "電",
	"画": "畫",
	"畅": "暢",
	"畴": "疇",
	"疖": "癤",
	"疗": "療",
	"疟": "瘧",
	"疠": "癘",
	"疡": "瘍",
	"疬": "癧",
	"疭": "瘲",
	"疮": "瘡",
	"疯": "瘋",
	"疱": "皰",
	"疴": "痾",
	"痈": "癰",
	"痉": "痙",
	"痒": "癢",
	"痖": "瘂",
	"痨": "癆",
	"痪": "瘓",
	"痫": "癇",
	"瘅": "癉",
	"瘆": "瘮",
	"瘗": "瘞",
	"瘪": "癟",
	"瘫": "癱",
	"瘾": "癮",
	"瘿": "癭",
	"癞": "癩",
	"癣": "癬",
	"癫": "癲",
	"皑": "皚",
	"皱": "皺",
	"皲": "皸",
	"盏": "盞",
	"盐": "鹽",
	"监": "監",
	"盖": "蓋",
	"盗": "盜",
	"盘": "盤",
	"眍": "瞘",
	"眦": "眥",
	"眬": "矓",
	"着": "著",
	"睁": "睜",
	"睐": "睞",
	"睑": "瞼",
	"瞆": "瞶",
	"瞒": "瞞",
	"䁖": "瞜",
	"瞩": "矚",
	"矫": "矯",
	"矶": "磯",
	"矾": "礬",
	"矿": "礦",
	"砀": "碭",
	"码": "碼",
	"砖": "磚",
	"砗": "硨",
	"砚": "硯",
	"砜": "碸",
	"砺": "礪",
	"砻": "礱",
	"砾": "礫",
	"础": "礎",
	"硁": "硜",
	"硕": "碩",
	"硖": "硤",
	"硗": "磽",
	"硙": "磑",
	"碍": "礙",
	"碛": "磧",
	"碜": "磣",
	"碱": "鹼",
	"礼": "禮",
	"祃": "禡",
	"祎": "禕",
	"祢": "禰",
	"祯": "禎",
	"祷": "禱",
	"祸": "禍",
	"禀": "稟",
	"禄": "祿",
	"禅": "禪",
	"离": "離",
	"秃": "禿",
	"秆": "稈",
	"积": "積",
	"称": "稱",
	"秽": "穢",
	"秾": "穠",
	"稆": "穭",
	"税": "稅",
	"稣": "穌",
	"稳": "穩",
	"穑": "穡",
	"穷": "窮",
	"窃": "竊",
	"窍": "竅",
	"窎": "窵",
	"窑": "窯",
	"窜": "竄",
	"窝": "窩",
	"窥": "窺",
	"窦": "竇",
	"窭": "窶",
	"竞": "競",
	"笃": "篤",
	"笋": "筍",
	"笔": "筆",
	"笕": "筧",
	"笺": "箋",
	"笼": "籠",
	"笾": "籩",
	"筚": "篳",
	"筛": "篩",
	"筜": "簹",
	"筝": "箏",
	"䇲": "筴",
	"筹": "籌",
	"筼": "篔",
	"简": "簡",
	"箓": "籙",
	"箦": "簀",
	"箧": "篋",
	"箨": "籜",
	"箩": "籮",
	"箪": "簞",
	"箫": "簫",
	"篑": "簣",
	"篓": "簍",
	"篮": "籃",
	"篱": "籬",
	"簖": "籪",
	"籁": "籟",
	"籴": "糴",
	"类": "類",
	"籼": "秈",
	"粜": "糶",
	"粝": "糲",
	"粤": "粵",
	"粪": "糞",
	"粮": "糧",
	"糁": "糝",
	"糇": "餱",
	"紧": "緊",
	"䌷": "紬",
	"䌹": "絅",
	"絷": "縶",
	"䌸": "縳",
	"䍁": "繸",
	"纟": "糹",
	"纠": "糾",
	"纡": "紆",
	"红": "紅",
	"纣": "紂",
	"纥": "紇",
	"约": "約",
	"级": "級",
	"纨": "紈",
	"纩": "纊",
	"纪": "紀",
	"纫": "紉",
	"纬": "緯",
	"纭": "紜",
	"纮": "紘",
	"纯": "純",
	"纰": "紕",
	"纱": "紗",
	"纲": "綱",
	"纳": "納",
	"纴": "紝",
	"纵": "縱",
	"纶": "綸",
	"纷": "紛",
	"纸": "紙",
	"纹": "紋",
	"纺": "紡",
	"纻": "紵",
	"纼": "紖",
	"纽": "紐",
	"纾": "紓",
	"绀": "紺",
	"绁": "紲",
	"绂": "紱",
	"练": "練",
	"组": "組",
	"绅": "紳",
	"细": "細",
	"织": "織",
	"终": "終",
	"绉": "縐",
	"绊": "絆",
	"绋": "紼",
	"绌": "絀",
	"绍": "紹",
	"绎": "繹",
	"经": "經",
	"绐": "紿",
	"绑": "綁",
	"绒": "絨",
	"结": "結",
	"绔": "絝",
	"绕": "繞",
	"绖": "絰",
	"绗": "絎",
	"绘": "繪",
	"给": "給",
	"绚": "絢",
	"绛": "絳",
	"络": "絡",
	"绞": "絞",
	"统": "統",
	"绠": "綆",
	"绡": "綃",
	"绢": "絹",
	"绤": "綌",
	"绥": "綏",
	"继": "繼",
	"绨": "綈",
	"绩": "績",
	"绪": "緒",
	"绫": "綾",
	"绬": "緓",
	"续": "續",
	"绮": "綺",
	"绯": "緋",
	"绰": "綽",
	"绲": "緄",
	"绳": "繩",
	"维": "維",
	"绵": "綿",
	"绶": "綬",
	"绸": "綢",
	"绹": "綯",
	"绺": "綹",
	"绻": "綣",
	"综": "綜",
	"绽": "綻",
	"绾": "綰",
	"缀": "綴",
	"缁": "緇",
	"缂": "緙",
	"缃": "緗",
	"缄": "緘",
	"缅": "緬",
	"缆": "纜",
	"缇": "緹",
	"缈": "緲",
	"缉": "緝",
	"缊": "縕",
	"缋": "繢",
	"缌": "緦",
	"缍": "綞",
	"缎": "緞",
	"缏": "緶",
	"缑": "緱",
	"缒": "縋",
	"缓": "緩",
	"缔": "締",
	"缕": "縷",
	"编": "編",
	"缗": "緡",
	"缘": "緣",
	"缙": "縉",
	"缚": "縛",
	"缛": "縟",
	"缜": "縝",
	"缝": "縫",
	"缞": "縗",
	"缟": "縞",
	"缠": "纏",
	"缡": "縭",
	"缢": "縊",
	"缣": "縑",
	"缤": "繽",
	"缥": "縹",
	"缦": "縵",
	"缧": "縲",
	"缨": "纓",
	"缩": "縮",
	"缪": "繆",
	"缫": "繅",
	"缬": "纈",
	"缭": "繚",
	"缮": "繕",
	"缯": "繒",
	"缱": "繾",
	"缲": "繰",
	"缳": "繯",
	"缴": "繳",
	"缵": "纘",
	"罂": "罌",
	"网": "網",
	"罗": "羅",
	"罚": "罰",
	"罢": "罷",
	"罴": "羆",
	"羁": "羈",
	"羟": "羥",
	"翘": "翹",
	"耢": "耮",
	"耧": "耬",
	"耸": "聳",
	"耻": "恥",
	"聂": "聶",
	"聋": "聾",
	"职": "職",
	"聍": "聹",
	"联": "聯",
	"聩": "聵",
	"聪": "聰",
	"肃": "肅",
	"肠": "腸",
	"肤": "膚",
	"肮": "骯",
	"肴": "餚",
	"肾": "腎",
	"肿": "腫",
	"胀": "脹",
	"胁": "脅",
	"胆": "膽",
	"胧": "朧",
	"胨": "腖",
	"胪": "臚",
	"胫": "脛",
	"胶": "膠",
	"脉": "脈",
	"脍": "膾",
	"脐": "臍",
	"脑": "腦",
	"脓": "膿",
	"脔": "臠",
	"脚": "腳",
	"脱": "脫",
	"脶": "腡",
	"脸": "臉",
	"腭": "齶",
	"腻": "膩",
	"腼": "靦",
	"腽": "膃",
	"腾": "騰",
	"膑": "臏",
	"臜": "臢",
	"舆": "輿",
	"舣": "艤",
	"舰": "艦",
	"舱": "艙",
	"舻": "艫",
	"艰": "艱",
	"艳": "艷",
	"艺": "藝",
	"节": "節",
	"芈": "羋",
	"芗": "薌",
	"芜": "蕪",
	"芦": "蘆",
	"苁": "蓯",
	"苇": "葦",
	"苈": "藶",
	"苋": "莧",
	"苌": "萇",
	"苍": "蒼",
	"苎": "苧",
	"茎": "莖",
	"茏": "蘢",
	"茑": "蔦",
	"茔": "塋",
	"茕": "煢",
	"茧": "繭",
	"荆": "荊",
	"荐": "薦",
	"荙": "薘",
	"荚": "莢",
	"荛": "蕘",
	"荜": "蓽",
	"荞": "蕎",
	"荟": "薈",
	"荠": "薺",
	"荡": "蕩",
	"荣": "榮",
	"荤": "葷",
	"荥": "滎",
	"荦": "犖",
	"荧": "熒",
	"荨": "蕁",
	"荩": "藎",
	"荪": "蓀",
	"荫": "蔭",
	"荬": "蕒",
	"荭": "葒",
	"荮": "葤",
	"莅": "蒞",
	"莱": "萊",
	"莲": "蓮",
	"莳": "蒔",
	"莴": "萵",
	"莶": "薟",
	"莸": "蕕",
	"莹": "瑩",
	"莺": "鶯",
	"萝": "蘿",
	"萤": "螢",
	"营": "營",
	"萦": "縈",
	"萧": "蕭",
	"萨": "薩",
	"葱": "蔥",
	"蒇": "蕆",
	"蒉": "蕢",
	"蒋": "蔣",
	"蒌": "蔞",
	"蓝": "藍",
	"蓟": "薊",
	"蓠": "蘺",
	"蓣": "蕷",
	"蓥": "鎣",
	"蓦": "驀",
	"蔂": "虆",
	"蔷": "薔",
	"蔹": "蘞",
	"蔺": "藺",
	"蔼": "藹",
	"蕰": "薀",
	"蕲": "蘄",
	"薮": "藪",
	"藓": "蘚",
	"蘖": "櫱",
	"虏": "虜",
	"虑": "慮",
	"虚": "虛",
	"虬": "虯",
	"虮": "蟣",
	"虽": "雖",
	"虾": "蝦",
	"虿": "蠆",
	"蚀": "蝕",
	"蚁": "蟻",
	"蚂": "螞",
	"蚕": "蠶",
	"蚬": "蜆",
	"蛊": "蠱",
	"蛎": "蠣",
	"蛏": "蟶",
	"蛮": "蠻",
	"蛰": "蟄",
	"蛱": "蛺",
	"蛲": "蟯",
	"蛳": "螄",
	"蛴": "蠐",
	"蜕": "蛻",
	"蜗": "蝸",
	"蝇": "蠅",
	"蝈": "蟈",
	"蝉": "蟬",
	"蝼": "螻",
	"蝾": "蠑",
	"螀": "螿",
	"螨": "蟎",
	"蟏": "蠨",
	"衅": "釁",
	"衔": "銜",
	"补": "補",
	"衬": "襯",
	"衮": "袞",
	"袄": "襖",
	"袅": "裊",
	"袆": "褘",
	"袜": "襪",
	"袭": "襲",
	"袯": "襏",
	"装": "裝",
	"裆": "襠",
	"裈": "褌",
	"裢": "褳",
	"裣": "襝",
	"裤": "褲",
	"裥": "襇",
	"褛": "褸",
	"褴": "襤",
	"见": "見",
	"观": "觀",
	"觃": "覎",
	"规": "規",
	"觅": "覓",
	"视": "視",
	"觇": "覘",
	"览": "覽",
	"觉": "覺",
	"觊": "覬",
	"觋": "覡",
	"觌": "覿",
	"觍": "覥",
	"觎": "覦",
	"觏": "覯",
	"觐": "覲",
	"觑": "覷",
	"觞": "觴",
	"触": "觸",
	"觯": "觶",
	"訚": "誾",
	"䜣": "訢",
	"誉": "譽",
	"誊": "謄",
	"讠": "訁",
	"计": "計",
	"订": "訂",
	"讣": "訃",
	"认": "認",
	"讥": "譏",
	"讦": "訐",
	"讧": "訌",
	"讨": "討",
	"让": "讓",
	"讪": "訕",
	"讫": "訖",
	"讬": "託",
	"训": "訓",
	"议": "議",
	"讯": "訊",
	"记": "記",
	"讱": "訒",
	"讲": "講",
	"讳": "諱",
	"讴": "謳",
	"讵": "詎",
	"讶": "訝",
	"讷": "訥",
	"许": "許",
	"讹": "訛",
	"论": "論",
	"讻": "訩",
	"讼": "訟",
	"讽": "諷",
	"设": "設",
	"访": "訪",
	"诀": "訣",
	"证": "證",
	"诂": "詁",
	"诃": "訶",
	"评": "評",
	"诅": "詛",
	"识": "識",
	"诇": "詗",
	"诈": "詐",
	"诉": "訴",
	"诊": "診",
	"诋": "詆",
	"诌": "謅",
	"词": "詞",
	"诎": "詘",
	"诏": "詔",
	"诐": "詖",
	"译": "譯",
	"诒": "詒",
	"诓": "誆",
	"诔": "誄",
	"试": "試",
	"诖": "詿",
	"诗": "詩",
	"诘": "詰",
	"诙": "詼",
	"诚": "誠",
	"诛": "誅",
	"诜": "詵",
	"话": "話",
	"诞": "誕",
	"诟": "詬",
	"诠": "詮",
	"诡": "詭",
	"询": "詢",
	"诣": "詣",
	"诤": "諍",
	"该": "該",
	"详": "詳",
	"诧": "詫",
	"诨": "諢",
	"诩": "詡",
	"诪": "譸",
	"诫": "誡",
	"诬": "誣",
	"语": "語",
	"诮": "誚",
	"误": "誤",
	"诰": "誥",
	"诱": "誘",
	"诲": "誨",
	"诳": "誑",
	"诵": "誦",
	"诶": "誒",
	"请": "請",
	"诸": "諸",
	"诹": "諏",
	"诺": "諾",
	"读": "讀",
	"诼": "諑",
	"诽": "誹",
	"课": "課",
	"诿": "諉",
	"谀": "諛",
	"谁": "誰",
	"谂": "諗",
	"调": "調",
	"谄": "諂",
	"谅": "諒",
	"谆": "諄",
	"谇": "誶",
	"谈": "談",
	"谊": "誼",
	"谋": "謀",
	"谌": "諶",
	"谍": "諜",
	"谎": "謊",
	"谏": "諫",
	"谐": "諧",
	"谑": "謔",
	"谒": "謁",
	"谓": "謂",
	"谔": "諤",
	"谕": "諭",
	"谖": "諼",
	"谗": "讒",
	"谘": "諮",
	"谙": "諳",
	"谚": "諺",
	"谛": "諦",
	"谜": "謎",
	"谝": "諞",
	"谞": "諝",
	"谟": "謨",
	"谠": "讜",
	"谡": "謖",
	"谢": "謝",
	"谤": "謗",
	"谥": "謚",
	"谦": "謙",
	"谧": "謐",
	"谨": "謹",
	"谩": "謾",
	"谪": "謫",
	"谬": "謬",
	"谭": "譚",
	"谮": "譖",
	"谯": "譙",
	"谰": "讕",
	"谱": "譜",
	"谲": "譎",
	"谳": "讞",
	"谴": "譴",
	"谵": "譫",
	"谶": "讖",
	"豮": "豶",
	"贝": "貝",
	"贞": "貞",
	"负": "負",
	"贠": "貟",
	"贡": "貢",
	"财": "財",
	"责": "責",
	"贤": "賢",
	"败": "敗",
	"账": "賬",
	"货": "貨",
	"质": "質",
	"贩": "販",
	"贪": "貪",
	"贫": "貧",
	"贬": "貶",
	"购": "購",
	"贮": "貯",
	"贯": "貫",
	"贰": "貳",
	"贱": "賤",
	"贲": "賁",
	"贳": "貰",
	"贴": "貼",
	"贵": "貴",
	"贶": "貺",
	"贷": "貸",
	"贸": "貿",
	"费": "費",
	"贺": "賀",
	"贻": "貽",
	"贼": "賊",
	"贽": "贄",
	"贾": "賈",
	"贿": "賄",
	"赀": "貲",
	"赁": "賃",
	"赂": "賂",
	"资": "資",
	"赅": "賅",
	"赆": "贐",
	"赇": "賕",
	"赈": "賑",
	"赉": "賚",
	"赊": "賒",
	"赋": "賦",
	"赌": "賭",
	"赎": "贖",
	"赏": "賞",
	"赐": "賜",
	"赑": "贔",
	"赒": "賙",
	"赓": "賡",
	"赔": "賠",
	"赕": "賧",
	"赖": "賴",
	"赗": "賵",
	"赘": "贅",
	"赙": "賻",
	"赚": "賺",
	"赛": "賽",
	"赜": "賾",
	"赞": "贊",
	"赟": "贇",
	"赠": "贈",
	"赡": "贍",
	"赢": "贏",
	"赣": "贛",
	"赪": "赬",
	"赵": "趙",
	"赶": "趕",
	"趋": "趨",
	"趱": "趲",
	"趸": "躉",
	"跃": "躍",
	"跄": "蹌",
	"跞": "躒",
	"践": "踐",
	"跶": "躂",
	"跷": "蹺",
	"跸": "蹕",
	"跹": "躚",
	"跻": "躋",
	"踊": "踴",
	"踌": "躊",
	"踪": "蹤",
	"踬": "躓",
	"踯": "躑",
	"蹑": "躡",
	"蹒": "蹣",
	"蹰": "躕",
	"蹿": "躥",
	"躏": "躪",
	"躜": "躦",
	"躯": "軀",
	"车": "車",
	"轧": "軋",
	"轨": "軌",
	"轩": "軒",
	"轪": "軑",
	"轫": "軔",
	"转": "轉",
	"轭": "軛",
	"轮": "輪",
	"软": "軟",
	"轰": "轟",
	"轱": "軲",
	"轲": "軻",
	"轳": "轤",
	"轴": "軸",
	"轵": "軹",
	"轶": "軼",
	"轷": "軤",
	"轸": "軫",
	"轹": "轢",
	"轺": "軺",
	"轻": "輕",
	"轼": "軾",
	"载": "載",
	"轾": "輊",
	"轿": "轎",
	"辀": "輈",
	"辁": "輇",
	"辂": "輅",
	"较": "較",
	"辄": "輒",
	"辅": "輔",
	"辆": "輛",
	"辇": "輦",
	"辈": "輩",
	"辉": "輝",
	"辊": "輥",
	"辋": "輞",
	"辌": "輬",
	"辍": "輟",
	"辎": "輜",
	"辏": "輳",
	"辐": "輻",
	"辑": "輯",
	"辒": "轀",
	"输": "輸",
	"辔": "轡",
	"辕": "轅",
	"辖": "轄",
	"辗": "輾",
	"辘": "轆",
	"辙": "轍",
	"辚": "轔",
	"辞": "辭",
	"辩": "辯",
	"辫": "辮",
	"边": "邊",
	"辽": "遼",
	"达": "達",
	"迁": "遷",
	"过": "過",
	"迈": "邁",
	"运": "運",
	"还": "還",
	"这": "這",
	"进": "進",
	"远": "遠",
	"违": "違",
	"连": "連",
	"迟": "遲",
	"迩": "邇",
	"迳": "逕",
	"迹": "跡",
	"选": "選",
	"逊": "遜",
	"递": "遞",
	"逦": "邐",
	"逻": "邏",
	"遗": "遺",
	"遥": "遙",
	"邓": "鄧",
	"邝": "鄺",
	"邬": "鄔",
	"邮": "郵",
	"邹": "鄒",
	"邺": "鄴",
	"邻": "鄰",
	"郏": "郟",
	"郐": "鄶",
	"郑": "鄭",
	"郓": "鄆",
	"郦": "酈",
	"郧": "鄖",
	"郸": "鄲",
	"酂": "酇",
	"酦": "醱",
	"酱": "醬",
	"酽": "釅",
	"酾": "釃",
	"酿": "釀",
	"释": "釋",
	"鉴": "鑒",
	"銮": "鑾",
	"錾": "鏨",
	"钅": "釒",
	"钆": "釓",
	"钇": "釔",
	"针": "針",
	"钉": "釘",
	"钊": "釗",
	"钋": "釙",
	"钌": "釕",
	"钍": "釷",
	"钎": "釺",
	"钏": "釧",
	"钐": "釤",
	"钑": "鈒",
	"钒": "釩",
	"钓": "釣",
	"钔": "鍆",
	"钕": "釹",
	"钖": "鍚",
	"钗": "釵",
	"钘": "鈃",
	"钙": "鈣",
	"钚": "鈈",
	"钛": "鈦",
	"钜": "鉅",
	"钝": "鈍",
	"钞": "鈔",
	"钠": "鈉",
	"钡": "鋇",
	"钢": "鋼",
	"钣": "鈑",
	"钤": "鈐",
	"钥": "鑰",
	"钦": "欽",
	"钧": "鈞",
	"钨": "鎢",
	"钪": "鈧",
	"钫": "鈁",
	"钬": "鈥",
	"钭": "鈄",
	"钮": "鈕",
	"钯": "鈀",
	"钰": "鈺",
	"钱": "錢",
	"钲": "鉦",
	"钳": "鉗",
	"钴": "鈷",
	"钶": "鈳",
	"钷": "鉕",
	"钸": "鈽",
	"钹": "鈸",
	"钺": "鉞",
	"钻": "鑽",
	"钼": "鉬",
	"钽": "鉭",
	"钾": "鉀",
	"钿": "鈿",
	"铀": "鈾",
	"铁": "鐵",
	"铂": "鉑",
	"铃": "鈴",
	"铄": "鑠",
	"铅": "鉛",
	"铆": "鉚",
	"铇": "鉋",
	"铈": "鈰",
	"铉": "鉉",
	"铊": "鉈",
	"铋": "鉍",
	"铌": "鈮",
	"铍": "鈹",
	"铎": "鐸",
	"铏": "鉶",
	"铐": "銬",
	"铑": "銠",
	"铒": "鉺",
	"铓": "鋩",
	"铔": "錏",
	"铕": "銪",
	"铖": "鋮",
	"铗": "鋏",
	"铘": "鋣",
	"铙": "鐃",
	"铚": "銍",
	"铛": "鐺",
	"铜": "銅",
	"铝": "鋁",
	"铞": "銱",
	"铟": "銦",
	"铠": "鎧",
	"铡": "鍘",
	"铢": "銖",
	"铣": "銑",
	"铤": "鋌",
	"铥": "銩",
	"铦": "銛",
	"铧": "鏵",
	"铨": "銓",
	"铩": "鎩",
	"铪": "鉿",
	"铫": "銚",
	"铬": "鉻",
	"铭": "銘",
	"铮": "錚",
	"铯": "銫",
	"铰": "鉸",
	"铱": "銥",
	"铲": "鏟",
	"铳": "銃",
	"铴": "鐋",
	"铵": "銨",
	"银": "銀",
	"铷": "銣",
	"铸": "鑄",
	"铹": "鐒",
	"铺": "鋪",
	"铻": "鋙",
	"铼": "錸",
	"铽": "鋱",
	"链": "鏈",
	"铿": "鏗",
	"销": "銷",
	"锁": "鎖",
	"锂": "鋰",
	"锃": "鋥",
	"锄": "鋤",
	"锅": "鍋",
	"锆": "鋯",
	"锇": "鋨",
	"锉": "銼",
	"锊": "鋝",
	"锋": "鋒",
	"锌": "鋅",
	"锍": "鋶",
	"锎": "鐦",
	"锏": "鐧",
	"锑": "銻",
	"锒": "鋃",
	"锓": "鋟",
	"锔": "鋦",
	"锕": "錒",
	"锖": "錆",
	"锗": "鍺",
	"锘": "鍩",
	"错": "錯",
	"锚": "錨",
	"锛": "錛",
	"锜": "錡",
	"锝": "鍀",
	"锞": "錁",
	"锟": "錕",
	"锠": "錩",
	"锡": "錫",
	"锢": "錮",
	"锣": "鑼",
	"锤": "錘",
	"锥": "錐",
	"锦": "錦",
	"锧": "鑕",
	"锩": "錈",
	"锪": "鍃",
	"锫": "錇",
	"锬": "錟",
	"锭": "錠",
	"键": "鍵",
	"锯": "鋸",
	"锰": "錳",
	"锱": "錙",
	"锲": "鍥",
	"锳": "鍈",
	"锴": "鍇",
	"锵": "鏘",
	"锶": "鍶",
	"锷": "鍔",
	"锸": "鍤",
	"锹": "鍬",
	"锺": "鍾",
	"锻": "鍛",
	"锼": "鎪",
	"锽": "鍠",
	"锾": "鍰",
	"锿": "鎄",
	"镀": "鍍",
	"镁": "鎂",
	"镂": "鏤",
	"镃": "鎡",
	"镄": "鐨",
	"镅": "鎇",
	"镆": "鏌",
	"镇": "鎮",
	"镈": "鎛",
	"镉": "鎘",
	"镊": "鑷",
	"镋": "鎲",
	"镍": "鎳",
	"镎": "鎿",
	"镏": "鎦",
	"镐": "鎬",
	"镑": "鎊",
	"镒": "鎰",
	"镓": "鎵",
	"镔": "鑌",
	"镕": "鎔",
	"镖": "鏢",
	"镗": "鏜",
	"镘": "鏝",
	"镙": "鏍",
	"镚": "鏰",
	"镛": "鏞",
	"镜": "鏡",
	"镝": "鏑",
	"镞": "鏃",
	"镟": "鏇",
	"镠": "鏐",
	"镡": "鐔",
	"镣": "鐐",
	"镤": "鏷",
	"镥": "鑥",
	"镦": "鐓",
	"镧": "鑭",
	"镨": "鐠",
	"镩": "鑹",
	"镪": "鏹",
	"镫": "鐙",
	"镬": "鑊",
	"镭": "鐳",
	"镮": "鐶",
	"镯": "鐲",
	"镰": "鐮",
	"镱": "鐿",
	"镲": "鑔",
	"镳": "鑣",
	"镴": "鑞",
	"镵": "鑱",
	"镶": "鑲",
	"长": "長",
	"门": "門",
	"闩": "閂",
	"闪": "閃",
	"闫": "閆",
	"闬": "閈",
	"闭": "閉",
	"问": "問",
	"闯": "闖",
	"闰": "閏",
	"闱": "闈",
	"闲": "閑",
	"闳": "閎",
	"间": "間",
	"闵": "閔",
	"闶": "閌",
	"闷": "悶",
	"闸": "閘",
	"闹": "鬧",
	"闺": "閨",
	"闻": "聞",
	"闼": "闥",
	"闽": "閩",
	"闾": "閭",
	"闿": "闓",
	"阀": "閥",
	"阁": "閣",
	"阂": "閡",
	"阃": "閫",
	"阄": "鬮",
	"阆": "閬",
	"阇": "闍",
	"阈": "閾",
	"阉": "閹",
	"阊": "閶",
	"阋": "鬩",
	"阌": "閿",
	"阍": "閽",
	"阎": "閻",
	"阏": "閼",
	"阐": "闡",
	"阑": "闌",
	"阒": "闃",
	"阓": "闠",
	"阔": "闊",
	"阕": "闋",
	"阖": "闔",
	"阗": "闐",
	"阘": "闒",
	"阙": "闕",
	"阚": "闞",
	"阛": "闤",
	"队": "隊",
	"阳": "陽",
	"阴": "陰",
	"阵": "陣",
	"阶": "階",
	"际": "際",
	"陆": "陸",
	"陇": "隴",
	"陈": "陳",
	"陉": "陘",
	"陕": "陝",
	"陧": "隉",
	"陨": "隕",
	"险": "險",
	"随": "隨",
	"隐": "隱",
	"隶": "隸",
	"隽": "雋",
	"难": "難",
	"雏": "雛",
	"雠": "讎",
	"雳": "靂",
	"雾": "霧",
	"霁": "霽",
	"霡": "霢",
	"霭": "靄",
	"靓": "靚",
	"静": "靜",
	"靥": "靨",
	"鞑": "韃",
	"鞒": "鞽",
	"鞯": "韉",
	"韦": "韋",
	"韧": "韌",
	"韨": "韍",
	"韩": "韓",
	"韪": "韙",
	"韫": "韞",
	"韬": "韜",
	"韵": "韻",
	"页": "頁",
	"顶": "頂",
	"顷": "頃",
	"顸": "頇",
	"项": "項",
	"顺": "順",
	"顼": "頊",
	"顽": "頑",
	"顾": "顧",
	"顿": "頓",
	"颀": "頎",
	"颁": "頒",
	"颂": "頌",
	"颃": "頏",
	"预": "預",
	"颅": "顱",
	"领": "領",
	"颇": "頗",
	"颈": "頸",
	"颉": "頡",
	"颊": "頰",
	"颋": "頲",
	"颌": "頜",
	"颍": "潁",
	"颎": "熲",
	"颏": "頦",
	"颐": "頤",
	"频": "頻",
	"颒": "頮",
	"颔": "頷",
	"颕": "頴",
	"颖": "穎",
	"颗": "顆",
	"题": "題",
	"颙": "顒",
	"颚": "顎",
	"颛": "顓",
	"额": "額",
	"颞": "顳",
	"颟": "顢",
	"颠": "顛",
	"颡": "顙",
	"颢": "顥",
	"颤": "顫",
	"颥": "顬",
	"颦": "顰",
	"颧": "顴",
	"风": "風",
	"飏": "颺",
	"飐": "颭",
	"飑": "颮",
	"飒": "颯",
	"飓": "颶",
	"飔": "颸",
	"飕": "颼",
	"飖": "颻",
	"飗": "飀",
	"飘": "飄",
	"飙": "飆",
	"飚": "飈",
	"飞": "飛",
	"飨": "饗",
	"餍": "饜",
	"饣": "飠",
	"饤": "飣",
	"饦": "飥",
	"饧": "餳",
	"饨": "飩",
	"饩": "餼",
	"饪": "飪",
	"饫": "飫",
	"饬": "飭",
	"饭": "飯",
	"饮": "飲",
	"饯": "餞",
	"饰": "飾",
	"饱": "飽",
	"饲": "飼",
	"饳": "飿",
	"饴": "飴",
	"饵": "餌",
	"饶": "饒",
	"饷": "餉",
	"饸": "餄",
	"饹": "餎",
	"饺": "餃",
	"饻": "餏",
	"饼": "餅",
	"饽": "餑",
	"饾": "餖",
	"饿": "餓",
	"馀": "餘",
	"馁": "餒",
	"馂": "餕",
	"馃": "餜",
	"馄": "餛",
	"馅": "餡",
	"馆": "館",
	"馇": "餷",
	"馈": "饋",
	"馉": "餶",
	"馊": "餿",
	"馋": "饞",
	"馌": "饁",
	"馍": "饃",
	"馎": "餺",
	"馏": "餾",
	"馐": "饈",
	"馑": "饉",
	"馒": "饅",
	"馓": "饊",
	"馔": "饌",
	"馕": "饢",
	"马": "馬",
	"驭": "馭",
	"驮": "馱",
	"驯": "馴",
	"驰": "馳",
	"驱": "驅",
	"驲": "馹",
	"驳": "駁",
	"驴": "驢",
	"驵": "駔",
	"驶": "駛",
	"驷": "駟",
	"驸": "駙",
	"驹": "駒",
	"驺": "騶",
	"驻": "駐",
	"驼": "駝",
	"驽": "駑",
	"驾": "駕",
	"驿": "驛",
	"骀": "駘",
	"骁": "驍",
	"骃": "駰",
	"骄": "驕",
	"骅": "驊",
	"骆": "駱",
	"骇": "駭",
	"骈": "駢",
	"骉": "驫",
	"骊": "驪",
	"骋": "騁",
	"验": "驗",
	"骍": "騂",
	"骎": "駸",
	"骏": "駿",
	"骐": "騏",
	"骑": "騎",
	"骒": "騍",
	"骓": "騅",
	"骔": "騌",
	"骕": "驌",
	"骖": "驂",
	"骗": "騙",
	"骘": "騭",
	"骙": "騤",
	"骚": "騷",
	"骛": "騖",
	"骜": "驁",
	"骝": "騮",
	"骞": "騫",
	"骟": "騸",
	"骠": "驃",
	"骡": "騾",
	"骢": "驄",
	"骣": "驏",
	"骤": "驟",
	"骥": "驥",
	"骦": "驦",
	"骧": "驤",
	"髅": "髏",
	"髋": "髖",
	"髌": "髕",
	"鬓": "鬢",
	"魇": "魘",
	"魉": "魎",
	"鱼": "魚",
	"鱽": "魛",
	"鱾": "魢",
	"鱿": "魷",
	"鲀": "魨",
	"鲁": "魯",
	"鲂": "魴",
	"鲃": "䰾",
	"鲄": "魺",
	"鲅": "鮁",
	"鲆": "鮃",
	"鲈": "鱸",
	"鲉": "鮋",
	"鲊": "鮓",
	"鲋": "鮒",
	"鲌": "鮊",
	"鲍": "鮑",
	"鲎": "鱟",
	"鲏": "鮍",
	"鲐": "鮐",
	"鲑": "鮭",
	"鲒": "鮚",
	"鲓": "鮳",
	"鲔": "鮪",
	"鲕": "鮞",
	"鲖": "鮦",
	"鲗": "鰂",
	"鲘": "鮜",
	"鲙": "鱠",
	"鲚": "鱭",
	"鲛": "鮫",
	"鲜": "鮮",
	"鲝": "鮺",
	"鲟": "鱘",
	"鲠": "鯁",
	"鲡": "鱺",
	"鲢": "鰱",
	"鲣": "鰹",
	"鲤": "鯉",
	"鲥": "鰣",
	"鲦": "鰷",
	"鲧": "鯀",
	"鲨": "鯊",
	"鲩": "鯇",
	"鲪": "鮶",
	"鲫": "鯽",
	"鲬": "鯒",
	"鲭": "鯖",
	"鲮": "鯪",
	"鲯": "鯕",
	"鲰": "鯫",
	"鲱": "鯡",
	"鲲": "鯤",
	"鲳": "鯧",
	"鲴": "鯝",
	"鲵": "鯢",
	"鲶": "鯰",
	"鲷": "鯛",
	"鲸": "鯨",
	"鲹": "鰺",
	"鲺": "鯴",
	"鲻": "鯔",
	"鲼": "鱝",
	"鲽": "鰈",
	"鲾": "鰏",
	"鲿": "鱨",
	"鳀": "鯷",
	"鳁": "鰮",
	"鳂": "鰃",
	"鳃": "鰓",
	"鳅": "鰍",
	"鳆": "鰒",
	"鳇": "鰉",
	"鳈": "鰁",
	"鳉": "鱂",
	"鳊": "鯿",
	"鳋": "鰠",
	"鳌": "鰲",
	"鳍": "鰭",
	"鳎": "鰨",
	"鳏": "鰥",
	"鳐": "鰩",
	"鳑": "鰟",
	"鳒": "鰜",
	"鳓": "鰳",
	"鳔": "鰾",
	"鳕": "鱈",
	"鳖": "鱉",
	"鳗": "鰻",
	"鳘": "鰵",
	"鳙": "鱅",
	"鳚": "䲁",
	"鳛": "鰼",
	"鳜": "鱖",
	"鳝": "鱔",
	"鳞": "鱗",
	"鳟": "鱒",
	"鳠": "鱯",
	"鳡": "鱤",
	"鳢": "鱧",
	"鳣": "鱣",
	"䴓": "鳾",
	"䴕": "鴷",
	"䴔": "鵁",
	"䴖": "鶄",
	"䴗": "鶪",
	"䴘": "鷈",
	"䴙": "鷿",
	"鸟": "鳥",
	"鸠": "鳩",
	"鸢": "鳶",
	"鸣": "鳴",
	"鸤": "鳲",
	"鸥": "鷗",
	"鸦": "鴉",
	"鸧": "鶬",
	"鸨": "鴇",
	"鸩": "鴆",
	"鸪": "鴣",
	"鸫": "鶇",
	"鸬": "鸕",
	"鸭": "鴨",
	"鸮": "鴞",
	"鸯": "鴦",
	"鸰": "鴒",
	"鸱": "鴟",
	"鸲": "鴝",
	"鸳": "鴛",
	"鸴": "鷽",
	"鸵": "鴕",
	"鸶": "鷥",
	"鸷": "鷙",
	"鸸": "鴯",
	"鸹": "鴰",
	"鸺": "鵂",
	"鸻": "鴴",
	"鸼": "鵃",
	"鸽": "鴿",
	"鸾": "鸞",
	"鸿": "鴻",
	"鹀": "鵐",
	"鹁": "鵓",
	"鹂": "鸝",
	"鹃": "鵑",
	"鹄": "鵠",
	"鹅": "鵝",
	"鹆": "鵒",
	"鹇": "鷳",
	"鹈": "鵜",
	"鹉": "鵡",
	"鹊": "鵲",
	"鹋": "鶓",
	"鹌": "鵪",
	"鹍": "鵾",
	"鹎": "鵯",
	"鹏": "鵬",
	"鹐": "鵮",
	"鹑": "鶉",
	"鹒": "鶊",
	"鹓": "鵷",
	"鹔": "鷫",
	"鹕": "鶘",
	"鹖": "鶡",
	"鹗": "鶚",
	"鹘": "鶻",
	"鹙": "鶖",
	"鹛": "鶥",
	"鹜": "鶩",
	"鹝": "鷊",
	"鹞": "鷂",
	"鹟": "鶲",
	"鹠": "鶹",
	"鹡": "鶺",
	"鹢": "鷁",
	"鹣": "鶼",
	"鹤": "鶴",
	"鹥": "鷖",
	"鹦": "鸚",
	"鹧": "鷓",
	"鹨": "鷚",
	"鹩": "鷯",
	"鹪": "鷦",
	"鹫": "鷲",
	"鹬": "鷸",
	"鹭": "鷺",
	"鹯": "鸇",
	"鹰": "鷹",
	"鹱": "鸌",
	"鹲": "鸏",
	"鹳": "鸛",
	"鹴": "鸘",
	"鹾": "鹺",
	"麦": "麥",
	"麸": "麩",
	"麽": "麼",
	"黄": "黃",
	"黉": "黌",
	"黡": "黶",
	"黩": "黷",
	"黪": "黲",
	"黾": "黽",
	"鼋": "黿",
	"鼍": "鼉",
	"鼗": "鞀",
	"鼹": "鼴",
	"齐": "齊",
	"齑": "齏",
	"齿": "齒",
	"龀": "齔",
	"龁": "齕",
	"龂": "齗",
	"龃": "齟",
	"龄": "齡",
	"龅": "齙",
	"龆": "齠",
	"龇": "齜",
	"龈": "齦",
	"龉": "齬",
	"龊": "齪",
	"龋": "齲",
	"龌": "齷",
	"龙": "龍",
	"龚": "龔",
	"龛": "龕",
	"龟": "龜",
};

/**
 * Wikipedia:繁简处理/繁简单字
 * https://zh.wikipedia.org/wiki/Wikipedia:%E7%B9%81%E7%AE%80%E5%A4%84%E7%90%86/%E7%B9%81%E7%AE%80%E5%8D%95%E5%AD%97
 */
export const wiki_t2s: ITable = {
	"䊷": "䌶",
	"𧩙": "䜥",
	"万": "万",
	"与": "与",
	"丑": "丑",
	"丟": "丢",
	"並": "并",
	"丰": "丰",
	"么": "么",
	"乾": "干",
	"亂": "乱",
	"于": "于",
	"云": "云",
	"亙": "亘",
	"亞": "亚",
	"仆": "仆",
	"价": "价",
	"伙": "伙",
	"佇": "伫",
	"佈": "布",
	"体": "体",
	"余": "馀",
	"佣": "佣",
	"併": "并",
	"來": "来",
	"侖": "仑",
	"侶": "侣",
	"俁": "俣",
	"係": "系",
	"俔": "伣",
	"俠": "侠",
	"倀": "伥",
	"倆": "俩",
	"倈": "俫",
	"倉": "仓",
	"個": "个",
	"們": "们",
	"倫": "伦",
	"偉": "伟",
	"側": "侧",
	"偵": "侦",
	"偽": "伪",
	"傑": "杰",
	"傖": "伧",
	"傘": "伞",
	"備": "备",
	"傢": "家",
	"傭": "佣",
	"傯": "偬",
	"傳": "传",
	"傴": "伛",
	"債": "债",
	"傷": "伤",
	"傾": "倾",
	"僂": "偻",
	"僅": "仅",
	"僉": "佥",
	"僑": "侨",
	"僕": "仆",
	"僞": "伪",
	"僥": "侥",
	"僨": "偾",
	"價": "价",
	"儀": "仪",
	"儂": "侬",
	"億": "亿",
	"儈": "侩",
	"儉": "俭",
	"儐": "傧",
	"儔": "俦",
	"儕": "侪",
	"儘": "尽",
	"償": "偿",
	"優": "优",
	"儲": "储",
	"儷": "俪",
	"儺": "傩",
	"儻": "傥",
	"儼": "俨",
	"儿": "儿",
	"兇": "凶",
	"兌": "兑",
	"兒": "儿",
	"兗": "兖",
	"党": "党",
	"內": "内",
	"兩": "两",
	"冊": "册",
	"冪": "幂",
	"准": "准",
	"凈": "净",
	"凍": "冻",
	"凜": "凛",
	"几": "几",
	"凭": "凭",
	"凱": "凯",
	"划": "划",
	"別": "别",
	"刪": "删",
	"剄": "刭",
	"則": "则",
	"剋": "克",
	"剎": "刹",
	"剗": "刬",
	"剛": "刚",
	"剝": "剥",
	"剮": "剐",
	"剴": "剀",
	"創": "创",
	"劃": "划",
	"劇": "剧",
	"劉": "刘",
	"劊": "刽",
	"劌": "刿",
	"劍": "剑",
	"劑": "剂",
	"勁": "劲",
	"動": "动",
	"務": "务",
	"勛": "勋",
	"勝": "胜",
	"勞": "劳",
	"勢": "势",
	"勩": "勚",
	"勱": "劢",
	"勵": "励",
	"勸": "劝",
	"勻": "匀",
	"匭": "匦",
	"匯": "汇",
	"匱": "匮",
	"區": "区",
	"協": "协",
	"卷": "卷",
	"卻": "却",
	"厂": "厂",
	"厙": "厍",
	"厠": "厕",
	"厭": "厌",
	"厲": "厉",
	"厴": "厣",
	"參": "参",
	"叄": "叁",
	"叢": "丛",
	"台": "台",
	"叶": "叶",
	"吁": "吁",
	"吊": "吊",
	"后": "后",
	"吒": "咤",
	"吳": "吴",
	"吶": "呐",
	"呂": "吕",
	"咸": "咸",
	"咼": "呙",
	"員": "员",
	"唄": "呗",
	"唚": "吣",
	"問": "问",
	"啓": "启",
	"啞": "哑",
	"啟": "启",
	"啢": "唡",
	"喎": "㖞",
	"喚": "唤",
	"喪": "丧",
	"喬": "乔",
	"單": "单",
	"喲": "哟",
	"嗆": "呛",
	"嗇": "啬",
	"嗊": "唝",
	"嗎": "吗",
	"嗚": "呜",
	"嗩": "唢",
	"嗶": "哔",
	"嘆": "叹",
	"嘍": "喽",
	"嘔": "呕",
	"嘖": "啧",
	"嘗": "尝",
	"嘜": "唛",
	"嘩": "哗",
	"嘮": "唠",
	"嘯": "啸",
	"嘰": "叽",
	"嘵": "哓",
	"嘸": "呒",
	"嘽": "啴",
	"噁": "恶",
	"噓": "嘘",
	"噝": "咝",
	"噠": "哒",
	"噥": "哝",
	"噦": "哕",
	"噯": "嗳",
	"噲": "哙",
	"噴": "喷",
	"噸": "吨",
	"噹": "当",
	"嚀": "咛",
	"嚇": "吓",
	"嚌": "哜",
	"嚕": "噜",
	"嚙": "啮",
	"嚥": "咽",
	"嚦": "呖",
	"嚨": "咙",
	"嚮": "向",
	"嚲": "亸",
	"嚳": "喾",
	"嚴": "严",
	"嚶": "嘤",
	"囀": "啭",
	"囁": "嗫",
	"囂": "嚣",
	"囅": "冁",
	"囈": "呓",
	"囌": "苏",
	"囑": "嘱",
	"囘": "回",
	"囪": "囱",
	"圇": "囵",
	"國": "国",
	"圍": "围",
	"園": "园",
	"圓": "圆",
	"圖": "图",
	"團": "团",
	"坏": "坏",
	"垵": "埯",
	"埡": "垭",
	"埰": "采",
	"執": "执",
	"堅": "坚",
	"堊": "垩",
	"堖": "垴",
	"堝": "埚",
	"堯": "尧",
	"報": "报",
	"場": "场",
	"塊": "块",
	"塋": "茔",
	"塏": "垲",
	"塒": "埘",
	"塗": "涂",
	"塚": "冢",
	"塢": "坞",
	"塤": "埙",
	"塵": "尘",
	"塹": "堑",
	"墊": "垫",
	"墜": "坠",
	"墮": "堕",
	"墳": "坟",
	"墻": "墙",
	"墾": "垦",
	"壇": "坛",
	"壈": "𡒄",
	"壋": "垱",
	"壓": "压",
	"壘": "垒",
	"壙": "圹",
	"壚": "垆",
	"壞": "坏",
	"壟": "垄",
	"壠": "垅",
	"壢": "坜",
	"壩": "坝",
	"壯": "壮",
	"壺": "壶",
	"壼": "壸",
	"壽": "寿",
	"夠": "够",
	"夢": "梦",
	"夾": "夹",
	"奐": "奂",
	"奧": "奥",
	"奩": "奁",
	"奪": "夺",
	"奬": "奖",
	"奮": "奋",
	"奼": "姹",
	"妝": "妆",
	"姍": "姗",
	"姦": "奸",
	"娛": "娱",
	"婁": "娄",
	"婦": "妇",
	"婭": "娅",
	"媧": "娲",
	"媯": "妫",
	"媼": "媪",
	"媽": "妈",
	"嫗": "妪",
	"嫵": "妩",
	"嫻": "娴",
	"嫿": "婳",
	"嬀": "妫",
	"嬈": "娆",
	"嬋": "婵",
	"嬌": "娇",
	"嬙": "嫱",
	"嬡": "嫒",
	"嬤": "嬷",
	"嬪": "嫔",
	"嬰": "婴",
	"嬸": "婶",
	"孌": "娈",
	"孫": "孙",
	"學": "学",
	"孿": "孪",
	"宁": "宁",
	"宮": "宫",
	"寢": "寝",
	"實": "实",
	"寧": "宁",
	"審": "审",
	"寫": "写",
	"寬": "宽",
	"寵": "宠",
	"寶": "宝",
	"將": "将",
	"專": "专",
	"尋": "寻",
	"對": "对",
	"導": "导",
	"尷": "尴",
	"屆": "届",
	"屍": "尸",
	"屓": "屃",
	"屜": "屉",
	"屢": "屡",
	"層": "层",
	"屨": "屦",
	"屬": "属",
	"岡": "冈",
	"峴": "岘",
	"島": "岛",
	"峽": "峡",
	"崍": "崃",
	"崗": "岗",
	"崢": "峥",
	"崬": "岽",
	"嵐": "岚",
	"嶁": "嵝",
	"嶄": "崭",
	"嶇": "岖",
	"嶔": "嵚",
	"嶗": "崂",
	"嶠": "峤",
	"嶢": "峣",
	"嶧": "峄",
	"嶮": "崄",
	"嶴": "岙",
	"嶸": "嵘",
	"嶺": "岭",
	"嶼": "屿",
	"嶽": "岳",
	"巋": "岿",
	"巒": "峦",
	"巔": "巅",
	"巰": "巯",
	"帘": "帘",
	"帥": "帅",
	"師": "师",
	"帳": "帐",
	"帶": "带",
	"幀": "帧",
	"幃": "帏",
	"幗": "帼",
	"幘": "帻",
	"幟": "帜",
	"幣": "币",
	"幫": "帮",
	"幬": "帱",
	"干": "干",
	"并": "并",
	"幹": "干",
	"幺": "么",
	"幾": "几",
	"广": "广",
	"庫": "库",
	"廁": "厕",
	"廂": "厢",
	"廄": "厩",
	"廈": "厦",
	"廚": "厨",
	"廝": "厮",
	"廟": "庙",
	"廠": "厂",
	"廡": "庑",
	"廢": "废",
	"廣": "广",
	"廩": "廪",
	"廬": "庐",
	"廳": "厅",
	"弒": "弑",
	"弳": "弪",
	"張": "张",
	"強": "强",
	"彆": "别",
	"彈": "弹",
	"彌": "弥",
	"彎": "弯",
	"彔": "录",
	"彙": "汇",
	"彞": "彝",
	"彥": "彦",
	"征": "征",
	"後": "后",
	"徑": "径",
	"從": "从",
	"徠": "徕",
	"復": "复",
	"徵": "征",
	"徹": "彻",
	"恆": "恒",
	"恥": "耻",
	"悅": "悦",
	"悞": "悮",
	"悵": "怅",
	"悶": "闷",
	"惡": "恶",
	"惱": "恼",
	"惲": "恽",
	"惻": "恻",
	"愛": "爱",
	"愜": "惬",
	"愨": "悫",
	"愴": "怆",
	"愷": "恺",
	"愾": "忾",
	"愿": "愿",
	"慄": "栗",
	"態": "态",
	"慍": "愠",
	"慘": "惨",
	"慚": "惭",
	"慟": "恸",
	"慣": "惯",
	"慤": "悫",
	"慪": "怄",
	"慫": "怂",
	"慮": "虑",
	"慳": "悭",
	"慶": "庆",
	"憂": "忧",
	"憊": "惫",
	"憐": "怜",
	"憑": "凭",
	"憒": "愦",
	"憚": "惮",
	"憤": "愤",
	"憫": "悯",
	"憮": "怃",
	"憲": "宪",
	"憶": "忆",
	"懇": "恳",
	"應": "应",
	"懌": "怿",
	"懍": "懔",
	"懞": "蒙",
	"懟": "怼",
	"懣": "懑",
	"懨": "恹",
	"懲": "惩",
	"懶": "懒",
	"懷": "怀",
	"懸": "悬",
	"懺": "忏",
	"懼": "惧",
	"懾": "慑",
	"戀": "恋",
	"戇": "戆",
	"戔": "戋",
	"戧": "戗",
	"戩": "戬",
	"戰": "战",
	"戱": "戯",
	"戲": "戏",
	"戶": "户",
	"担": "担",
	"拋": "抛",
	"拾": "十",
	"挩": "捝",
	"挾": "挟",
	"捨": "舍",
	"捫": "扪",
	"据": "据",
	"掃": "扫",
	"掄": "抡",
	"掗": "挜",
	"掙": "挣",
	"掛": "挂",
	"採": "采",
	"揀": "拣",
	"揚": "扬",
	"換": "换",
	"揮": "挥",
	"損": "损",
	"搖": "摇",
	"搗": "捣",
	"搵": "揾",
	"搶": "抢",
	"摑": "掴",
	"摜": "掼",
	"摟": "搂",
	"摯": "挚",
	"摳": "抠",
	"摶": "抟",
	"摺": "折",
	"摻": "掺",
	"撈": "捞",
	"撏": "挦",
	"撐": "撑",
	"撓": "挠",
	"撝": "㧑",
	"撟": "挢",
	"撣": "掸",
	"撥": "拨",
	"撫": "抚",
	"撲": "扑",
	"撳": "揿",
	"撻": "挞",
	"撾": "挝",
	"撿": "捡",
	"擁": "拥",
	"擄": "掳",
	"擇": "择",
	"擊": "击",
	"擋": "挡",
	"擓": "㧟",
	"擔": "担",
	"據": "据",
	"擠": "挤",
	"擬": "拟",
	"擯": "摈",
	"擰": "拧",
	"擱": "搁",
	"擲": "掷",
	"擴": "扩",
	"擷": "撷",
	"擺": "摆",
	"擻": "擞",
	"擼": "撸",
	"擾": "扰",
	"攄": "摅",
	"攆": "撵",
	"攏": "拢",
	"攔": "拦",
	"攖": "撄",
	"攙": "搀",
	"攛": "撺",
	"攜": "携",
	"攝": "摄",
	"攢": "攒",
	"攣": "挛",
	"攤": "摊",
	"攪": "搅",
	"攬": "揽",
	"敗": "败",
	"敘": "叙",
	"敵": "敌",
	"數": "数",
	"斂": "敛",
	"斃": "毙",
	"斕": "斓",
	"斗": "斗",
	"斬": "斩",
	"斷": "断",
	"於": "于",
	"時": "时",
	"晉": "晋",
	"晝": "昼",
	"暈": "晕",
	"暉": "晖",
	"暘": "旸",
	"暢": "畅",
	"暨": "及",
	"暫": "暂",
	"曄": "晔",
	"曆": "历",
	"曇": "昙",
	"曉": "晓",
	"曏": "向",
	"曖": "暧",
	"曠": "旷",
	"曨": "昽",
	"曬": "晒",
	"書": "书",
	"會": "会",
	"朧": "胧",
	"朮": "术",
	"東": "东",
	"杴": "锨",
	"极": "极",
	"柜": "柜",
	"柵": "栅",
	"桿": "杆",
	"梔": "栀",
	"梘": "枧",
	"條": "条",
	"梟": "枭",
	"梲": "棁",
	"棄": "弃",
	"棖": "枨",
	"棗": "枣",
	"棟": "栋",
	"棧": "栈",
	"棲": "栖",
	"棶": "梾",
	"椏": "桠",
	"楊": "杨",
	"楓": "枫",
	"楨": "桢",
	"業": "业",
	"極": "极",
	"榦": "干",
	"榪": "杩",
	"榮": "荣",
	"榲": "榅",
	"榿": "桤",
	"構": "构",
	"槍": "枪",
	"槤": "梿",
	"槧": "椠",
	"槨": "椁",
	"槳": "桨",
	"樁": "桩",
	"樂": "乐",
	"樅": "枞",
	"樓": "楼",
	"標": "标",
	"樞": "枢",
	"樣": "样",
	"樸": "朴",
	"樹": "树",
	"樺": "桦",
	"橈": "桡",
	"橋": "桥",
	"機": "机",
	"橢": "椭",
	"橫": "横",
	"檁": "檩",
	"檉": "柽",
	"檔": "档",
	"檜": "桧",
	"檟": "槚",
	"檢": "检",
	"檣": "樯",
	"檮": "梼",
	"檯": "台",
	"檳": "槟",
	"檸": "柠",
	"檻": "槛",
	"櫃": "柜",
	"櫓": "橹",
	"櫚": "榈",
	"櫛": "栉",
	"櫝": "椟",
	"櫞": "橼",
	"櫟": "栎",
	"櫥": "橱",
	"櫧": "槠",
	"櫨": "栌",
	"櫪": "枥",
	"櫫": "橥",
	"櫬": "榇",
	"櫱": "蘖",
	"櫳": "栊",
	"櫸": "榉",
	"櫻": "樱",
	"欄": "栏",
	"權": "权",
	"欏": "椤",
	"欒": "栾",
	"欖": "榄",
	"欞": "棂",
	"欽": "钦",
	"歐": "欧",
	"歟": "欤",
	"歡": "欢",
	"歲": "岁",
	"歷": "历",
	"歸": "归",
	"歿": "殁",
	"殘": "残",
	"殞": "殒",
	"殤": "殇",
	"殨": "㱮",
	"殫": "殚",
	"殮": "殓",
	"殯": "殡",
	"殲": "歼",
	"殺": "杀",
	"殻": "壳",
	"殼": "壳",
	"毀": "毁",
	"毆": "殴",
	"毿": "毵",
	"氂": "牦",
	"氈": "毡",
	"氌": "氇",
	"氣": "气",
	"氫": "氢",
	"氬": "氩",
	"氳": "氲",
	"汙": "污",
	"決": "决",
	"沈": "沉",
	"沒": "没",
	"沖": "冲",
	"況": "况",
	"洶": "汹",
	"浹": "浃",
	"涇": "泾",
	"涼": "凉",
	"淀": "淀",
	"淒": "凄",
	"淚": "泪",
	"淥": "渌",
	"淨": "净",
	"淩": "凌",
	"淪": "沦",
	"淵": "渊",
	"淶": "涞",
	"淺": "浅",
	"渙": "涣",
	"減": "减",
	"渦": "涡",
	"測": "测",
	"渾": "浑",
	"湊": "凑",
	"湞": "浈",
	"湯": "汤",
	"溈": "沩",
	"準": "准",
	"溝": "沟",
	"溫": "温",
	"滄": "沧",
	"滅": "灭",
	"滌": "涤",
	"滎": "荥",
	"滬": "沪",
	"滯": "滞",
	"滲": "渗",
	"滷": "卤",
	"滸": "浒",
	"滻": "浐",
	"滾": "滚",
	"滿": "满",
	"漁": "渔",
	"漚": "沤",
	"漢": "汉",
	"漣": "涟",
	"漬": "渍",
	"漲": "涨",
	"漵": "溆",
	"漸": "渐",
	"漿": "浆",
	"潁": "颍",
	"潑": "泼",
	"潔": "洁",
	"潙": "沩",
	"潛": "潜",
	"潤": "润",
	"潯": "浔",
	"潰": "溃",
	"潷": "滗",
	"潿": "涠",
	"澀": "涩",
	"澆": "浇",
	"澇": "涝",
	"澐": "沄",
	"澗": "涧",
	"澠": "渑",
	"澤": "泽",
	"澦": "滪",
	"澩": "泶",
	"澮": "浍",
	"澱": "淀",
	"濁": "浊",
	"濃": "浓",
	"濕": "湿",
	"濘": "泞",
	"濛": "蒙",
	"濟": "济",
	"濤": "涛",
	"濫": "滥",
	"濰": "潍",
	"濱": "滨",
	"濺": "溅",
	"濼": "泺",
	"濾": "滤",
	"瀅": "滢",
	"瀆": "渎",
	"瀉": "泻",
	"瀋": "沈",
	"瀏": "浏",
	"瀕": "濒",
	"瀘": "泸",
	"瀝": "沥",
	"瀟": "潇",
	"瀠": "潆",
	"瀦": "潴",
	"瀧": "泷",
	"瀨": "濑",
	"瀰": "弥",
	"瀲": "潋",
	"瀾": "澜",
	"灃": "沣",
	"灄": "滠",
	"灑": "洒",
	"灕": "漓",
	"灘": "滩",
	"灝": "灏",
	"灠": "漤",
	"灣": "湾",
	"灤": "滦",
	"灧": "滟",
	"災": "灾",
	"為": "为",
	"烏": "乌",
	"烴": "烃",
	"無": "无",
	"煉": "炼",
	"煒": "炜",
	"煙": "烟",
	"煢": "茕",
	"煥": "焕",
	"煩": "烦",
	"煬": "炀",
	"熅": "煴",
	"熒": "荧",
	"熗": "炝",
	"熱": "热",
	"熲": "颎",
	"熾": "炽",
	"燁": "烨",
	"燈": "灯",
	"燉": "炖",
	"燒": "烧",
	"燙": "烫",
	"燜": "焖",
	"營": "营",
	"燦": "灿",
	"燭": "烛",
	"燴": "烩",
	"燼": "烬",
	"燾": "焘",
	"爍": "烁",
	"爐": "炉",
	"爛": "烂",
	"爭": "争",
	"爲": "为",
	"爺": "爷",
	"爾": "尔",
	"牆": "墙",
	"牘": "牍",
	"牽": "牵",
	"犖": "荦",
	"犢": "犊",
	"犧": "牺",
	"狀": "状",
	"狹": "狭",
	"狽": "狈",
	"猙": "狰",
	"猶": "犹",
	"猻": "狲",
	"獁": "犸",
	"獄": "狱",
	"獅": "狮",
	"獎": "奖",
	"獨": "独",
	"獪": "狯",
	"獫": "猃",
	"獮": "狝",
	"獰": "狞",
	"獲": "获",
	"獵": "猎",
	"獷": "犷",
	"獸": "兽",
	"獺": "獭",
	"獻": "献",
	"獼": "猕",
	"玀": "猡",
	"現": "现",
	"琺": "珐",
	"琿": "珲",
	"瑋": "玮",
	"瑒": "玚",
	"瑣": "琐",
	"瑤": "瑶",
	"瑩": "莹",
	"瑪": "玛",
	"瑲": "玱",
	"璉": "琏",
	"璣": "玑",
	"璦": "瑷",
	"璫": "珰",
	"環": "环",
	"璽": "玺",
	"瓊": "琼",
	"瓏": "珑",
	"瓔": "璎",
	"瓚": "瓒",
	"甌": "瓯",
	"產": "产",
	"産": "产",
	"畝": "亩",
	"畢": "毕",
	"異": "异",
	"畵": "画",
	"當": "当",
	"疇": "畴",
	"疊": "叠",
	"痙": "痉",
	"痾": "疴",
	"瘂": "痖",
	"瘋": "疯",
	"瘍": "疡",
	"瘓": "痪",
	"瘞": "瘗",
	"瘡": "疮",
	"瘧": "疟",
	"瘮": "瘆",
	"瘲": "疭",
	"瘺": "瘘",
	"瘻": "瘘",
	"療": "疗",
	"癆": "痨",
	"癇": "痫",
	"癉": "瘅",
	"癘": "疠",
	"癟": "瘪",
	"癢": "痒",
	"癤": "疖",
	"癥": "症",
	"癧": "疬",
	"癩": "癞",
	"癬": "癣",
	"癭": "瘿",
	"癮": "瘾",
	"癰": "痈",
	"癱": "瘫",
	"癲": "癫",
	"發": "发",
	"皚": "皑",
	"皰": "疱",
	"皸": "皲",
	"皺": "皱",
	"盃": "杯",
	"盜": "盗",
	"盞": "盏",
	"盡": "尽",
	"監": "监",
	"盤": "盘",
	"盧": "卢",
	"眥": "眦",
	"眾": "众",
	"睏": "困",
	"睜": "睁",
	"睞": "睐",
	"瞘": "眍",
	"瞜": "䁖",
	"瞞": "瞒",
	"瞭": "了",
	"瞶": "瞆",
	"瞼": "睑",
	"矇": "蒙",
	"矓": "眬",
	"矚": "瞩",
	"矯": "矫",
	"硃": "朱",
	"硜": "硁",
	"硤": "硖",
	"硨": "砗",
	"确": "确",
	"硯": "砚",
	"碩": "硕",
	"碭": "砀",
	"碸": "砜",
	"確": "确",
	"碼": "码",
	"磑": "硙",
	"磚": "砖",
	"磣": "碜",
	"磧": "碛",
	"磯": "矶",
	"磽": "硗",
	"礆": "硷",
	"礎": "础",
	"礙": "碍",
	"礦": "矿",
	"礪": "砺",
	"礫": "砾",
	"礬": "矾",
	"礱": "砻",
	"祿": "禄",
	"禍": "祸",
	"禎": "祯",
	"禕": "祎",
	"禡": "祃",
	"禦": "御",
	"禪": "禅",
	"禮": "礼",
	"禰": "祢",
	"禱": "祷",
	"禿": "秃",
	"秈": "籼",
	"种": "种",
	"稅": "税",
	"稈": "秆",
	"稟": "禀",
	"種": "种",
	"稱": "称",
	"穀": "谷",
	"穌": "稣",
	"積": "积",
	"穎": "颖",
	"穠": "秾",
	"穡": "穑",
	"穢": "秽",
	"穩": "稳",
	"穫": "获",
	"穭": "稆",
	"窩": "窝",
	"窪": "洼",
	"窮": "穷",
	"窯": "窑",
	"窵": "窎",
	"窶": "窭",
	"窺": "窥",
	"竄": "窜",
	"竅": "窍",
	"竇": "窦",
	"竈": "灶",
	"竊": "窃",
	"竪": "竖",
	"競": "竞",
	"筆": "笔",
	"筍": "笋",
	"筑": "筑",
	"筧": "笕",
	"筴": "䇲",
	"箋": "笺",
	"箏": "筝",
	"節": "节",
	"範": "范",
	"築": "筑",
	"篋": "箧",
	"篔": "筼",
	"篤": "笃",
	"篩": "筛",
	"篳": "筚",
	"簀": "箦",
	"簍": "篓",
	"簞": "箪",
	"簡": "简",
	"簣": "篑",
	"簫": "箫",
	"簹": "筜",
	"簽": "签",
	"簾": "帘",
	"籃": "篮",
	"籌": "筹",
	"籖": "签",
	"籙": "箓",
	"籜": "箨",
	"籟": "籁",
	"籠": "笼",
	"籩": "笾",
	"籪": "簖",
	"籬": "篱",
	"籮": "箩",
	"粵": "粤",
	"糝": "糁",
	"糞": "粪",
	"糧": "粮",
	"糰": "团",
	"糲": "粝",
	"糴": "籴",
	"糶": "粜",
	"糹": "纟",
	"糾": "纠",
	"紀": "纪",
	"紂": "纣",
	"約": "约",
	"紅": "红",
	"紆": "纡",
	"紇": "纥",
	"紈": "纨",
	"紉": "纫",
	"紋": "纹",
	"納": "纳",
	"紐": "纽",
	"紓": "纾",
	"純": "纯",
	"紕": "纰",
	"紖": "纼",
	"紗": "纱",
	"紘": "纮",
	"紙": "纸",
	"級": "级",
	"紛": "纷",
	"紜": "纭",
	"紝": "纴",
	"紡": "纺",
	"紬": "䌷",
	"細": "细",
	"紱": "绂",
	"紲": "绁",
	"紳": "绅",
	"紵": "纻",
	"紹": "绍",
	"紺": "绀",
	"紼": "绋",
	"紿": "绐",
	"絀": "绌",
	"終": "终",
	"組": "组",
	"絅": "䌹",
	"絆": "绊",
	"絎": "绗",
	"結": "结",
	"絕": "绝",
	"絛": "绦",
	"絝": "绔",
	"絞": "绞",
	"絡": "络",
	"絢": "绚",
	"給": "给",
	"絨": "绒",
	"絰": "绖",
	"統": "统",
	"絲": "丝",
	"絳": "绛",
	"絶": "绝",
	"絹": "绢",
	"綁": "绑",
	"綃": "绡",
	"綆": "绠",
	"綈": "绨",
	"綉": "绣",
	"綌": "绤",
	"綏": "绥",
	"經": "经",
	"綜": "综",
	"綞": "缍",
	"綠": "绿",
	"綢": "绸",
	"綣": "绻",
	"綫": "线",
	"綬": "绶",
	"維": "维",
	"綯": "绹",
	"綰": "绾",
	"綱": "纲",
	"網": "网",
	"綳": "绷",
	"綴": "缀",
	"綸": "纶",
	"綹": "绺",
	"綺": "绮",
	"綻": "绽",
	"綽": "绰",
	"綾": "绫",
	"綿": "绵",
	"緄": "绲",
	"緇": "缁",
	"緊": "紧",
	"緋": "绯",
	"緑": "绿",
	"緒": "绪",
	"緓": "绬",
	"緔": "绱",
	"緗": "缃",
	"緘": "缄",
	"緙": "缂",
	"線": "线",
	"緝": "缉",
	"緞": "缎",
	"締": "缔",
	"緡": "缗",
	"緣": "缘",
	"緦": "缌",
	"編": "编",
	"緩": "缓",
	"緬": "缅",
	"緯": "纬",
	"緱": "缑",
	"緲": "缈",
	"練": "练",
	"緶": "缏",
	"緹": "缇",
	"緻": "致",
	"縈": "萦",
	"縉": "缙",
	"縊": "缢",
	"縋": "缒",
	"縐": "绉",
	"縑": "缣",
	"縕": "缊",
	"縗": "缞",
	"縛": "缚",
	"縝": "缜",
	"縞": "缟",
	"縟": "缛",
	"縣": "县",
	"縧": "绦",
	"縫": "缝",
	"縭": "缡",
	"縮": "缩",
	"縱": "纵",
	"縲": "缧",
	"縳": "䌸",
	"縴": "纤",
	"縵": "缦",
	"縶": "絷",
	"縷": "缕",
	"縹": "缥",
	"總": "总",
	"績": "绩",
	"繃": "绷",
	"繅": "缫",
	"繆": "缪",
	"繒": "缯",
	"織": "织",
	"繕": "缮",
	"繚": "缭",
	"繞": "绕",
	"繡": "绣",
	"繢": "缋",
	"繩": "绳",
	"繪": "绘",
	"繫": "系",
	"繭": "茧",
	"繮": "缰",
	"繯": "缳",
	"繰": "缲",
	"繳": "缴",
	"繸": "䍁",
	"繹": "绎",
	"繼": "继",
	"繽": "缤",
	"繾": "缱",
	"纈": "缬",
	"纊": "纩",
	"續": "续",
	"纍": "累",
	"纏": "缠",
	"纓": "缨",
	"纔": "才",
	"纖": "纤",
	"纘": "缵",
	"纜": "缆",
	"缽": "钵",
	"罈": "坛",
	"罌": "罂",
	"罰": "罚",
	"罵": "骂",
	"罷": "罢",
	"羅": "罗",
	"羆": "罴",
	"羈": "羁",
	"羋": "芈",
	"羥": "羟",
	"義": "义",
	"習": "习",
	"翹": "翘",
	"耬": "耧",
	"耮": "耢",
	"聖": "圣",
	"聞": "闻",
	"聯": "联",
	"聰": "聪",
	"聲": "声",
	"聳": "耸",
	"聵": "聩",
	"聶": "聂",
	"職": "职",
	"聹": "聍",
	"聽": "听",
	"聾": "聋",
	"肅": "肃",
	"胜": "胜",
	"脅": "胁",
	"脈": "脉",
	"脛": "胫",
	"脩": "修",
	"脫": "脱",
	"脹": "胀",
	"腊": "腊",
	"腎": "肾",
	"腖": "胨",
	"腡": "脶",
	"腦": "脑",
	"腫": "肿",
	"腳": "脚",
	"腸": "肠",
	"膃": "腽",
	"膚": "肤",
	"膠": "胶",
	"膩": "腻",
	"膽": "胆",
	"膾": "脍",
	"膿": "脓",
	"臉": "脸",
	"臍": "脐",
	"臏": "膑",
	"臘": "腊",
	"臚": "胪",
	"臟": "脏",
	"臠": "脔",
	"臢": "臜",
	"臥": "卧",
	"臨": "临",
	"臺": "台",
	"與": "与",
	"興": "兴",
	"舉": "举",
	"舊": "旧",
	"艙": "舱",
	"艤": "舣",
	"艦": "舰",
	"艫": "舻",
	"艱": "艰",
	"艷": "艳",
	"芻": "刍",
	"苎": "苧",
	"苧": "苎",
	"苹": "苹",
	"茲": "兹",
	"荊": "荆",
	"莊": "庄",
	"莖": "茎",
	"莢": "荚",
	"莧": "苋",
	"華": "华",
	"萇": "苌",
	"萊": "莱",
	"萬": "万",
	"萵": "莴",
	"葉": "叶",
	"葒": "荭",
	"著": "着",
	"葤": "荮",
	"葦": "苇",
	"葯": "药",
	"葷": "荤",
	"蒓": "莼",
	"蒔": "莳",
	"蒞": "莅",
	"蒼": "苍",
	"蓀": "荪",
	"蓋": "盖",
	"蓮": "莲",
	"蓯": "苁",
	"蓴": "莼",
	"蓽": "荜",
	"蔔": "卜",
	"蔞": "蒌",
	"蔣": "蒋",
	"蔥": "葱",
	"蔦": "茑",
	"蔭": "荫",
	"蕁": "荨",
	"蕆": "蒇",
	"蕎": "荞",
	"蕒": "荬",
	"蕓": "芸",
	"蕕": "莸",
	"蕘": "荛",
	"蕢": "蒉",
	"蕩": "荡",
	"蕪": "芜",
	"蕭": "萧",
	"蕷": "蓣",
	"薀": "蕰",
	"薈": "荟",
	"薊": "蓟",
	"薌": "芗",
	"薑": "姜",
	"薔": "蔷",
	"薘": "荙",
	"薟": "莶",
	"薦": "荐",
	"薩": "萨",
	"薴": "苧",
	"薺": "荠",
	"藉": "借",
	"藍": "蓝",
	"藎": "荩",
	"藝": "艺",
	"藥": "药",
	"藪": "薮",
	"藴": "蕴",
	"藶": "苈",
	"藹": "蔼",
	"藺": "蔺",
	"蘄": "蕲",
	"蘆": "芦",
	"蘇": "苏",
	"蘊": "蕴",
	"蘋": "苹",
	"蘚": "藓",
	"蘞": "蔹",
	"蘢": "茏",
	"蘭": "兰",
	"蘺": "蓠",
	"蘿": "萝",
	"虆": "蔂",
	"處": "处",
	"虛": "虚",
	"虜": "虏",
	"號": "号",
	"虧": "亏",
	"虫": "虫",
	"虯": "虬",
	"蛺": "蛱",
	"蛻": "蜕",
	"蜆": "蚬",
	"蜡": "蜡",
	"蝕": "蚀",
	"蝟": "猬",
	"蝦": "虾",
	"蝸": "蜗",
	"螄": "蛳",
	"螞": "蚂",
	"螢": "萤",
	"螻": "蝼",
	"螿": "螀",
	"蟄": "蛰",
	"蟈": "蝈",
	"蟎": "螨",
	"蟣": "虮",
	"蟬": "蝉",
	"蟯": "蛲",
	"蟲": "虫",
	"蟶": "蛏",
	"蟻": "蚁",
	"蠅": "蝇",
	"蠆": "虿",
	"蠐": "蛴",
	"蠑": "蝾",
	"蠟": "蜡",
	"蠣": "蛎",
	"蠨": "蟏",
	"蠱": "蛊",
	"蠶": "蚕",
	"蠻": "蛮",
	"衆": "众",
	"衊": "蔑",
	"術": "术",
	"衕": "同",
	"衚": "胡",
	"衛": "卫",
	"衝": "冲",
	"衹": "只",
	"袞": "衮",
	"裊": "袅",
	"裏": "里",
	"補": "补",
	"裝": "装",
	"裡": "里",
	"製": "制",
	"複": "复",
	"褌": "裈",
	"褘": "袆",
	"褲": "裤",
	"褳": "裢",
	"褸": "褛",
	"褻": "亵",
	"襇": "裥",
	"襏": "袯",
	"襖": "袄",
	"襝": "裣",
	"襠": "裆",
	"襤": "褴",
	"襪": "袜",
	"襯": "衬",
	"襲": "袭",
	"覆": "复",
	"見": "见",
	"覎": "觃",
	"規": "规",
	"覓": "觅",
	"視": "视",
	"覘": "觇",
	"覡": "觋",
	"覥": "觍",
	"覦": "觎",
	"親": "亲",
	"覬": "觊",
	"覯": "觏",
	"覲": "觐",
	"覷": "觑",
	"覺": "觉",
	"覽": "览",
	"覿": "觌",
	"觀": "观",
	"觴": "觞",
	"觶": "觯",
	"觸": "触",
	"訁": "讠",
	"訂": "订",
	"訃": "讣",
	"計": "计",
	"訊": "讯",
	"訌": "讧",
	"討": "讨",
	"訐": "讦",
	"訒": "讱",
	"訓": "训",
	"訕": "讪",
	"訖": "讫",
	"託": "讬",
	"記": "记",
	"訛": "讹",
	"訝": "讶",
	"訟": "讼",
	"訢": "䜣",
	"訣": "诀",
	"訥": "讷",
	"訩": "讻",
	"訪": "访",
	"設": "设",
	"許": "许",
	"訴": "诉",
	"訶": "诃",
	"診": "诊",
	"註": "注",
	"詁": "诂",
	"詆": "诋",
	"詎": "讵",
	"詐": "诈",
	"詒": "诒",
	"詔": "诏",
	"評": "评",
	"詖": "诐",
	"詗": "诇",
	"詘": "诎",
	"詛": "诅",
	"詞": "词",
	"詠": "咏",
	"詡": "诩",
	"詢": "询",
	"詣": "诣",
	"試": "试",
	"詩": "诗",
	"詫": "诧",
	"詬": "诟",
	"詭": "诡",
	"詮": "诠",
	"詰": "诘",
	"話": "话",
	"該": "该",
	"詳": "详",
	"詵": "诜",
	"詼": "诙",
	"詿": "诖",
	"誄": "诔",
	"誅": "诛",
	"誆": "诓",
	"誇": "夸",
	"誌": "志",
	"認": "认",
	"誑": "诳",
	"誒": "诶",
	"誕": "诞",
	"誘": "诱",
	"誚": "诮",
	"語": "语",
	"誠": "诚",
	"誡": "诫",
	"誣": "诬",
	"誤": "误",
	"誥": "诰",
	"誦": "诵",
	"誨": "诲",
	"說": "说",
	"説": "说",
	"誰": "谁",
	"課": "课",
	"誶": "谇",
	"誹": "诽",
	"誼": "谊",
	"誾": "訚",
	"調": "调",
	"諂": "谄",
	"諄": "谆",
	"談": "谈",
	"諉": "诿",
	"請": "请",
	"諍": "诤",
	"諏": "诹",
	"諑": "诼",
	"諒": "谅",
	"論": "论",
	"諗": "谂",
	"諛": "谀",
	"諜": "谍",
	"諝": "谞",
	"諞": "谝",
	"諢": "诨",
	"諤": "谔",
	"諦": "谛",
	"諧": "谐",
	"諫": "谏",
	"諭": "谕",
	"諮": "谘",
	"諱": "讳",
	"諳": "谙",
	"諶": "谌",
	"諷": "讽",
	"諸": "诸",
	"諺": "谚",
	"諼": "谖",
	"諾": "诺",
	"謀": "谋",
	"謁": "谒",
	"謂": "谓",
	"謄": "誊",
	"謅": "诌",
	"謊": "谎",
	"謎": "谜",
	"謐": "谧",
	"謔": "谑",
	"謖": "谡",
	"謗": "谤",
	"謙": "谦",
	"謚": "谥",
	"講": "讲",
	"謝": "谢",
	"謠": "谣",
	"謡": "谣",
	"謨": "谟",
	"謫": "谪",
	"謬": "谬",
	"謭": "谫",
	"謳": "讴",
	"謹": "谨",
	"謾": "谩",
	"證": "证",
	"譎": "谲",
	"譏": "讥",
	"譖": "谮",
	"識": "识",
	"譙": "谯",
	"譚": "谭",
	"譜": "谱",
	"譫": "谵",
	"譯": "译",
	"議": "议",
	"譴": "谴",
	"護": "护",
	"譸": "诪",
	"譽": "誉",
	"譾": "谫",
	"讀": "读",
	"變": "变",
	"讎": "雠",
	"讒": "谗",
	"讓": "让",
	"讕": "谰",
	"讖": "谶",
	"讜": "谠",
	"讞": "谳",
	"豈": "岂",
	"豎": "竖",
	"豐": "丰",
	"豬": "猪",
	"豶": "豮",
	"貓": "猫",
	"貝": "贝",
	"貞": "贞",
	"貟": "贠",
	"負": "负",
	"財": "财",
	"貢": "贡",
	"貧": "贫",
	"貨": "货",
	"販": "贩",
	"貪": "贪",
	"貫": "贯",
	"責": "责",
	"貯": "贮",
	"貰": "贳",
	"貲": "赀",
	"貳": "贰",
	"貴": "贵",
	"貶": "贬",
	"買": "买",
	"貸": "贷",
	"貺": "贶",
	"費": "费",
	"貼": "贴",
	"貽": "贻",
	"貿": "贸",
	"賀": "贺",
	"賁": "贲",
	"賂": "赂",
	"賃": "赁",
	"賄": "贿",
	"賅": "赅",
	"資": "资",
	"賈": "贾",
	"賊": "贼",
	"賑": "赈",
	"賒": "赊",
	"賓": "宾",
	"賕": "赇",
	"賙": "赒",
	"賚": "赉",
	"賜": "赐",
	"賞": "赏",
	"賠": "赔",
	"賡": "赓",
	"賢": "贤",
	"賣": "卖",
	"賤": "贱",
	"賦": "赋",
	"賧": "赕",
	"質": "质",
	"賫": "赍",
	"賬": "账",
	"賭": "赌",
	"賴": "赖",
	"賵": "赗",
	"賺": "赚",
	"賻": "赙",
	"購": "购",
	"賽": "赛",
	"賾": "赜",
	"贄": "贽",
	"贅": "赘",
	"贇": "赟",
	"贈": "赠",
	"贊": "赞",
	"贋": "赝",
	"贍": "赡",
	"贏": "赢",
	"贐": "赆",
	"贓": "赃",
	"贔": "赑",
	"贖": "赎",
	"贗": "赝",
	"贛": "赣",
	"贜": "赃",
	"赬": "赪",
	"趕": "赶",
	"趙": "赵",
	"趨": "趋",
	"趲": "趱",
	"跡": "迹",
	"踐": "践",
	"踴": "踊",
	"蹌": "跄",
	"蹕": "跸",
	"蹣": "蹒",
	"蹤": "踪",
	"蹺": "跷",
	"躂": "跶",
	"躉": "趸",
	"躊": "踌",
	"躋": "跻",
	"躍": "跃",
	"躑": "踯",
	"躒": "跞",
	"躓": "踬",
	"躕": "蹰",
	"躚": "跹",
	"躡": "蹑",
	"躥": "蹿",
	"躦": "躜",
	"躪": "躏",
	"軀": "躯",
	"車": "车",
	"軋": "轧",
	"軌": "轨",
	"軍": "军",
	"軑": "轪",
	"軒": "轩",
	"軔": "轫",
	"軛": "轭",
	"軟": "软",
	"軤": "轷",
	"軫": "轸",
	"軲": "轱",
	"軸": "轴",
	"軹": "轵",
	"軺": "轺",
	"軻": "轲",
	"軼": "轶",
	"軾": "轼",
	"較": "较",
	"輅": "辂",
	"輇": "辁",
	"輈": "辀",
	"載": "载",
	"輊": "轾",
	"輒": "辄",
	"輓": "挽",
	"輔": "辅",
	"輕": "轻",
	"輛": "辆",
	"輜": "辎",
	"輝": "辉",
	"輞": "辋",
	"輟": "辍",
	"輥": "辊",
	"輦": "辇",
	"輩": "辈",
	"輪": "轮",
	"輬": "辌",
	"輯": "辑",
	"輳": "辏",
	"輸": "输",
	"輻": "辐",
	"輾": "辗",
	"輿": "舆",
	"轀": "辒",
	"轂": "毂",
	"轄": "辖",
	"轅": "辕",
	"轆": "辘",
	"轉": "转",
	"轍": "辙",
	"轎": "轿",
	"轔": "辚",
	"轟": "轰",
	"轡": "辔",
	"轢": "轹",
	"轤": "轳",
	"辦": "办",
	"辭": "辞",
	"辮": "辫",
	"辯": "辩",
	"農": "农",
	"迴": "回",
	"适": "适",
	"逕": "迳",
	"這": "这",
	"連": "连",
	"週": "周",
	"進": "进",
	"遊": "游",
	"運": "运",
	"過": "过",
	"達": "达",
	"違": "违",
	"遙": "遥",
	"遜": "逊",
	"遞": "递",
	"遠": "远",
	"適": "适",
	"遲": "迟",
	"遷": "迁",
	"選": "选",
	"遺": "遗",
	"遼": "辽",
	"邁": "迈",
	"還": "还",
	"邇": "迩",
	"邊": "边",
	"邏": "逻",
	"邐": "逦",
	"郟": "郏",
	"郵": "邮",
	"鄆": "郓",
	"鄉": "乡",
	"鄒": "邹",
	"鄔": "邬",
	"鄖": "郧",
	"鄧": "邓",
	"鄭": "郑",
	"鄰": "邻",
	"鄲": "郸",
	"鄴": "邺",
	"鄶": "郐",
	"鄺": "邝",
	"酇": "酂",
	"酈": "郦",
	"醖": "酝",
	"醜": "丑",
	"醞": "酝",
	"醫": "医",
	"醬": "酱",
	"醱": "酦",
	"釀": "酿",
	"釁": "衅",
	"釃": "酾",
	"釅": "酽",
	"采": "采",
	"釋": "释",
	"釐": "厘",
	"釒": "钅",
	"釓": "钆",
	"釔": "钇",
	"釕": "钌",
	"釗": "钊",
	"釘": "钉",
	"釙": "钋",
	"針": "针",
	"釣": "钓",
	"釤": "钐",
	"釧": "钏",
	"釩": "钒",
	"釵": "钗",
	"釷": "钍",
	"釹": "钕",
	"釺": "钎",
	"鈀": "钯",
	"鈁": "钫",
	"鈃": "钘",
	"鈄": "钭",
	"鈈": "钚",
	"鈉": "钠",
	"鈍": "钝",
	"鈎": "钩",
	"鈐": "钤",
	"鈑": "钣",
	"鈒": "钑",
	"鈔": "钞",
	"鈕": "钮",
	"鈞": "钧",
	"鈣": "钙",
	"鈥": "钬",
	"鈦": "钛",
	"鈧": "钪",
	"鈮": "铌",
	"鈰": "铈",
	"鈳": "钶",
	"鈴": "铃",
	"鈷": "钴",
	"鈸": "钹",
	"鈹": "铍",
	"鈺": "钰",
	"鈽": "钸",
	"鈾": "铀",
	"鈿": "钿",
	"鉀": "钾",
	"鉅": "钜",
	"鉈": "铊",
	"鉉": "铉",
	"鉋": "铇",
	"鉍": "铋",
	"鉑": "铂",
	"鉕": "钷",
	"鉗": "钳",
	"鉚": "铆",
	"鉛": "铅",
	"鉞": "钺",
	"鉢": "钵",
	"鉤": "钩",
	"鉦": "钲",
	"鉬": "钼",
	"鉭": "钽",
	"鉶": "铏",
	"鉸": "铰",
	"鉺": "铒",
	"鉻": "铬",
	"鉿": "铪",
	"銀": "银",
	"銃": "铳",
	"銅": "铜",
	"銍": "铚",
	"銑": "铣",
	"銓": "铨",
	"銖": "铢",
	"銘": "铭",
	"銚": "铫",
	"銛": "铦",
	"銜": "衔",
	"銠": "铑",
	"銣": "铷",
	"銥": "铱",
	"銦": "铟",
	"銨": "铵",
	"銩": "铥",
	"銪": "铕",
	"銫": "铯",
	"銬": "铐",
	"銱": "铞",
	"銳": "锐",
	"銷": "销",
	"銹": "锈",
	"銻": "锑",
	"銼": "锉",
	"鋁": "铝",
	"鋃": "锒",
	"鋅": "锌",
	"鋇": "钡",
	"鋌": "铤",
	"鋏": "铗",
	"鋒": "锋",
	"鋙": "铻",
	"鋝": "锊",
	"鋟": "锓",
	"鋣": "铘",
	"鋤": "锄",
	"鋥": "锃",
	"鋦": "锔",
	"鋨": "锇",
	"鋩": "铓",
	"鋪": "铺",
	"鋭": "锐",
	"鋮": "铖",
	"鋯": "锆",
	"鋰": "锂",
	"鋱": "铽",
	"鋶": "锍",
	"鋸": "锯",
	"鋼": "钢",
	"錁": "锞",
	"錄": "录",
	"錆": "锖",
	"錇": "锫",
	"錈": "锩",
	"錏": "铔",
	"錐": "锥",
	"錒": "锕",
	"錕": "锟",
	"錘": "锤",
	"錙": "锱",
	"錚": "铮",
	"錛": "锛",
	"錟": "锬",
	"錠": "锭",
	"錡": "锜",
	"錢": "钱",
	"錦": "锦",
	"錨": "锚",
	"錩": "锠",
	"錫": "锡",
	"錮": "锢",
	"錯": "错",
	"録": "录",
	"錳": "锰",
	"錶": "表",
	"錸": "铼",
	"鍀": "锝",
	"鍁": "锨",
	"鍃": "锪",
	"鍆": "钔",
	"鍇": "锴",
	"鍈": "锳",
	"鍋": "锅",
	"鍍": "镀",
	"鍔": "锷",
	"鍘": "铡",
	"鍚": "钖",
	"鍛": "锻",
	"鍠": "锽",
	"鍤": "锸",
	"鍥": "锲",
	"鍩": "锘",
	"鍬": "锹",
	"鍰": "锾",
	"鍵": "键",
	"鍶": "锶",
	"鍺": "锗",
	"鎂": "镁",
	"鎄": "锿",
	"鎇": "镅",
	"鎊": "镑",
	"鎔": "镕",
	"鎖": "锁",
	"鎘": "镉",
	"鎛": "镈",
	"鎡": "镃",
	"鎢": "钨",
	"鎣": "蓥",
	"鎦": "镏",
	"鎧": "铠",
	"鎩": "铩",
	"鎪": "锼",
	"鎬": "镐",
	"鎮": "镇",
	"鎰": "镒",
	"鎲": "镋",
	"鎳": "镍",
	"鎵": "镓",
	"鎸": "镌",
	"鎿": "镎",
	"鏃": "镞",
	"鏇": "镟",
	"鏈": "链",
	"鏌": "镆",
	"鏍": "镙",
	"鏐": "镠",
	"鏑": "镝",
	"鏗": "铿",
	"鏘": "锵",
	"鏜": "镗",
	"鏝": "镘",
	"鏞": "镛",
	"鏟": "铲",
	"鏡": "镜",
	"鏢": "镖",
	"鏤": "镂",
	"鏨": "錾",
	"鏰": "镚",
	"鏵": "铧",
	"鏷": "镤",
	"鏹": "镪",
	"鏽": "锈",
	"鐃": "铙",
	"鐋": "铴",
	"鐐": "镣",
	"鐒": "铹",
	"鐓": "镦",
	"鐔": "镡",
	"鐘": "钟",
	"鐙": "镫",
	"鐝": "镢",
	"鐠": "镨",
	"鐦": "锎",
	"鐧": "锏",
	"鐨": "镄",
	"鐫": "镌",
	"鐮": "镰",
	"鐲": "镯",
	"鐳": "镭",
	"鐵": "铁",
	"鐶": "镮",
	"鐸": "铎",
	"鐺": "铛",
	"鐿": "镱",
	"鑄": "铸",
	"鑊": "镬",
	"鑌": "镔",
	"鑒": "鉴",
	"鑔": "镲",
	"鑕": "锧",
	"鑞": "镴",
	"鑠": "铄",
	"鑣": "镳",
	"鑥": "镥",
	"鑭": "镧",
	"鑰": "钥",
	"鑱": "镵",
	"鑲": "镶",
	"鑷": "镊",
	"鑹": "镩",
	"鑼": "锣",
	"鑽": "钻",
	"鑾": "銮",
	"鑿": "凿",
	"钁": "镢",
	"長": "长",
	"門": "门",
	"閂": "闩",
	"閃": "闪",
	"閆": "闫",
	"閈": "闬",
	"閉": "闭",
	"開": "开",
	"閌": "闶",
	"閎": "闳",
	"閏": "闰",
	"閑": "闲",
	"間": "间",
	"閔": "闵",
	"閘": "闸",
	"閡": "阂",
	"閣": "阁",
	"閤": "合",
	"閥": "阀",
	"閨": "闺",
	"閩": "闽",
	"閫": "阃",
	"閬": "阆",
	"閭": "闾",
	"閱": "阅",
	"閲": "阅",
	"閶": "阊",
	"閹": "阉",
	"閻": "阎",
	"閼": "阏",
	"閽": "阍",
	"閾": "阈",
	"閿": "阌",
	"闃": "阒",
	"闆": "板",
	"闇": "暗",
	"闈": "闱",
	"闊": "阔",
	"闋": "阕",
	"闌": "阑",
	"闍": "阇",
	"闐": "阗",
	"闒": "阘",
	"闓": "闿",
	"闔": "阖",
	"闕": "阙",
	"闖": "闯",
	"關": "关",
	"闞": "阚",
	"闠": "阓",
	"闡": "阐",
	"闢": "辟",
	"闤": "阛",
	"闥": "闼",
	"阪": "坂",
	"陘": "陉",
	"陝": "陕",
	"陣": "阵",
	"陰": "阴",
	"陳": "陈",
	"陸": "陆",
	"陽": "阳",
	"隉": "陧",
	"隊": "队",
	"階": "阶",
	"隕": "陨",
	"際": "际",
	"隨": "随",
	"險": "险",
	"隱": "隐",
	"隴": "陇",
	"隸": "隶",
	"隻": "只",
	"雋": "隽",
	"雖": "虽",
	"雙": "双",
	"雛": "雏",
	"雜": "杂",
	"雞": "鸡",
	"離": "离",
	"難": "难",
	"雲": "云",
	"電": "电",
	"霢": "霡",
	"霧": "雾",
	"霽": "霁",
	"靂": "雳",
	"靄": "霭",
	"靈": "灵",
	"靚": "靓",
	"靜": "静",
	"靦": "腼",
	"靨": "靥",
	"鞀": "鼗",
	"鞏": "巩",
	"鞝": "绱",
	"鞽": "鞒",
	"韁": "缰",
	"韃": "鞑",
	"韉": "鞯",
	"韋": "韦",
	"韌": "韧",
	"韍": "韨",
	"韓": "韩",
	"韙": "韪",
	"韜": "韬",
	"韞": "韫",
	"韻": "韵",
	"響": "响",
	"頁": "页",
	"頂": "顶",
	"頃": "顷",
	"項": "项",
	"順": "顺",
	"頇": "顸",
	"須": "须",
	"頊": "顼",
	"頌": "颂",
	"頎": "颀",
	"頏": "颃",
	"預": "预",
	"頑": "顽",
	"頒": "颁",
	"頓": "顿",
	"頗": "颇",
	"領": "领",
	"頜": "颌",
	"頡": "颉",
	"頤": "颐",
	"頦": "颏",
	"頭": "头",
	"頮": "颒",
	"頰": "颊",
	"頲": "颋",
	"頴": "颕",
	"頷": "颔",
	"頸": "颈",
	"頹": "颓",
	"頻": "频",
	"頽": "颓",
	"顆": "颗",
	"題": "题",
	"額": "额",
	"顎": "颚",
	"顏": "颜",
	"顒": "颙",
	"顓": "颛",
	"顔": "颜",
	"願": "愿",
	"顙": "颡",
	"顛": "颠",
	"類": "类",
	"顢": "颟",
	"顥": "颢",
	"顧": "顾",
	"顫": "颤",
	"顬": "颥",
	"顯": "显",
	"顰": "颦",
	"顱": "颅",
	"顳": "颞",
	"顴": "颧",
	"風": "风",
	"颭": "飐",
	"颮": "飑",
	"颯": "飒",
	"颱": "台",
	"颳": "刮",
	"颶": "飓",
	"颸": "飔",
	"颺": "飏",
	"颻": "飖",
	"颼": "飕",
	"飀": "飗",
	"飄": "飘",
	"飆": "飙",
	"飈": "飚",
	"飛": "飞",
	"飠": "饣",
	"飢": "饥",
	"飣": "饤",
	"飥": "饦",
	"飩": "饨",
	"飪": "饪",
	"飫": "饫",
	"飭": "饬",
	"飯": "饭",
	"飲": "饮",
	"飴": "饴",
	"飼": "饲",
	"飽": "饱",
	"飾": "饰",
	"飿": "饳",
	"餃": "饺",
	"餄": "饸",
	"餅": "饼",
	"餉": "饷",
	"養": "养",
	"餌": "饵",
	"餎": "饹",
	"餏": "饻",
	"餑": "饽",
	"餒": "馁",
	"餓": "饿",
	"餕": "馂",
	"餖": "饾",
	"餘": "余",
	"餚": "肴",
	"餛": "馄",
	"餜": "馃",
	"餞": "饯",
	"餡": "馅",
	"館": "馆",
	"餱": "糇",
	"餳": "饧",
	"餶": "馉",
	"餷": "馇",
	"餺": "馎",
	"餼": "饩",
	"餾": "馏",
	"餿": "馊",
	"饁": "馌",
	"饃": "馍",
	"饅": "馒",
	"饈": "馐",
	"饉": "馑",
	"饊": "馓",
	"饋": "馈",
	"饌": "馔",
	"饑": "饥",
	"饒": "饶",
	"饗": "飨",
	"饜": "餍",
	"饞": "馋",
	"饢": "馕",
	"馬": "马",
	"馭": "驭",
	"馮": "冯",
	"馱": "驮",
	"馳": "驰",
	"馴": "驯",
	"馹": "驲",
	"駁": "驳",
	"駐": "驻",
	"駑": "驽",
	"駒": "驹",
	"駔": "驵",
	"駕": "驾",
	"駘": "骀",
	"駙": "驸",
	"駛": "驶",
	"駝": "驼",
	"駟": "驷",
	"駡": "骂",
	"駢": "骈",
	"駭": "骇",
	"駰": "骃",
	"駱": "骆",
	"駸": "骎",
	"駿": "骏",
	"騁": "骋",
	"騂": "骍",
	"騅": "骓",
	"騌": "骔",
	"騍": "骒",
	"騎": "骑",
	"騏": "骐",
	"騖": "骛",
	"騙": "骗",
	"騤": "骙",
	"騫": "骞",
	"騭": "骘",
	"騮": "骝",
	"騰": "腾",
	"騶": "驺",
	"騷": "骚",
	"騸": "骟",
	"騾": "骡",
	"驀": "蓦",
	"驁": "骜",
	"驂": "骖",
	"驃": "骠",
	"驄": "骢",
	"驅": "驱",
	"驊": "骅",
	"驌": "骕",
	"驍": "骁",
	"驏": "骣",
	"驕": "骄",
	"驗": "验",
	"驚": "惊",
	"驛": "驿",
	"驟": "骤",
	"驢": "驴",
	"驤": "骧",
	"驥": "骥",
	"驦": "骦",
	"驪": "骊",
	"驫": "骉",
	"骯": "肮",
	"髏": "髅",
	"髒": "脏",
	"體": "体",
	"髕": "髌",
	"髖": "髋",
	"髮": "发",
	"鬆": "松",
	"鬍": "胡",
	"鬚": "须",
	"鬢": "鬓",
	"鬥": "斗",
	"鬧": "闹",
	"鬩": "阋",
	"鬮": "阄",
	"鬱": "郁",
	"魎": "魉",
	"魘": "魇",
	"魚": "鱼",
	"魛": "鱽",
	"魢": "鱾",
	"魨": "鲀",
	"魯": "鲁",
	"魴": "鲂",
	"魷": "鱿",
	"魺": "鲄",
	"鮁": "鲅",
	"鮃": "鲆",
	"鮊": "鲌",
	"鮋": "鲉",
	"鮍": "鲏",
	"鮎": "鲇",
	"鮐": "鲐",
	"鮑": "鲍",
	"鮒": "鲋",
	"鮓": "鲊",
	"鮚": "鲒",
	"鮜": "鲘",
	"鮝": "鲞",
	"鮞": "鲕",
	"鮦": "鲖",
	"鮪": "鲔",
	"鮫": "鲛",
	"鮭": "鲑",
	"鮮": "鲜",
	"鮳": "鲓",
	"鮶": "鲪",
	"鮺": "鲝",
	"鯀": "鲧",
	"鯁": "鲠",
	"鯇": "鲩",
	"鯉": "鲤",
	"鯊": "鲨",
	"鯒": "鲬",
	"鯔": "鲻",
	"鯕": "鲯",
	"鯖": "鲭",
	"鯗": "鲞",
	"鯛": "鲷",
	"鯝": "鲴",
	"鯡": "鲱",
	"鯢": "鲵",
	"鯤": "鲲",
	"鯧": "鲳",
	"鯨": "鲸",
	"鯪": "鲮",
	"鯫": "鲰",
	"鯴": "鲺",
	"鯷": "鳀",
	"鯽": "鲫",
	"鯿": "鳊",
	"鰁": "鳈",
	"鰂": "鲗",
	"鰃": "鳂",
	"鰈": "鲽",
	"鰉": "鳇",
	"鰍": "鳅",
	"鰏": "鲾",
	"鰐": "鳄",
	"鰒": "鳆",
	"鰓": "鳃",
	"鰜": "鳒",
	"鰟": "鳑",
	"鰠": "鳋",
	"鰣": "鲥",
	"鰥": "鳏",
	"鰨": "鳎",
	"鰩": "鳐",
	"鰭": "鳍",
	"鰮": "鳁",
	"鰱": "鲢",
	"鰲": "鳌",
	"鰳": "鳓",
	"鰵": "鳘",
	"鰷": "鲦",
	"鰹": "鲣",
	"鰺": "鲹",
	"鰻": "鳗",
	"鰼": "鳛",
	"鰾": "鳔",
	"鱂": "鳉",
	"鱅": "鳙",
	"鱈": "鳕",
	"鱉": "鳖",
	"鱒": "鳟",
	"鱔": "鳝",
	"鱖": "鳜",
	"鱗": "鳞",
	"鱘": "鲟",
	"鱝": "鲼",
	"鱟": "鲎",
	"鱠": "鲙",
	"鱣": "鳣",
	"鱤": "鳡",
	"鱧": "鳢",
	"鱨": "鲿",
	"鱭": "鲚",
	"鱯": "鳠",
	"鱷": "鳄",
	"鱸": "鲈",
	"鱺": "鲡",
	"䰾": "鲃",
	"䲁": "鳚",
	"鳥": "鸟",
	"鳧": "凫",
	"鳩": "鸠",
	"鳬": "凫",
	"鳲": "鸤",
	"鳳": "凤",
	"鳴": "鸣",
	"鳶": "鸢",
	"鳾": "䴓",
	"鴆": "鸩",
	"鴇": "鸨",
	"鴉": "鸦",
	"鴒": "鸰",
	"鴕": "鸵",
	"鴛": "鸳",
	"鴝": "鸲",
	"鴞": "鸮",
	"鴟": "鸱",
	"鴣": "鸪",
	"鴦": "鸯",
	"鴨": "鸭",
	"鴯": "鸸",
	"鴰": "鸹",
	"鴴": "鸻",
	"鴷": "䴕",
	"鴻": "鸿",
	"鴿": "鸽",
	"鵁": "䴔",
	"鵂": "鸺",
	"鵃": "鸼",
	"鵐": "鹀",
	"鵑": "鹃",
	"鵒": "鹆",
	"鵓": "鹁",
	"鵜": "鹈",
	"鵝": "鹅",
	"鵠": "鹄",
	"鵡": "鹉",
	"鵪": "鹌",
	"鵬": "鹏",
	"鵮": "鹐",
	"鵯": "鹎",
	"鵲": "鹊",
	"鵷": "鹓",
	"鵾": "鹍",
	"鶄": "䴖",
	"鶇": "鸫",
	"鶉": "鹑",
	"鶊": "鹒",
	"鶓": "鹋",
	"鶖": "鹙",
	"鶘": "鹕",
	"鶚": "鹗",
	"鶡": "鹖",
	"鶥": "鹛",
	"鶩": "鹜",
	"鶪": "䴗",
	"鶬": "鸧",
	"鶯": "莺",
	"鶲": "鹟",
	"鶴": "鹤",
	"鶹": "鹠",
	"鶺": "鹡",
	"鶻": "鹘",
	"鶼": "鹣",
	"鶿": "鹚",
	"鷀": "鹚",
	"鷁": "鹢",
	"鷂": "鹞",
	"鷄": "鸡",
	"鷈": "䴘",
	"鷊": "鹝",
	"鷓": "鹧",
	"鷖": "鹥",
	"鷗": "鸥",
	"鷙": "鸷",
	"鷚": "鹨",
	"鷥": "鸶",
	"鷦": "鹪",
	"鷫": "鹔",
	"鷯": "鹩",
	"鷲": "鹫",
	"鷳": "鹇",
	"鷸": "鹬",
	"鷹": "鹰",
	"鷺": "鹭",
	"鷽": "鸴",
	"鷿": "䴙",
	"鸇": "鹯",
	"鸌": "鹱",
	"鸏": "鹲",
	"鸕": "鸬",
	"鸘": "鹴",
	"鸚": "鹦",
	"鸛": "鹳",
	"鸝": "鹂",
	"鸞": "鸾",
	"鹵": "卤",
	"鹹": "咸",
	"鹺": "鹾",
	"鹽": "盐",
	"麗": "丽",
	"麥": "麦",
	"麩": "麸",
	"麪": "面",
	"麫": "面",
	"麯": "曲",
	"麵": "面",
	"麽": "么",
	"黃": "黄",
	"黌": "黉",
	"點": "点",
	"黨": "党",
	"黲": "黪",
	"黴": "霉",
	"黶": "黡",
	"黷": "黩",
	"黽": "黾",
	"黿": "鼋",
	"鼉": "鼍",
	"鼕": "冬",
	"鼴": "鼹",
	"齊": "齐",
	"齋": "斋",
	"齎": "赍",
	"齏": "齑",
	"齒": "齿",
	"齔": "龀",
	"齕": "龁",
	"齗": "龂",
	"齙": "龅",
	"齜": "龇",
	"齟": "龃",
	"齠": "龆",
	"齡": "龄",
	"齣": "出",
	"齦": "龈",
	"齪": "龊",
	"齬": "龉",
	"齲": "龋",
	"齶": "腭",
	"齷": "龌",
	"龍": "龙",
	"龎": "厐",
	"龐": "庞",
	"龔": "龚",
	"龕": "龛",
	"龜": "龟",
};

/**
 * Wikipedia:繁简处理/简繁单字
 * https://zh.wikipedia.org/wiki/Wikipedia:%E7%B9%81%E7%AE%80%E5%A4%84%E7%90%86/%E7%AE%80%E7%B9%81%E5%8D%95%E5%AD%97
 */
export const wiki_s2t_v2: ITable = {
	"䌶": "䊷",
	"䜥": "𧩙",
	"专": "專",
	"业": "業",
	"丛": "叢",
	"东": "東",
	"丝": "絲",
	"丢": "丟",
	"两": "兩",
	"严": "嚴",
	"丧": "喪",
	"个": "個",
	"临": "臨",
	"丽": "麗",
	"举": "舉",
	"义": "義",
	"乌": "烏",
	"乐": "樂",
	"乔": "喬",
	"习": "習",
	"乡": "鄉",
	"书": "書",
	"买": "買",
	"乱": "亂",
	"争": "爭",
	"亏": "虧",
	"亚": "亞",
	"亩": "畝",
	"亲": "親",
	"亵": "褻",
	"亸": "嚲",
	"亿": "億",
	"仅": "僅",
	"从": "從",
	"仑": "侖",
	"仓": "倉",
	"仪": "儀",
	"们": "們",
	"优": "優",
	"会": "會",
	"伛": "傴",
	"伞": "傘",
	"伟": "偉",
	"传": "傳",
	"伣": "俔",
	"伤": "傷",
	"伥": "倀",
	"伦": "倫",
	"伧": "傖",
	"伫": "佇",
	"佥": "僉",
	"侠": "俠",
	"侣": "侶",
	"侥": "僥",
	"侦": "偵",
	"侧": "側",
	"侨": "僑",
	"侩": "儈",
	"侪": "儕",
	"侬": "儂",
	"俣": "俁",
	"俦": "儔",
	"俨": "儼",
	"俩": "倆",
	"俪": "儷",
	"俫": "倈",
	"俭": "儉",
	"债": "債",
	"倾": "傾",
	"偬": "傯",
	"偻": "僂",
	"偾": "僨",
	"偿": "償",
	"傥": "儻",
	"傧": "儐",
	"储": "儲",
	"傩": "儺",
	"兑": "兌",
	"兖": "兗",
	"兰": "蘭",
	"关": "關",
	"兴": "興",
	"兹": "茲",
	"养": "養",
	"兽": "獸",
	"冁": "囅",
	"内": "內",
	"冈": "岡",
	"册": "冊",
	"写": "寫",
	"军": "軍",
	"农": "農",
	"冯": "馮",
	"决": "決",
	"况": "況",
	"冻": "凍",
	"净": "凈",
	"凉": "涼",
	"减": "減",
	"凑": "湊",
	"凛": "凜",
	"凤": "鳳",
	"凯": "凱",
	"击": "擊",
	"凿": "鑿",
	"刍": "芻",
	"刘": "劉",
	"则": "則",
	"刚": "剛",
	"创": "創",
	"删": "刪",
	"刬": "剗",
	"刭": "剄",
	"刹": "剎",
	"刽": "劊",
	"刿": "劌",
	"剀": "剴",
	"剂": "劑",
	"剐": "剮",
	"剑": "劍",
	"剥": "剝",
	"剧": "劇",
	"劝": "勸",
	"办": "辦",
	"务": "務",
	"劢": "勱",
	"动": "動",
	"励": "勵",
	"劲": "勁",
	"劳": "勞",
	"势": "勢",
	"勋": "勛",
	"勚": "勩",
	"匀": "勻",
	"匦": "匭",
	"匮": "匱",
	"区": "區",
	"医": "醫",
	"华": "華",
	"协": "協",
	"单": "單",
	"卖": "賣",
	"卢": "盧",
	"卫": "衛",
	"却": "卻",
	"厅": "廳",
	"厉": "厲",
	"压": "壓",
	"厌": "厭",
	"厍": "厙",
	"厐": "龎",
	"厘": "釐",
	"厢": "廂",
	"厣": "厴",
	"厦": "廈",
	"厨": "廚",
	"厩": "廄",
	"厮": "廝",
	"县": "縣",
	"叁": "叄",
	"参": "參",
	"双": "雙",
	"变": "變",
	"叙": "敘",
	"叠": "疊",
	"号": "號",
	"叹": "嘆",
	"叽": "嘰",
	"吓": "嚇",
	"吕": "呂",
	"吗": "嗎",
	"吣": "唚",
	"吨": "噸",
	"听": "聽",
	"吴": "吳",
	"呐": "吶",
	"呒": "嘸",
	"呓": "囈",
	"呕": "嘔",
	"呖": "嚦",
	"呗": "唄",
	"员": "員",
	"呙": "咼",
	"呛": "嗆",
	"呜": "嗚",
	"咏": "詠",
	"咙": "嚨",
	"咛": "嚀",
	"咝": "噝",
	"咤": "吒",
	"响": "響",
	"哑": "啞",
	"哒": "噠",
	"哓": "嘵",
	"哔": "嗶",
	"哕": "噦",
	"哗": "嘩",
	"哙": "噲",
	"哜": "嚌",
	"哝": "噥",
	"哟": "喲",
	"唛": "嘜",
	"唝": "嗊",
	"唠": "嘮",
	"唡": "啢",
	"唢": "嗩",
	"唤": "喚",
	"啧": "嘖",
	"啬": "嗇",
	"啭": "囀",
	"啮": "嚙",
	"啴": "嘽",
	"啸": "嘯",
	"㖞": "喎",
	"喷": "噴",
	"喽": "嘍",
	"喾": "嚳",
	"嗫": "囁",
	"嗳": "噯",
	"嘘": "噓",
	"嘤": "嚶",
	"嘱": "囑",
	"噜": "嚕",
	"嚣": "囂",
	"园": "園",
	"囱": "囪",
	"围": "圍",
	"囵": "圇",
	"国": "國",
	"图": "圖",
	"圆": "圓",
	"圣": "聖",
	"圹": "壙",
	"场": "場",
	"坂": "阪",
	"块": "塊",
	"坚": "堅",
	"坜": "壢",
	"坝": "壩",
	"坞": "塢",
	"坟": "墳",
	"坠": "墜",
	"垄": "壟",
	"垅": "壠",
	"垆": "壚",
	"垒": "壘",
	"垦": "墾",
	"垩": "堊",
	"垫": "墊",
	"垭": "埡",
	"垱": "壋",
	"垲": "塏",
	"垴": "堖",
	"埘": "塒",
	"埙": "塤",
	"埚": "堝",
	"埯": "垵",
	"堑": "塹",
	"堕": "墮",
	"𡒄": "壈",
	"壮": "壯",
	"声": "聲",
	"壶": "壺",
	"壸": "壼",
	"处": "處",
	"备": "備",
	"够": "夠",
	"头": "頭",
	"夹": "夾",
	"夺": "奪",
	"奁": "奩",
	"奂": "奐",
	"奋": "奮",
	"奥": "奧",
	"妆": "妝",
	"妇": "婦",
	"妈": "媽",
	"妩": "嫵",
	"妪": "嫗",
	"姗": "姍",
	"姹": "奼",
	"娄": "婁",
	"娅": "婭",
	"娆": "嬈",
	"娇": "嬌",
	"娈": "孌",
	"娱": "娛",
	"娲": "媧",
	"娴": "嫻",
	"婳": "嫿",
	"婴": "嬰",
	"婵": "嬋",
	"婶": "嬸",
	"媪": "媼",
	"嫒": "嬡",
	"嫔": "嬪",
	"嫱": "嬙",
	"嬷": "嬤",
	"孙": "孫",
	"学": "學",
	"孪": "孿",
	"宝": "寶",
	"实": "實",
	"宠": "寵",
	"审": "審",
	"宪": "憲",
	"宫": "宮",
	"宽": "寬",
	"宾": "賓",
	"寝": "寢",
	"对": "對",
	"寻": "尋",
	"导": "導",
	"寿": "壽",
	"将": "將",
	"尔": "爾",
	"尘": "塵",
	"尝": "嘗",
	"尧": "堯",
	"尴": "尷",
	"尸": "屍",
	"层": "層",
	"屃": "屓",
	"屉": "屜",
	"届": "屆",
	"属": "屬",
	"屡": "屢",
	"屦": "屨",
	"屿": "嶼",
	"岁": "歲",
	"岂": "豈",
	"岖": "嶇",
	"岗": "崗",
	"岘": "峴",
	"岙": "嶴",
	"岚": "嵐",
	"岛": "島",
	"岭": "嶺",
	"岽": "崬",
	"岿": "巋",
	"峄": "嶧",
	"峡": "峽",
	"峣": "嶢",
	"峤": "嶠",
	"峥": "崢",
	"峦": "巒",
	"崂": "嶗",
	"崃": "崍",
	"崄": "嶮",
	"崭": "嶄",
	"嵘": "嶸",
	"嵚": "嶔",
	"嵝": "嶁",
	"巅": "巔",
	"巩": "鞏",
	"巯": "巰",
	"币": "幣",
	"帅": "帥",
	"师": "師",
	"帏": "幃",
	"帐": "帳",
	"帜": "幟",
	"带": "帶",
	"帧": "幀",
	"帮": "幫",
	"帱": "幬",
	"帻": "幘",
	"帼": "幗",
	"幂": "冪",
	"幺": "么",
	"庄": "莊",
	"庆": "慶",
	"庐": "廬",
	"庑": "廡",
	"库": "庫",
	"应": "應",
	"庙": "廟",
	"庞": "龐",
	"废": "廢",
	"廪": "廩",
	"开": "開",
	"异": "異",
	"弃": "棄",
	"弑": "弒",
	"张": "張",
	"弪": "弳",
	"弯": "彎",
	"弹": "彈",
	"强": "強",
	"归": "歸",
	"彝": "彞",
	"彦": "彥",
	"彻": "徹",
	"径": "徑",
	"徕": "徠",
	"忆": "憶",
	"忏": "懺",
	"忧": "憂",
	"忾": "愾",
	"怀": "懷",
	"态": "態",
	"怂": "慫",
	"怃": "憮",
	"怄": "慪",
	"怅": "悵",
	"怆": "愴",
	"怜": "憐",
	"总": "總",
	"怼": "懟",
	"怿": "懌",
	"恋": "戀",
	"恒": "恆",
	"恳": "懇",
	"恸": "慟",
	"恹": "懨",
	"恺": "愷",
	"恻": "惻",
	"恼": "惱",
	"恽": "惲",
	"悦": "悅",
	"悬": "懸",
	"悭": "慳",
	"悮": "悞",
	"悯": "憫",
	"惊": "驚",
	"惧": "懼",
	"惨": "慘",
	"惩": "懲",
	"惫": "憊",
	"惬": "愜",
	"惭": "慚",
	"惮": "憚",
	"惯": "慣",
	"愠": "慍",
	"愤": "憤",
	"愦": "憒",
	"慑": "懾",
	"懑": "懣",
	"懒": "懶",
	"懔": "懍",
	"戆": "戇",
	"戋": "戔",
	"戏": "戲",
	"戗": "戧",
	"战": "戰",
	"戬": "戩",
	"戯": "戱",
	"户": "戶",
	"扑": "撲",
	"执": "執",
	"扩": "擴",
	"扪": "捫",
	"扫": "掃",
	"扬": "揚",
	"扰": "擾",
	"抚": "撫",
	"抛": "拋",
	"抟": "摶",
	"抠": "摳",
	"抡": "掄",
	"抢": "搶",
	"护": "護",
	"报": "報",
	"拟": "擬",
	"拢": "攏",
	"拣": "揀",
	"拥": "擁",
	"拦": "攔",
	"拧": "擰",
	"拨": "撥",
	"择": "擇",
	"挂": "掛",
	"挚": "摯",
	"挛": "攣",
	"挜": "掗",
	"挝": "撾",
	"挞": "撻",
	"挟": "挾",
	"挠": "撓",
	"挡": "擋",
	"挢": "撟",
	"挣": "掙",
	"挤": "擠",
	"挥": "揮",
	"挦": "撏",
	"挽": "輓",
	"捝": "挩",
	"捞": "撈",
	"损": "損",
	"捡": "撿",
	"换": "換",
	"捣": "搗",
	"掳": "擄",
	"掴": "摑",
	"掷": "擲",
	"掸": "撣",
	"掺": "摻",
	"掼": "摜",
	"揽": "攬",
	"揾": "搵",
	"揿": "撳",
	"搀": "攙",
	"搁": "擱",
	"搂": "摟",
	"搅": "攪",
	"携": "攜",
	"摄": "攝",
	"摅": "攄",
	"摆": "擺",
	"摇": "搖",
	"摈": "擯",
	"摊": "攤",
	"撄": "攖",
	"撑": "撐",
	"㧑": "撝",
	"撵": "攆",
	"撷": "擷",
	"撸": "擼",
	"撺": "攛",
	"㧟": "擓",
	"擞": "擻",
	"攒": "攢",
	"敌": "敵",
	"敛": "斂",
	"数": "數",
	"斋": "齋",
	"斓": "斕",
	"斩": "斬",
	"断": "斷",
	"无": "無",
	"旧": "舊",
	"时": "時",
	"旷": "曠",
	"旸": "暘",
	"昙": "曇",
	"昼": "晝",
	"昽": "曨",
	"显": "顯",
	"晋": "晉",
	"晒": "曬",
	"晓": "曉",
	"晔": "曄",
	"晕": "暈",
	"晖": "暉",
	"暂": "暫",
	"暧": "曖",
	"机": "機",
	"杀": "殺",
	"杂": "雜",
	"权": "權",
	"杆": "桿",
	"条": "條",
	"来": "來",
	"杨": "楊",
	"杩": "榪",
	"杰": "傑",
	"构": "構",
	"枞": "樅",
	"枢": "樞",
	"枣": "棗",
	"枥": "櫪",
	"枧": "梘",
	"枨": "棖",
	"枪": "槍",
	"枫": "楓",
	"枭": "梟",
	"柠": "檸",
	"柽": "檉",
	"栀": "梔",
	"栅": "柵",
	"标": "標",
	"栈": "棧",
	"栉": "櫛",
	"栊": "櫳",
	"栋": "棟",
	"栌": "櫨",
	"栎": "櫟",
	"栏": "欄",
	"树": "樹",
	"栖": "棲",
	"栗": "慄",
	"样": "樣",
	"栾": "欒",
	"桠": "椏",
	"桡": "橈",
	"桢": "楨",
	"档": "檔",
	"桤": "榿",
	"桥": "橋",
	"桦": "樺",
	"桧": "檜",
	"桨": "槳",
	"桩": "樁",
	"梦": "夢",
	"梼": "檮",
	"梾": "棶",
	"梿": "槤",
	"检": "檢",
	"棁": "梲",
	"棂": "欞",
	"椁": "槨",
	"椟": "櫝",
	"椠": "槧",
	"椤": "欏",
	"椭": "橢",
	"楼": "樓",
	"榄": "欖",
	"榅": "榲",
	"榇": "櫬",
	"榈": "櫚",
	"榉": "櫸",
	"槚": "檟",
	"槛": "檻",
	"槟": "檳",
	"槠": "櫧",
	"横": "橫",
	"樯": "檣",
	"樱": "櫻",
	"橥": "櫫",
	"橱": "櫥",
	"橹": "櫓",
	"橼": "櫞",
	"檩": "檁",
	"欢": "歡",
	"欤": "歟",
	"欧": "歐",
	"歼": "殲",
	"殁": "歿",
	"殇": "殤",
	"残": "殘",
	"殒": "殞",
	"殓": "殮",
	"殚": "殫",
	"殡": "殯",
	"㱮": "殨",
	"殴": "毆",
	"毁": "毀",
	"毂": "轂",
	"毕": "畢",
	"毙": "斃",
	"毡": "氈",
	"毵": "毿",
	"氇": "氌",
	"气": "氣",
	"氢": "氫",
	"氩": "氬",
	"氲": "氳",
	"汉": "漢",
	"汤": "湯",
	"汹": "洶",
	"沟": "溝",
	"没": "沒",
	"沣": "灃",
	"沤": "漚",
	"沥": "瀝",
	"沦": "淪",
	"沧": "滄",
	"沪": "滬",
	"泞": "濘",
	"泪": "淚",
	"泶": "澩",
	"泷": "瀧",
	"泸": "瀘",
	"泺": "濼",
	"泻": "瀉",
	"泼": "潑",
	"泽": "澤",
	"泾": "涇",
	"洁": "潔",
	"洒": "灑",
	"洼": "窪",
	"浃": "浹",
	"浅": "淺",
	"浆": "漿",
	"浇": "澆",
	"浈": "湞",
	"浊": "濁",
	"测": "測",
	"浍": "澮",
	"济": "濟",
	"浏": "瀏",
	"浐": "滻",
	"浑": "渾",
	"浒": "滸",
	"浓": "濃",
	"浔": "潯",
	"涛": "濤",
	"涝": "澇",
	"涞": "淶",
	"涟": "漣",
	"涠": "潿",
	"涡": "渦",
	"涣": "渙",
	"涤": "滌",
	"润": "潤",
	"涧": "澗",
	"涨": "漲",
	"涩": "澀",
	"渊": "淵",
	"渌": "淥",
	"渍": "漬",
	"渎": "瀆",
	"渐": "漸",
	"渑": "澠",
	"渔": "漁",
	"渖": "瀋",
	"渗": "滲",
	"温": "溫",
	"湾": "灣",
	"湿": "濕",
	"溃": "潰",
	"溅": "濺",
	"溆": "漵",
	"滗": "潷",
	"滚": "滾",
	"滞": "滯",
	"滟": "灧",
	"滠": "灄",
	"满": "滿",
	"滢": "瀅",
	"滤": "濾",
	"滥": "濫",
	"滦": "灤",
	"滨": "濱",
	"滩": "灘",
	"滪": "澦",
	"漤": "灠",
	"潆": "瀠",
	"潇": "瀟",
	"潋": "瀲",
	"潍": "濰",
	"潜": "潛",
	"潴": "瀦",
	"澜": "瀾",
	"濑": "瀨",
	"濒": "瀕",
	"灏": "灝",
	"灭": "滅",
	"灯": "燈",
	"灵": "靈",
	"灶": "竈",
	"灾": "災",
	"灿": "燦",
	"炀": "煬",
	"炉": "爐",
	"炖": "燉",
	"炜": "煒",
	"炝": "熗",
	"点": "點",
	"炼": "煉",
	"炽": "熾",
	"烁": "爍",
	"烂": "爛",
	"烃": "烴",
	"烛": "燭",
	"烟": "煙",
	"烦": "煩",
	"烧": "燒",
	"烨": "燁",
	"烩": "燴",
	"烫": "燙",
	"烬": "燼",
	"热": "熱",
	"焕": "煥",
	"焖": "燜",
	"焘": "燾",
	"煴": "熅",
	"爱": "愛",
	"爷": "爺",
	"牍": "牘",
	"牦": "氂",
	"牵": "牽",
	"牺": "犧",
	"犊": "犢",
	"状": "狀",
	"犷": "獷",
	"犸": "獁",
	"犹": "猶",
	"狈": "狽",
	"狝": "獮",
	"狞": "獰",
	"独": "獨",
	"狭": "狹",
	"狮": "獅",
	"狯": "獪",
	"狰": "猙",
	"狱": "獄",
	"狲": "猻",
	"猃": "獫",
	"猎": "獵",
	"猕": "獼",
	"猡": "玀",
	"猪": "豬",
	"猫": "貓",
	"猬": "蝟",
	"献": "獻",
	"獭": "獺",
	"玑": "璣",
	"玚": "瑒",
	"玛": "瑪",
	"玮": "瑋",
	"环": "環",
	"现": "現",
	"玱": "瑲",
	"玺": "璽",
	"珐": "琺",
	"珑": "瓏",
	"珰": "璫",
	"珲": "琿",
	"琏": "璉",
	"琐": "瑣",
	"琼": "瓊",
	"瑶": "瑤",
	"瑷": "璦",
	"璎": "瓔",
	"瓒": "瓚",
	"瓯": "甌",
	"电": "電",
	"画": "畫",
	"畅": "暢",
	"畴": "疇",
	"疖": "癤",
	"疗": "療",
	"疟": "瘧",
	"疠": "癘",
	"疡": "瘍",
	"疬": "癧",
	"疭": "瘲",
	"疮": "瘡",
	"疯": "瘋",
	"疱": "皰",
	"疴": "痾",
	"痈": "癰",
	"痉": "痙",
	"痒": "癢",
	"痖": "瘂",
	"痨": "癆",
	"痪": "瘓",
	"痫": "癇",
	"瘅": "癉",
	"瘆": "瘮",
	"瘗": "瘞",
	"瘪": "癟",
	"瘫": "癱",
	"瘾": "癮",
	"瘿": "癭",
	"癞": "癩",
	"癣": "癬",
	"癫": "癲",
	"皑": "皚",
	"皱": "皺",
	"皲": "皸",
	"盏": "盞",
	"盐": "鹽",
	"监": "監",
	"盖": "蓋",
	"盗": "盜",
	"盘": "盤",
	"眍": "瞘",
	"眦": "眥",
	"眬": "矓",
	"着": "著",
	"睁": "睜",
	"睐": "睞",
	"睑": "瞼",
	"瞆": "瞶",
	"瞒": "瞞",
	"䁖": "瞜",
	"瞩": "矚",
	"矫": "矯",
	"矶": "磯",
	"矾": "礬",
	"矿": "礦",
	"砀": "碭",
	"码": "碼",
	"砖": "磚",
	"砗": "硨",
	"砚": "硯",
	"砜": "碸",
	"砺": "礪",
	"砻": "礱",
	"砾": "礫",
	"础": "礎",
	"硁": "硜",
	"硕": "碩",
	"硖": "硤",
	"硗": "磽",
	"硙": "磑",
	"碍": "礙",
	"碛": "磧",
	"碜": "磣",
	"碱": "鹼",
	"礼": "禮",
	"祃": "禡",
	"祎": "禕",
	"祢": "禰",
	"祯": "禎",
	"祷": "禱",
	"祸": "禍",
	"禀": "稟",
	"禄": "祿",
	"禅": "禪",
	"离": "離",
	"秃": "禿",
	"秆": "稈",
	"积": "積",
	"称": "稱",
	"秽": "穢",
	"秾": "穠",
	"稆": "穭",
	"税": "稅",
	"稣": "穌",
	"稳": "穩",
	"穑": "穡",
	"穷": "窮",
	"窃": "竊",
	"窍": "竅",
	"窎": "窵",
	"窑": "窯",
	"窜": "竄",
	"窝": "窩",
	"窥": "窺",
	"窦": "竇",
	"窭": "窶",
	"竞": "競",
	"笃": "篤",
	"笋": "筍",
	"笔": "筆",
	"笕": "筧",
	"笺": "箋",
	"笼": "籠",
	"笾": "籩",
	"筚": "篳",
	"筛": "篩",
	"筜": "簹",
	"筝": "箏",
	"䇲": "筴",
	"筹": "籌",
	"筼": "篔",
	"简": "簡",
	"箓": "籙",
	"箦": "簀",
	"箧": "篋",
	"箨": "籜",
	"箩": "籮",
	"箪": "簞",
	"箫": "簫",
	"篑": "簣",
	"篓": "簍",
	"篮": "籃",
	"篱": "籬",
	"簖": "籪",
	"籁": "籟",
	"籴": "糴",
	"类": "類",
	"籼": "秈",
	"粜": "糶",
	"粝": "糲",
	"粤": "粵",
	"粪": "糞",
	"粮": "糧",
	"糁": "糝",
	"糇": "餱",
	"紧": "緊",
	"䌷": "紬",
	"䌹": "絅",
	"絷": "縶",
	"䌸": "縳",
	"䍁": "繸",
	"纟": "糹",
	"纠": "糾",
	"纡": "紆",
	"红": "紅",
	"纣": "紂",
	"纥": "紇",
	"约": "約",
	"级": "級",
	"纨": "紈",
	"纩": "纊",
	"纪": "紀",
	"纫": "紉",
	"纬": "緯",
	"纭": "紜",
	"纮": "紘",
	"纯": "純",
	"纰": "紕",
	"纱": "紗",
	"纲": "綱",
	"纳": "納",
	"纴": "紝",
	"纵": "縱",
	"纶": "綸",
	"纷": "紛",
	"纸": "紙",
	"纹": "紋",
	"纺": "紡",
	"纻": "紵",
	"纼": "紖",
	"纽": "紐",
	"纾": "紓",
	"绀": "紺",
	"绁": "紲",
	"绂": "紱",
	"练": "練",
	"组": "組",
	"绅": "紳",
	"细": "細",
	"织": "織",
	"终": "終",
	"绉": "縐",
	"绊": "絆",
	"绋": "紼",
	"绌": "絀",
	"绍": "紹",
	"绎": "繹",
	"经": "經",
	"绐": "紿",
	"绑": "綁",
	"绒": "絨",
	"结": "結",
	"绔": "絝",
	"绕": "繞",
	"绖": "絰",
	"绗": "絎",
	"绘": "繪",
	"给": "給",
	"绚": "絢",
	"绛": "絳",
	"络": "絡",
	"绞": "絞",
	"统": "統",
	"绠": "綆",
	"绡": "綃",
	"绢": "絹",
	"绤": "綌",
	"绥": "綏",
	"继": "繼",
	"绨": "綈",
	"绩": "績",
	"绪": "緒",
	"绫": "綾",
	"绬": "緓",
	"续": "續",
	"绮": "綺",
	"绯": "緋",
	"绰": "綽",
	"绲": "緄",
	"绳": "繩",
	"维": "維",
	"绵": "綿",
	"绶": "綬",
	"绸": "綢",
	"绹": "綯",
	"绺": "綹",
	"绻": "綣",
	"综": "綜",
	"绽": "綻",
	"绾": "綰",
	"缀": "綴",
	"缁": "緇",
	"缂": "緙",
	"缃": "緗",
	"缄": "緘",
	"缅": "緬",
	"缆": "纜",
	"缇": "緹",
	"缈": "緲",
	"缉": "緝",
	"缊": "縕",
	"缋": "繢",
	"缌": "緦",
	"缍": "綞",
	"缎": "緞",
	"缏": "緶",
	"缑": "緱",
	"缒": "縋",
	"缓": "緩",
	"缔": "締",
	"缕": "縷",
	"编": "編",
	"缗": "緡",
	"缘": "緣",
	"缙": "縉",
	"缚": "縛",
	"缛": "縟",
	"缜": "縝",
	"缝": "縫",
	"缞": "縗",
	"缟": "縞",
	"缠": "纏",
	"缡": "縭",
	"缢": "縊",
	"缣": "縑",
	"缤": "繽",
	"缥": "縹",
	"缦": "縵",
	"缧": "縲",
	"缨": "纓",
	"缩": "縮",
	"缪": "繆",
	"缫": "繅",
	"缬": "纈",
	"缭": "繚",
	"缮": "繕",
	"缯": "繒",
	"缱": "繾",
	"缲": "繰",
	"缳": "繯",
	"缴": "繳",
	"缵": "纘",
	"罂": "罌",
	"网": "網",
	"罗": "羅",
	"罚": "罰",
	"罢": "罷",
	"罴": "羆",
	"羁": "羈",
	"羟": "羥",
	"翘": "翹",
	"耢": "耮",
	"耧": "耬",
	"耸": "聳",
	"耻": "恥",
	"聂": "聶",
	"聋": "聾",
	"职": "職",
	"聍": "聹",
	"联": "聯",
	"聩": "聵",
	"聪": "聰",
	"肃": "肅",
	"肠": "腸",
	"肤": "膚",
	"肮": "骯",
	"肴": "餚",
	"肾": "腎",
	"肿": "腫",
	"胀": "脹",
	"胁": "脅",
	"胆": "膽",
	"胧": "朧",
	"胨": "腖",
	"胪": "臚",
	"胫": "脛",
	"胶": "膠",
	"脉": "脈",
	"脍": "膾",
	"脐": "臍",
	"脑": "腦",
	"脓": "膿",
	"脔": "臠",
	"脚": "腳",
	"脱": "脫",
	"脶": "腡",
	"脸": "臉",
	"腭": "齶",
	"腻": "膩",
	"腼": "靦",
	"腽": "膃",
	"腾": "騰",
	"膑": "臏",
	"臜": "臢",
	"舆": "輿",
	"舣": "艤",
	"舰": "艦",
	"舱": "艙",
	"舻": "艫",
	"艰": "艱",
	"艳": "艷",
	"艺": "藝",
	"节": "節",
	"芈": "羋",
	"芗": "薌",
	"芜": "蕪",
	"芦": "蘆",
	"苁": "蓯",
	"苇": "葦",
	"苈": "藶",
	"苋": "莧",
	"苌": "萇",
	"苍": "蒼",
	"苎": "苧",
	"茎": "莖",
	"茏": "蘢",
	"茑": "蔦",
	"茔": "塋",
	"茕": "煢",
	"茧": "繭",
	"荆": "荊",
	"荐": "薦",
	"荙": "薘",
	"荚": "莢",
	"荛": "蕘",
	"荜": "蓽",
	"荞": "蕎",
	"荟": "薈",
	"荠": "薺",
	"荡": "蕩",
	"荣": "榮",
	"荤": "葷",
	"荥": "滎",
	"荦": "犖",
	"荧": "熒",
	"荨": "蕁",
	"荩": "藎",
	"荪": "蓀",
	"荫": "蔭",
	"荬": "蕒",
	"荭": "葒",
	"荮": "葤",
	"莅": "蒞",
	"莱": "萊",
	"莲": "蓮",
	"莳": "蒔",
	"莴": "萵",
	"莶": "薟",
	"莸": "蕕",
	"莹": "瑩",
	"莺": "鶯",
	"萝": "蘿",
	"萤": "螢",
	"营": "營",
	"萦": "縈",
	"萧": "蕭",
	"萨": "薩",
	"葱": "蔥",
	"蒇": "蕆",
	"蒉": "蕢",
	"蒋": "蔣",
	"蒌": "蔞",
	"蓝": "藍",
	"蓟": "薊",
	"蓠": "蘺",
	"蓣": "蕷",
	"蓥": "鎣",
	"蓦": "驀",
	"蔂": "虆",
	"蔷": "薔",
	"蔹": "蘞",
	"蔺": "藺",
	"蔼": "藹",
	"蕰": "薀",
	"蕲": "蘄",
	"薮": "藪",
	"藓": "蘚",
	"蘖": "櫱",
	"虏": "虜",
	"虑": "慮",
	"虚": "虛",
	"虬": "虯",
	"虮": "蟣",
	"虽": "雖",
	"虾": "蝦",
	"虿": "蠆",
	"蚀": "蝕",
	"蚁": "蟻",
	"蚂": "螞",
	"蚕": "蠶",
	"蚬": "蜆",
	"蛊": "蠱",
	"蛎": "蠣",
	"蛏": "蟶",
	"蛮": "蠻",
	"蛰": "蟄",
	"蛱": "蛺",
	"蛲": "蟯",
	"蛳": "螄",
	"蛴": "蠐",
	"蜕": "蛻",
	"蜗": "蝸",
	"蝇": "蠅",
	"蝈": "蟈",
	"蝉": "蟬",
	"蝼": "螻",
	"蝾": "蠑",
	"螀": "螿",
	"螨": "蟎",
	"蟏": "蠨",
	"衅": "釁",
	"衔": "銜",
	"补": "補",
	"衬": "襯",
	"衮": "袞",
	"袄": "襖",
	"袅": "裊",
	"袆": "褘",
	"袜": "襪",
	"袭": "襲",
	"袯": "襏",
	"装": "裝",
	"裆": "襠",
	"裈": "褌",
	"裢": "褳",
	"裣": "襝",
	"裤": "褲",
	"裥": "襇",
	"褛": "褸",
	"褴": "襤",
	"见": "見",
	"观": "觀",
	"觃": "覎",
	"规": "規",
	"觅": "覓",
	"视": "視",
	"觇": "覘",
	"览": "覽",
	"觉": "覺",
	"觊": "覬",
	"觋": "覡",
	"觌": "覿",
	"觍": "覥",
	"觎": "覦",
	"觏": "覯",
	"觐": "覲",
	"觑": "覷",
	"觞": "觴",
	"触": "觸",
	"觯": "觶",
	"訚": "誾",
	"䜣": "訢",
	"誉": "譽",
	"誊": "謄",
	"讠": "訁",
	"计": "計",
	"订": "訂",
	"讣": "訃",
	"认": "認",
	"讥": "譏",
	"讦": "訐",
	"讧": "訌",
	"讨": "討",
	"让": "讓",
	"讪": "訕",
	"讫": "訖",
	"讬": "託",
	"训": "訓",
	"议": "議",
	"讯": "訊",
	"记": "記",
	"讱": "訒",
	"讲": "講",
	"讳": "諱",
	"讴": "謳",
	"讵": "詎",
	"讶": "訝",
	"讷": "訥",
	"许": "許",
	"讹": "訛",
	"论": "論",
	"讻": "訩",
	"讼": "訟",
	"讽": "諷",
	"设": "設",
	"访": "訪",
	"诀": "訣",
	"证": "證",
	"诂": "詁",
	"诃": "訶",
	"评": "評",
	"诅": "詛",
	"识": "識",
	"诇": "詗",
	"诈": "詐",
	"诉": "訴",
	"诊": "診",
	"诋": "詆",
	"诌": "謅",
	"词": "詞",
	"诎": "詘",
	"诏": "詔",
	"诐": "詖",
	"译": "譯",
	"诒": "詒",
	"诓": "誆",
	"诔": "誄",
	"试": "試",
	"诖": "詿",
	"诗": "詩",
	"诘": "詰",
	"诙": "詼",
	"诚": "誠",
	"诛": "誅",
	"诜": "詵",
	"话": "話",
	"诞": "誕",
	"诟": "詬",
	"诠": "詮",
	"诡": "詭",
	"询": "詢",
	"诣": "詣",
	"诤": "諍",
	"该": "該",
	"详": "詳",
	"诧": "詫",
	"诨": "諢",
	"诩": "詡",
	"诪": "譸",
	"诫": "誡",
	"诬": "誣",
	"语": "語",
	"诮": "誚",
	"误": "誤",
	"诰": "誥",
	"诱": "誘",
	"诲": "誨",
	"诳": "誑",
	"诵": "誦",
	"诶": "誒",
	"请": "請",
	"诸": "諸",
	"诹": "諏",
	"诺": "諾",
	"读": "讀",
	"诼": "諑",
	"诽": "誹",
	"课": "課",
	"诿": "諉",
	"谀": "諛",
	"谁": "誰",
	"谂": "諗",
	"调": "調",
	"谄": "諂",
	"谅": "諒",
	"谆": "諄",
	"谇": "誶",
	"谈": "談",
	"谊": "誼",
	"谋": "謀",
	"谌": "諶",
	"谍": "諜",
	"谎": "謊",
	"谏": "諫",
	"谐": "諧",
	"谑": "謔",
	"谒": "謁",
	"谓": "謂",
	"谔": "諤",
	"谕": "諭",
	"谖": "諼",
	"谗": "讒",
	"谘": "諮",
	"谙": "諳",
	"谚": "諺",
	"谛": "諦",
	"谜": "謎",
	"谝": "諞",
	"谞": "諝",
	"谟": "謨",
	"谠": "讜",
	"谡": "謖",
	"谢": "謝",
	"谤": "謗",
	"谥": "謚",
	"谦": "謙",
	"谧": "謐",
	"谨": "謹",
	"谩": "謾",
	"谪": "謫",
	"谬": "謬",
	"谭": "譚",
	"谮": "譖",
	"谯": "譙",
	"谰": "讕",
	"谱": "譜",
	"谲": "譎",
	"谳": "讞",
	"谴": "譴",
	"谵": "譫",
	"谶": "讖",
	"豮": "豶",
	"贝": "貝",
	"贞": "貞",
	"负": "負",
	"贠": "貟",
	"贡": "貢",
	"财": "財",
	"责": "責",
	"贤": "賢",
	"败": "敗",
	"账": "賬",
	"货": "貨",
	"质": "質",
	"贩": "販",
	"贪": "貪",
	"贫": "貧",
	"贬": "貶",
	"购": "購",
	"贮": "貯",
	"贯": "貫",
	"贰": "貳",
	"贱": "賤",
	"贲": "賁",
	"贳": "貰",
	"贴": "貼",
	"贵": "貴",
	"贶": "貺",
	"贷": "貸",
	"贸": "貿",
	"费": "費",
	"贺": "賀",
	"贻": "貽",
	"贼": "賊",
	"贽": "贄",
	"贾": "賈",
	"贿": "賄",
	"赀": "貲",
	"赁": "賃",
	"赂": "賂",
	"资": "資",
	"赅": "賅",
	"赆": "贐",
	"赇": "賕",
	"赈": "賑",
	"赉": "賚",
	"赊": "賒",
	"赋": "賦",
	"赌": "賭",
	"赎": "贖",
	"赏": "賞",
	"赐": "賜",
	"赑": "贔",
	"赒": "賙",
	"赓": "賡",
	"赔": "賠",
	"赕": "賧",
	"赖": "賴",
	"赗": "賵",
	"赘": "贅",
	"赙": "賻",
	"赚": "賺",
	"赛": "賽",
	"赜": "賾",
	"赞": "贊",
	"赟": "贇",
	"赠": "贈",
	"赡": "贍",
	"赢": "贏",
	"赣": "贛",
	"赪": "赬",
	"赵": "趙",
	"赶": "趕",
	"趋": "趨",
	"趱": "趲",
	"趸": "躉",
	"跃": "躍",
	"跄": "蹌",
	"跞": "躒",
	"践": "踐",
	"跶": "躂",
	"跷": "蹺",
	"跸": "蹕",
	"跹": "躚",
	"跻": "躋",
	"踊": "踴",
	"踌": "躊",
	"踪": "蹤",
	"踬": "躓",
	"踯": "躑",
	"蹑": "躡",
	"蹒": "蹣",
	"蹰": "躕",
	"蹿": "躥",
	"躏": "躪",
	"躜": "躦",
	"躯": "軀",
	"车": "車",
	"轧": "軋",
	"轨": "軌",
	"轩": "軒",
	"轪": "軑",
	"轫": "軔",
	"转": "轉",
	"轭": "軛",
	"轮": "輪",
	"软": "軟",
	"轰": "轟",
	"轱": "軲",
	"轲": "軻",
	"轳": "轤",
	"轴": "軸",
	"轵": "軹",
	"轶": "軼",
	"轷": "軤",
	"轸": "軫",
	"轹": "轢",
	"轺": "軺",
	"轻": "輕",
	"轼": "軾",
	"载": "載",
	"轾": "輊",
	"轿": "轎",
	"辀": "輈",
	"辁": "輇",
	"辂": "輅",
	"较": "較",
	"辄": "輒",
	"辅": "輔",
	"辆": "輛",
	"辇": "輦",
	"辈": "輩",
	"辉": "輝",
	"辊": "輥",
	"辋": "輞",
	"辌": "輬",
	"辍": "輟",
	"辎": "輜",
	"辏": "輳",
	"辐": "輻",
	"辑": "輯",
	"辒": "轀",
	"输": "輸",
	"辔": "轡",
	"辕": "轅",
	"辖": "轄",
	"辗": "輾",
	"辘": "轆",
	"辙": "轍",
	"辚": "轔",
	"辞": "辭",
	"辩": "辯",
	"辫": "辮",
	"边": "邊",
	"辽": "遼",
	"达": "達",
	"迁": "遷",
	"过": "過",
	"迈": "邁",
	"运": "運",
	"还": "還",
	"这": "這",
	"进": "進",
	"远": "遠",
	"违": "違",
	"连": "連",
	"迟": "遲",
	"迩": "邇",
	"迳": "逕",
	"迹": "跡",
	"选": "選",
	"逊": "遜",
	"递": "遞",
	"逦": "邐",
	"逻": "邏",
	"遗": "遺",
	"遥": "遙",
	"邓": "鄧",
	"邝": "鄺",
	"邬": "鄔",
	"邮": "郵",
	"邹": "鄒",
	"邺": "鄴",
	"邻": "鄰",
	"郏": "郟",
	"郐": "鄶",
	"郑": "鄭",
	"郓": "鄆",
	"郦": "酈",
	"郧": "鄖",
	"郸": "鄲",
	"酂": "酇",
	"酦": "醱",
	"酱": "醬",
	"酽": "釅",
	"酾": "釃",
	"酿": "釀",
	"释": "釋",
	"鉴": "鑒",
	"銮": "鑾",
	"錾": "鏨",
	"钅": "釒",
	"钆": "釓",
	"钇": "釔",
	"针": "針",
	"钉": "釘",
	"钊": "釗",
	"钋": "釙",
	"钌": "釕",
	"钍": "釷",
	"钎": "釺",
	"钏": "釧",
	"钐": "釤",
	"钑": "鈒",
	"钒": "釩",
	"钓": "釣",
	"钔": "鍆",
	"钕": "釹",
	"钖": "鍚",
	"钗": "釵",
	"钘": "鈃",
	"钙": "鈣",
	"钚": "鈈",
	"钛": "鈦",
	"钜": "鉅",
	"钝": "鈍",
	"钞": "鈔",
	"钠": "鈉",
	"钡": "鋇",
	"钢": "鋼",
	"钣": "鈑",
	"钤": "鈐",
	"钥": "鑰",
	"钦": "欽",
	"钧": "鈞",
	"钨": "鎢",
	"钪": "鈧",
	"钫": "鈁",
	"钬": "鈥",
	"钭": "鈄",
	"钮": "鈕",
	"钯": "鈀",
	"钰": "鈺",
	"钱": "錢",
	"钲": "鉦",
	"钳": "鉗",
	"钴": "鈷",
	"钶": "鈳",
	"钷": "鉕",
	"钸": "鈽",
	"钹": "鈸",
	"钺": "鉞",
	"钻": "鑽",
	"钼": "鉬",
	"钽": "鉭",
	"钾": "鉀",
	"钿": "鈿",
	"铀": "鈾",
	"铁": "鐵",
	"铂": "鉑",
	"铃": "鈴",
	"铄": "鑠",
	"铅": "鉛",
	"铆": "鉚",
	"铇": "鉋",
	"铈": "鈰",
	"铉": "鉉",
	"铊": "鉈",
	"铋": "鉍",
	"铌": "鈮",
	"铍": "鈹",
	"铎": "鐸",
	"铏": "鉶",
	"铐": "銬",
	"铑": "銠",
	"铒": "鉺",
	"铓": "鋩",
	"铔": "錏",
	"铕": "銪",
	"铖": "鋮",
	"铗": "鋏",
	"铘": "鋣",
	"铙": "鐃",
	"铚": "銍",
	"铛": "鐺",
	"铜": "銅",
	"铝": "鋁",
	"铞": "銱",
	"铟": "銦",
	"铠": "鎧",
	"铡": "鍘",
	"铢": "銖",
	"铣": "銑",
	"铤": "鋌",
	"铥": "銩",
	"铦": "銛",
	"铧": "鏵",
	"铨": "銓",
	"铩": "鎩",
	"铪": "鉿",
	"铫": "銚",
	"铬": "鉻",
	"铭": "銘",
	"铮": "錚",
	"铯": "銫",
	"铰": "鉸",
	"铱": "銥",
	"铲": "鏟",
	"铳": "銃",
	"铴": "鐋",
	"铵": "銨",
	"银": "銀",
	"铷": "銣",
	"铸": "鑄",
	"铹": "鐒",
	"铺": "鋪",
	"铻": "鋙",
	"铼": "錸",
	"铽": "鋱",
	"链": "鏈",
	"铿": "鏗",
	"销": "銷",
	"锁": "鎖",
	"锂": "鋰",
	"锃": "鋥",
	"锄": "鋤",
	"锅": "鍋",
	"锆": "鋯",
	"锇": "鋨",
	"锉": "銼",
	"锊": "鋝",
	"锋": "鋒",
	"锌": "鋅",
	"锍": "鋶",
	"锎": "鐦",
	"锏": "鐧",
	"锑": "銻",
	"锒": "鋃",
	"锓": "鋟",
	"锔": "鋦",
	"锕": "錒",
	"锖": "錆",
	"锗": "鍺",
	"锘": "鍩",
	"错": "錯",
	"锚": "錨",
	"锛": "錛",
	"锜": "錡",
	"锝": "鍀",
	"锞": "錁",
	"锟": "錕",
	"锠": "錩",
	"锡": "錫",
	"锢": "錮",
	"锣": "鑼",
	"锤": "錘",
	"锥": "錐",
	"锦": "錦",
	"锧": "鑕",
	"锩": "錈",
	"锪": "鍃",
	"锫": "錇",
	"锬": "錟",
	"锭": "錠",
	"键": "鍵",
	"锯": "鋸",
	"锰": "錳",
	"锱": "錙",
	"锲": "鍥",
	"锳": "鍈",
	"锴": "鍇",
	"锵": "鏘",
	"锶": "鍶",
	"锷": "鍔",
	"锸": "鍤",
	"锹": "鍬",
	"锺": "鍾",
	"锻": "鍛",
	"锼": "鎪",
	"锽": "鍠",
	"锾": "鍰",
	"锿": "鎄",
	"镀": "鍍",
	"镁": "鎂",
	"镂": "鏤",
	"镃": "鎡",
	"镄": "鐨",
	"镅": "鎇",
	"镆": "鏌",
	"镇": "鎮",
	"镈": "鎛",
	"镉": "鎘",
	"镊": "鑷",
	"镋": "鎲",
	"镍": "鎳",
	"镎": "鎿",
	"镏": "鎦",
	"镐": "鎬",
	"镑": "鎊",
	"镒": "鎰",
	"镓": "鎵",
	"镔": "鑌",
	"镕": "鎔",
	"镖": "鏢",
	"镗": "鏜",
	"镘": "鏝",
	"镙": "鏍",
	"镚": "鏰",
	"镛": "鏞",
	"镜": "鏡",
	"镝": "鏑",
	"镞": "鏃",
	"镟": "鏇",
	"镠": "鏐",
	"镡": "鐔",
	"镣": "鐐",
	"镤": "鏷",
	"镥": "鑥",
	"镦": "鐓",
	"镧": "鑭",
	"镨": "鐠",
	"镩": "鑹",
	"镪": "鏹",
	"镫": "鐙",
	"镬": "鑊",
	"镭": "鐳",
	"镮": "鐶",
	"镯": "鐲",
	"镰": "鐮",
	"镱": "鐿",
	"镲": "鑔",
	"镳": "鑣",
	"镴": "鑞",
	"镵": "鑱",
	"镶": "鑲",
	"长": "長",
	"门": "門",
	"闩": "閂",
	"闪": "閃",
	"闫": "閆",
	"闬": "閈",
	"闭": "閉",
	"问": "問",
	"闯": "闖",
	"闰": "閏",
	"闱": "闈",
	"闲": "閑",
	"闳": "閎",
	"间": "間",
	"闵": "閔",
	"闶": "閌",
	"闷": "悶",
	"闸": "閘",
	"闹": "鬧",
	"闺": "閨",
	"闻": "聞",
	"闼": "闥",
	"闽": "閩",
	"闾": "閭",
	"闿": "闓",
	"阀": "閥",
	"阁": "閣",
	"阂": "閡",
	"阃": "閫",
	"阄": "鬮",
	"阆": "閬",
	"阇": "闍",
	"阈": "閾",
	"阉": "閹",
	"阊": "閶",
	"阋": "鬩",
	"阌": "閿",
	"阍": "閽",
	"阎": "閻",
	"阏": "閼",
	"阐": "闡",
	"阑": "闌",
	"阒": "闃",
	"阓": "闠",
	"阔": "闊",
	"阕": "闋",
	"阖": "闔",
	"阗": "闐",
	"阘": "闒",
	"阙": "闕",
	"阚": "闞",
	"阛": "闤",
	"队": "隊",
	"阳": "陽",
	"阴": "陰",
	"阵": "陣",
	"阶": "階",
	"际": "際",
	"陆": "陸",
	"陇": "隴",
	"陈": "陳",
	"陉": "陘",
	"陕": "陝",
	"陧": "隉",
	"陨": "隕",
	"险": "險",
	"随": "隨",
	"隐": "隱",
	"隶": "隸",
	"隽": "雋",
	"难": "難",
	"雏": "雛",
	"雠": "讎",
	"雳": "靂",
	"雾": "霧",
	"霁": "霽",
	"霡": "霢",
	"霭": "靄",
	"靓": "靚",
	"静": "靜",
	"靥": "靨",
	"鞑": "韃",
	"鞒": "鞽",
	"鞯": "韉",
	"韦": "韋",
	"韧": "韌",
	"韨": "韍",
	"韩": "韓",
	"韪": "韙",
	"韫": "韞",
	"韬": "韜",
	"韵": "韻",
	"页": "頁",
	"顶": "頂",
	"顷": "頃",
	"顸": "頇",
	"项": "項",
	"顺": "順",
	"顼": "頊",
	"顽": "頑",
	"顾": "顧",
	"顿": "頓",
	"颀": "頎",
	"颁": "頒",
	"颂": "頌",
	"颃": "頏",
	"预": "預",
	"颅": "顱",
	"领": "領",
	"颇": "頗",
	"颈": "頸",
	"颉": "頡",
	"颊": "頰",
	"颋": "頲",
	"颌": "頜",
	"颍": "潁",
	"颎": "熲",
	"颏": "頦",
	"颐": "頤",
	"频": "頻",
	"颒": "頮",
	"颔": "頷",
	"颕": "頴",
	"颖": "穎",
	"颗": "顆",
	"题": "題",
	"颙": "顒",
	"颚": "顎",
	"颛": "顓",
	"额": "額",
	"颞": "顳",
	"颟": "顢",
	"颠": "顛",
	"颡": "顙",
	"颢": "顥",
	"颤": "顫",
	"颥": "顬",
	"颦": "顰",
	"颧": "顴",
	"风": "風",
	"飏": "颺",
	"飐": "颭",
	"飑": "颮",
	"飒": "颯",
	"飓": "颶",
	"飔": "颸",
	"飕": "颼",
	"飖": "颻",
	"飗": "飀",
	"飘": "飄",
	"飙": "飆",
	"飚": "飈",
	"飞": "飛",
	"飨": "饗",
	"餍": "饜",
	"饣": "飠",
	"饤": "飣",
	"饦": "飥",
	"饧": "餳",
	"饨": "飩",
	"饩": "餼",
	"饪": "飪",
	"饫": "飫",
	"饬": "飭",
	"饭": "飯",
	"饮": "飲",
	"饯": "餞",
	"饰": "飾",
	"饱": "飽",
	"饲": "飼",
	"饳": "飿",
	"饴": "飴",
	"饵": "餌",
	"饶": "饒",
	"饷": "餉",
	"饸": "餄",
	"饹": "餎",
	"饺": "餃",
	"饻": "餏",
	"饼": "餅",
	"饽": "餑",
	"饾": "餖",
	"饿": "餓",
	"馀": "餘",
	"馁": "餒",
	"馂": "餕",
	"馃": "餜",
	"馄": "餛",
	"馅": "餡",
	"馆": "館",
	"馇": "餷",
	"馈": "饋",
	"馉": "餶",
	"馊": "餿",
	"馋": "饞",
	"馌": "饁",
	"馍": "饃",
	"馎": "餺",
	"馏": "餾",
	"馐": "饈",
	"馑": "饉",
	"馒": "饅",
	"馓": "饊",
	"馔": "饌",
	"馕": "饢",
	"马": "馬",
	"驭": "馭",
	"驮": "馱",
	"驯": "馴",
	"驰": "馳",
	"驱": "驅",
	"驲": "馹",
	"驳": "駁",
	"驴": "驢",
	"驵": "駔",
	"驶": "駛",
	"驷": "駟",
	"驸": "駙",
	"驹": "駒",
	"驺": "騶",
	"驻": "駐",
	"驼": "駝",
	"驽": "駑",
	"驾": "駕",
	"驿": "驛",
	"骀": "駘",
	"骁": "驍",
	"骃": "駰",
	"骄": "驕",
	"骅": "驊",
	"骆": "駱",
	"骇": "駭",
	"骈": "駢",
	"骉": "驫",
	"骊": "驪",
	"骋": "騁",
	"验": "驗",
	"骍": "騂",
	"骎": "駸",
	"骏": "駿",
	"骐": "騏",
	"骑": "騎",
	"骒": "騍",
	"骓": "騅",
	"骔": "騌",
	"骕": "驌",
	"骖": "驂",
	"骗": "騙",
	"骘": "騭",
	"骙": "騤",
	"骚": "騷",
	"骛": "騖",
	"骜": "驁",
	"骝": "騮",
	"骞": "騫",
	"骟": "騸",
	"骠": "驃",
	"骡": "騾",
	"骢": "驄",
	"骣": "驏",
	"骤": "驟",
	"骥": "驥",
	"骦": "驦",
	"骧": "驤",
	"髅": "髏",
	"髋": "髖",
	"髌": "髕",
	"鬓": "鬢",
	"魇": "魘",
	"魉": "魎",
	"鱼": "魚",
	"鱽": "魛",
	"鱾": "魢",
	"鱿": "魷",
	"鲀": "魨",
	"鲁": "魯",
	"鲂": "魴",
	"鲃": "䰾",
	"鲄": "魺",
	"鲅": "鮁",
	"鲆": "鮃",
	"鲈": "鱸",
	"鲉": "鮋",
	"鲊": "鮓",
	"鲋": "鮒",
	"鲌": "鮊",
	"鲍": "鮑",
	"鲎": "鱟",
	"鲏": "鮍",
	"鲐": "鮐",
	"鲑": "鮭",
	"鲒": "鮚",
	"鲓": "鮳",
	"鲔": "鮪",
	"鲕": "鮞",
	"鲖": "鮦",
	"鲗": "鰂",
	"鲘": "鮜",
	"鲙": "鱠",
	"鲚": "鱭",
	"鲛": "鮫",
	"鲜": "鮮",
	"鲝": "鮺",
	"鲟": "鱘",
	"鲠": "鯁",
	"鲡": "鱺",
	"鲢": "鰱",
	"鲣": "鰹",
	"鲤": "鯉",
	"鲥": "鰣",
	"鲦": "鰷",
	"鲧": "鯀",
	"鲨": "鯊",
	"鲩": "鯇",
	"鲪": "鮶",
	"鲫": "鯽",
	"鲬": "鯒",
	"鲭": "鯖",
	"鲮": "鯪",
	"鲯": "鯕",
	"鲰": "鯫",
	"鲱": "鯡",
	"鲲": "鯤",
	"鲳": "鯧",
	"鲴": "鯝",
	"鲵": "鯢",
	"鲶": "鯰",
	"鲷": "鯛",
	"鲸": "鯨",
	"鲹": "鰺",
	"鲺": "鯴",
	"鲻": "鯔",
	"鲼": "鱝",
	"鲽": "鰈",
	"鲾": "鰏",
	"鲿": "鱨",
	"鳀": "鯷",
	"鳁": "鰮",
	"鳂": "鰃",
	"鳃": "鰓",
	"鳅": "鰍",
	"鳆": "鰒",
	"鳇": "鰉",
	"鳈": "鰁",
	"鳉": "鱂",
	"鳊": "鯿",
	"鳋": "鰠",
	"鳌": "鰲",
	"鳍": "鰭",
	"鳎": "鰨",
	"鳏": "鰥",
	"鳐": "鰩",
	"鳑": "鰟",
	"鳒": "鰜",
	"鳓": "鰳",
	"鳔": "鰾",
	"鳕": "鱈",
	"鳖": "鱉",
	"鳗": "鰻",
	"鳘": "鰵",
	"鳙": "鱅",
	"鳚": "䲁",
	"鳛": "鰼",
	"鳜": "鱖",
	"鳝": "鱔",
	"鳞": "鱗",
	"鳟": "鱒",
	"鳠": "鱯",
	"鳡": "鱤",
	"鳢": "鱧",
	"鳣": "鱣",
	"䴓": "鳾",
	"䴕": "鴷",
	"䴔": "鵁",
	"䴖": "鶄",
	"䴗": "鶪",
	"䴘": "鷈",
	"䴙": "鷿",
	"鸟": "鳥",
	"鸠": "鳩",
	"鸢": "鳶",
	"鸣": "鳴",
	"鸤": "鳲",
	"鸥": "鷗",
	"鸦": "鴉",
	"鸧": "鶬",
	"鸨": "鴇",
	"鸩": "鴆",
	"鸪": "鴣",
	"鸫": "鶇",
	"鸬": "鸕",
	"鸭": "鴨",
	"鸮": "鴞",
	"鸯": "鴦",
	"鸰": "鴒",
	"鸱": "鴟",
	"鸲": "鴝",
	"鸳": "鴛",
	"鸴": "鷽",
	"鸵": "鴕",
	"鸶": "鷥",
	"鸷": "鷙",
	"鸸": "鴯",
	"鸹": "鴰",
	"鸺": "鵂",
	"鸻": "鴴",
	"鸼": "鵃",
	"鸽": "鴿",
	"鸾": "鸞",
	"鸿": "鴻",
	"鹀": "鵐",
	"鹁": "鵓",
	"鹂": "鸝",
	"鹃": "鵑",
	"鹄": "鵠",
	"鹅": "鵝",
	"鹆": "鵒",
	"鹇": "鷳",
	"鹈": "鵜",
	"鹉": "鵡",
	"鹊": "鵲",
	"鹋": "鶓",
	"鹌": "鵪",
	"鹍": "鵾",
	"鹎": "鵯",
	"鹏": "鵬",
	"鹐": "鵮",
	"鹑": "鶉",
	"鹒": "鶊",
	"鹓": "鵷",
	"鹔": "鷫",
	"鹕": "鶘",
	"鹖": "鶡",
	"鹗": "鶚",
	"鹘": "鶻",
	"鹙": "鶖",
	"鹛": "鶥",
	"鹜": "鶩",
	"鹝": "鷊",
	"鹞": "鷂",
	"鹟": "鶲",
	"鹠": "鶹",
	"鹡": "鶺",
	"鹢": "鷁",
	"鹣": "鶼",
	"鹤": "鶴",
	"鹥": "鷖",
	"鹦": "鸚",
	"鹧": "鷓",
	"鹨": "鷚",
	"鹩": "鷯",
	"鹪": "鷦",
	"鹫": "鷲",
	"鹬": "鷸",
	"鹭": "鷺",
	"鹯": "鸇",
	"鹰": "鷹",
	"鹱": "鸌",
	"鹲": "鸏",
	"鹳": "鸛",
	"鹴": "鸘",
	"鹾": "鹺",
	"麦": "麥",
	"麸": "麩",
	"麽": "麼",
	"黄": "黃",
	"黉": "黌",
	"黡": "黶",
	"黩": "黷",
	"黪": "黲",
	"黾": "黽",
	"鼋": "黿",
	"鼍": "鼉",
	"鼗": "鞀",
	"鼹": "鼴",
	"齐": "齊",
	"齑": "齏",
	"齿": "齒",
	"龀": "齔",
	"龁": "齕",
	"龂": "齗",
	"龃": "齟",
	"龄": "齡",
	"龅": "齙",
	"龆": "齠",
	"龇": "齜",
	"龈": "齦",
	"龉": "齬",
	"龊": "齪",
	"龋": "齲",
	"龌": "齷",
	"龙": "龍",
	"龚": "龔",
	"龛": "龕",
	"龟": "龜",
};

/**
 * Wikipedia:繁简处理/繁简单字
 * https://zh.wikipedia.org/wiki/Wikipedia:%E7%B9%81%E7%AE%80%E5%A4%84%E7%90%86/%E7%B9%81%E7%AE%80%E5%8D%95%E5%AD%97
 */
export const wiki_t2s_v2: ITable = {
	"䊷": "䌶",
	"𧩙": "䜥",
	"丟": "丢",
	"並": "并",
	"乾": "干",
	"亂": "乱",
	"亙": "亘",
	"亞": "亚",
	"佇": "伫",
	"佈": "布",
	"余": "馀",
	"併": "并",
	"來": "来",
	"侖": "仑",
	"侶": "侣",
	"俁": "俣",
	"係": "系",
	"俔": "伣",
	"俠": "侠",
	"倀": "伥",
	"倆": "俩",
	"倈": "俫",
	"倉": "仓",
	"個": "个",
	"們": "们",
	"倫": "伦",
	"偉": "伟",
	"側": "侧",
	"偵": "侦",
	"偽": "伪",
	"傑": "杰",
	"傖": "伧",
	"傘": "伞",
	"備": "备",
	"傢": "家",
	"傭": "佣",
	"傯": "偬",
	"傳": "传",
	"傴": "伛",
	"債": "债",
	"傷": "伤",
	"傾": "倾",
	"僂": "偻",
	"僅": "仅",
	"僉": "佥",
	"僑": "侨",
	"僕": "仆",
	"僞": "伪",
	"僥": "侥",
	"僨": "偾",
	"價": "价",
	"儀": "仪",
	"儂": "侬",
	"億": "亿",
	"儈": "侩",
	"儉": "俭",
	"儐": "傧",
	"儔": "俦",
	"儕": "侪",
	"儘": "尽",
	"償": "偿",
	"優": "优",
	"儲": "储",
	"儷": "俪",
	"儺": "傩",
	"儻": "傥",
	"儼": "俨",
	"兇": "凶",
	"兌": "兑",
	"兒": "儿",
	"兗": "兖",
	"內": "内",
	"兩": "两",
	"冊": "册",
	"冪": "幂",
	"凈": "净",
	"凍": "冻",
	"凜": "凛",
	"凱": "凯",
	"別": "别",
	"刪": "删",
	"剄": "刭",
	"則": "则",
	"剋": "克",
	"剎": "刹",
	"剗": "刬",
	"剛": "刚",
	"剝": "剥",
	"剮": "剐",
	"剴": "剀",
	"創": "创",
	"劃": "划",
	"劇": "剧",
	"劉": "刘",
	"劊": "刽",
	"劌": "刿",
	"劍": "剑",
	"劑": "剂",
	"勁": "劲",
	"動": "动",
	"務": "务",
	"勛": "勋",
	"勝": "胜",
	"勞": "劳",
	"勢": "势",
	"勩": "勚",
	"勱": "劢",
	"勵": "励",
	"勸": "劝",
	"勻": "匀",
	"匭": "匦",
	"匯": "汇",
	"匱": "匮",
	"區": "区",
	"協": "协",
	"卻": "却",
	"厙": "厍",
	"厠": "厕",
	"厭": "厌",
	"厲": "厉",
	"厴": "厣",
	"參": "参",
	"叄": "叁",
	"叢": "丛",
	"吒": "咤",
	"吳": "吴",
	"吶": "呐",
	"呂": "吕",
	"咼": "呙",
	"員": "员",
	"唄": "呗",
	"唚": "吣",
	"問": "问",
	"啓": "启",
	"啞": "哑",
	"啟": "启",
	"啢": "唡",
	"喎": "㖞",
	"喚": "唤",
	"喪": "丧",
	"喬": "乔",
	"單": "单",
	"喲": "哟",
	"嗆": "呛",
	"嗇": "啬",
	"嗊": "唝",
	"嗎": "吗",
	"嗚": "呜",
	"嗩": "唢",
	"嗶": "哔",
	"嘆": "叹",
	"嘍": "喽",
	"嘔": "呕",
	"嘖": "啧",
	"嘗": "尝",
	"嘜": "唛",
	"嘩": "哗",
	"嘮": "唠",
	"嘯": "啸",
	"嘰": "叽",
	"嘵": "哓",
	"嘸": "呒",
	"嘽": "啴",
	"噁": "恶",
	"噓": "嘘",
	"噝": "咝",
	"噠": "哒",
	"噥": "哝",
	"噦": "哕",
	"噯": "嗳",
	"噲": "哙",
	"噴": "喷",
	"噸": "吨",
	"噹": "当",
	"嚀": "咛",
	"嚇": "吓",
	"嚌": "哜",
	"嚕": "噜",
	"嚙": "啮",
	"嚥": "咽",
	"嚦": "呖",
	"嚨": "咙",
	"嚮": "向",
	"嚲": "亸",
	"嚳": "喾",
	"嚴": "严",
	"嚶": "嘤",
	"囀": "啭",
	"囁": "嗫",
	"囂": "嚣",
	"囅": "冁",
	"囈": "呓",
	"囌": "苏",
	"囑": "嘱",
	"囘": "回",
	"囪": "囱",
	"圇": "囵",
	"國": "国",
	"圍": "围",
	"園": "园",
	"圓": "圆",
	"圖": "图",
	"團": "团",
	"垵": "埯",
	"埡": "垭",
	"埰": "采",
	"執": "执",
	"堅": "坚",
	"堊": "垩",
	"堖": "垴",
	"堝": "埚",
	"堯": "尧",
	"報": "报",
	"場": "场",
	"塊": "块",
	"塋": "茔",
	"塏": "垲",
	"塒": "埘",
	"塗": "涂",
	"塚": "冢",
	"塢": "坞",
	"塤": "埙",
	"塵": "尘",
	"塹": "堑",
	"墊": "垫",
	"墜": "坠",
	"墮": "堕",
	"墳": "坟",
	"墻": "墙",
	"墾": "垦",
	"壇": "坛",
	"壈": "𡒄",
	"壋": "垱",
	"壓": "压",
	"壘": "垒",
	"壙": "圹",
	"壚": "垆",
	"壞": "坏",
	"壟": "垄",
	"壠": "垅",
	"壢": "坜",
	"壩": "坝",
	"壯": "壮",
	"壺": "壶",
	"壼": "壸",
	"壽": "寿",
	"夠": "够",
	"夢": "梦",
	"夾": "夹",
	"奐": "奂",
	"奧": "奥",
	"奩": "奁",
	"奪": "夺",
	"奬": "奖",
	"奮": "奋",
	"奼": "姹",
	"妝": "妆",
	"姍": "姗",
	"姦": "奸",
	"娛": "娱",
	"婁": "娄",
	"婦": "妇",
	"婭": "娅",
	"媧": "娲",
	"媯": "妫",
	"媼": "媪",
	"媽": "妈",
	"嫗": "妪",
	"嫵": "妩",
	"嫻": "娴",
	"嫿": "婳",
	"嬀": "妫",
	"嬈": "娆",
	"嬋": "婵",
	"嬌": "娇",
	"嬙": "嫱",
	"嬡": "嫒",
	"嬤": "嬷",
	"嬪": "嫔",
	"嬰": "婴",
	"嬸": "婶",
	"孌": "娈",
	"孫": "孙",
	"學": "学",
	"孿": "孪",
	"宮": "宫",
	"寢": "寝",
	"實": "实",
	"寧": "宁",
	"審": "审",
	"寫": "写",
	"寬": "宽",
	"寵": "宠",
	"寶": "宝",
	"將": "将",
	"專": "专",
	"尋": "寻",
	"對": "对",
	"導": "导",
	"尷": "尴",
	"屆": "届",
	"屍": "尸",
	"屓": "屃",
	"屜": "屉",
	"屢": "屡",
	"層": "层",
	"屨": "屦",
	"屬": "属",
	"岡": "冈",
	"峴": "岘",
	"島": "岛",
	"峽": "峡",
	"崍": "崃",
	"崗": "岗",
	"崢": "峥",
	"崬": "岽",
	"嵐": "岚",
	"嶁": "嵝",
	"嶄": "崭",
	"嶇": "岖",
	"嶔": "嵚",
	"嶗": "崂",
	"嶠": "峤",
	"嶢": "峣",
	"嶧": "峄",
	"嶮": "崄",
	"嶴": "岙",
	"嶸": "嵘",
	"嶺": "岭",
	"嶼": "屿",
	"嶽": "岳",
	"巋": "岿",
	"巒": "峦",
	"巔": "巅",
	"巰": "巯",
	"帥": "帅",
	"師": "师",
	"帳": "帐",
	"帶": "带",
	"幀": "帧",
	"幃": "帏",
	"幗": "帼",
	"幘": "帻",
	"幟": "帜",
	"幣": "币",
	"幫": "帮",
	"幬": "帱",
	"幹": "干",
	"幺": "么",
	"幾": "几",
	"庫": "库",
	"廁": "厕",
	"廂": "厢",
	"廄": "厩",
	"廈": "厦",
	"廚": "厨",
	"廝": "厮",
	"廟": "庙",
	"廠": "厂",
	"廡": "庑",
	"廢": "废",
	"廣": "广",
	"廩": "廪",
	"廬": "庐",
	"廳": "厅",
	"弒": "弑",
	"弳": "弪",
	"張": "张",
	"強": "强",
	"彆": "别",
	"彈": "弹",
	"彌": "弥",
	"彎": "弯",
	"彔": "录",
	"彙": "汇",
	"彞": "彝",
	"彥": "彦",
	"後": "后",
	"徑": "径",
	"從": "从",
	"徠": "徕",
	"復": "复",
	"徵": "征",
	"徹": "彻",
	"恆": "恒",
	"恥": "耻",
	"悅": "悦",
	"悞": "悮",
	"悵": "怅",
	"悶": "闷",
	"惡": "恶",
	"惱": "恼",
	"惲": "恽",
	"惻": "恻",
	"愛": "爱",
	"愜": "惬",
	"愨": "悫",
	"愴": "怆",
	"愷": "恺",
	"愾": "忾",
	"慄": "栗",
	"態": "态",
	"慍": "愠",
	"慘": "惨",
	"慚": "惭",
	"慟": "恸",
	"慣": "惯",
	"慤": "悫",
	"慪": "怄",
	"慫": "怂",
	"慮": "虑",
	"慳": "悭",
	"慶": "庆",
	"憂": "忧",
	"憊": "惫",
	"憐": "怜",
	"憑": "凭",
	"憒": "愦",
	"憚": "惮",
	"憤": "愤",
	"憫": "悯",
	"憮": "怃",
	"憲": "宪",
	"憶": "忆",
	"懇": "恳",
	"應": "应",
	"懌": "怿",
	"懍": "懔",
	"懞": "蒙",
	"懟": "怼",
	"懣": "懑",
	"懨": "恹",
	"懲": "惩",
	"懶": "懒",
	"懷": "怀",
	"懸": "悬",
	"懺": "忏",
	"懼": "惧",
	"懾": "慑",
	"戀": "恋",
	"戇": "戆",
	"戔": "戋",
	"戧": "戗",
	"戩": "戬",
	"戰": "战",
	"戱": "戯",
	"戲": "戏",
	"戶": "户",
	"拋": "抛",
	"拾": "十",
	"挩": "捝",
	"挾": "挟",
	"捨": "舍",
	"捫": "扪",
	"掃": "扫",
	"掄": "抡",
	"掗": "挜",
	"掙": "挣",
	"掛": "挂",
	"採": "采",
	"揀": "拣",
	"揚": "扬",
	"換": "换",
	"揮": "挥",
	"損": "损",
	"搖": "摇",
	"搗": "捣",
	"搵": "揾",
	"搶": "抢",
	"摑": "掴",
	"摜": "掼",
	"摟": "搂",
	"摯": "挚",
	"摳": "抠",
	"摶": "抟",
	"摺": "折",
	"摻": "掺",
	"撈": "捞",
	"撏": "挦",
	"撐": "撑",
	"撓": "挠",
	"撝": "㧑",
	"撟": "挢",
	"撣": "掸",
	"撥": "拨",
	"撫": "抚",
	"撲": "扑",
	"撳": "揿",
	"撻": "挞",
	"撾": "挝",
	"撿": "捡",
	"擁": "拥",
	"擄": "掳",
	"擇": "择",
	"擊": "击",
	"擋": "挡",
	"擓": "㧟",
	"擔": "担",
	"據": "据",
	"擠": "挤",
	"擬": "拟",
	"擯": "摈",
	"擰": "拧",
	"擱": "搁",
	"擲": "掷",
	"擴": "扩",
	"擷": "撷",
	"擺": "摆",
	"擻": "擞",
	"擼": "撸",
	"擾": "扰",
	"攄": "摅",
	"攆": "撵",
	"攏": "拢",
	"攔": "拦",
	"攖": "撄",
	"攙": "搀",
	"攛": "撺",
	"攜": "携",
	"攝": "摄",
	"攢": "攒",
	"攣": "挛",
	"攤": "摊",
	"攪": "搅",
	"攬": "揽",
	"敗": "败",
	"敘": "叙",
	"敵": "敌",
	"數": "数",
	"斂": "敛",
	"斃": "毙",
	"斕": "斓",
	"斬": "斩",
	"斷": "断",
	"於": "于",
	"時": "时",
	"晉": "晋",
	"晝": "昼",
	"暈": "晕",
	"暉": "晖",
	"暘": "旸",
	"暢": "畅",
	"暨": "及",
	"暫": "暂",
	"曄": "晔",
	"曆": "历",
	"曇": "昙",
	"曉": "晓",
	"曏": "向",
	"曖": "暧",
	"曠": "旷",
	"曨": "昽",
	"曬": "晒",
	"書": "书",
	"會": "会",
	"朧": "胧",
	"朮": "术",
	"東": "东",
	"杴": "锨",
	"柵": "栅",
	"桿": "杆",
	"梔": "栀",
	"梘": "枧",
	"條": "条",
	"梟": "枭",
	"梲": "棁",
	"棄": "弃",
	"棖": "枨",
	"棗": "枣",
	"棟": "栋",
	"棧": "栈",
	"棲": "栖",
	"棶": "梾",
	"椏": "桠",
	"楊": "杨",
	"楓": "枫",
	"楨": "桢",
	"業": "业",
	"極": "极",
	"榦": "干",
	"榪": "杩",
	"榮": "荣",
	"榲": "榅",
	"榿": "桤",
	"構": "构",
	"槍": "枪",
	"槤": "梿",
	"槧": "椠",
	"槨": "椁",
	"槳": "桨",
	"樁": "桩",
	"樂": "乐",
	"樅": "枞",
	"樓": "楼",
	"標": "标",
	"樞": "枢",
	"樣": "样",
	"樸": "朴",
	"樹": "树",
	"樺": "桦",
	"橈": "桡",
	"橋": "桥",
	"機": "机",
	"橢": "椭",
	"橫": "横",
	"檁": "檩",
	"檉": "柽",
	"檔": "档",
	"檜": "桧",
	"檟": "槚",
	"檢": "检",
	"檣": "樯",
	"檮": "梼",
	"檯": "台",
	"檳": "槟",
	"檸": "柠",
	"檻": "槛",
	"櫃": "柜",
	"櫓": "橹",
	"櫚": "榈",
	"櫛": "栉",
	"櫝": "椟",
	"櫞": "橼",
	"櫟": "栎",
	"櫥": "橱",
	"櫧": "槠",
	"櫨": "栌",
	"櫪": "枥",
	"櫫": "橥",
	"櫬": "榇",
	"櫱": "蘖",
	"櫳": "栊",
	"櫸": "榉",
	"櫻": "樱",
	"欄": "栏",
	"權": "权",
	"欏": "椤",
	"欒": "栾",
	"欖": "榄",
	"欞": "棂",
	"欽": "钦",
	"歐": "欧",
	"歟": "欤",
	"歡": "欢",
	"歲": "岁",
	"歷": "历",
	"歸": "归",
	"歿": "殁",
	"殘": "残",
	"殞": "殒",
	"殤": "殇",
	"殨": "㱮",
	"殫": "殚",
	"殮": "殓",
	"殯": "殡",
	"殲": "歼",
	"殺": "杀",
	"殻": "壳",
	"殼": "壳",
	"毀": "毁",
	"毆": "殴",
	"毿": "毵",
	"氂": "牦",
	"氈": "毡",
	"氌": "氇",
	"氣": "气",
	"氫": "氢",
	"氬": "氩",
	"氳": "氲",
	"汙": "污",
	"決": "决",
	"沈": "沉",
	"沒": "没",
	"沖": "冲",
	"況": "况",
	"洶": "汹",
	"浹": "浃",
	"涇": "泾",
	"涼": "凉",
	"淒": "凄",
	"淚": "泪",
	"淥": "渌",
	"淨": "净",
	"淩": "凌",
	"淪": "沦",
	"淵": "渊",
	"淶": "涞",
	"淺": "浅",
	"渙": "涣",
	"減": "减",
	"渦": "涡",
	"測": "测",
	"渾": "浑",
	"湊": "凑",
	"湞": "浈",
	"湯": "汤",
	"溈": "沩",
	"準": "准",
	"溝": "沟",
	"溫": "温",
	"滄": "沧",
	"滅": "灭",
	"滌": "涤",
	"滎": "荥",
	"滬": "沪",
	"滯": "滞",
	"滲": "渗",
	"滷": "卤",
	"滸": "浒",
	"滻": "浐",
	"滾": "滚",
	"滿": "满",
	"漁": "渔",
	"漚": "沤",
	"漢": "汉",
	"漣": "涟",
	"漬": "渍",
	"漲": "涨",
	"漵": "溆",
	"漸": "渐",
	"漿": "浆",
	"潁": "颍",
	"潑": "泼",
	"潔": "洁",
	"潙": "沩",
	"潛": "潜",
	"潤": "润",
	"潯": "浔",
	"潰": "溃",
	"潷": "滗",
	"潿": "涠",
	"澀": "涩",
	"澆": "浇",
	"澇": "涝",
	"澐": "沄",
	"澗": "涧",
	"澠": "渑",
	"澤": "泽",
	"澦": "滪",
	"澩": "泶",
	"澮": "浍",
	"澱": "淀",
	"濁": "浊",
	"濃": "浓",
	"濕": "湿",
	"濘": "泞",
	"濛": "蒙",
	"濟": "济",
	"濤": "涛",
	"濫": "滥",
	"濰": "潍",
	"濱": "滨",
	"濺": "溅",
	"濼": "泺",
	"濾": "滤",
	"瀅": "滢",
	"瀆": "渎",
	"瀉": "泻",
	"瀋": "沈",
	"瀏": "浏",
	"瀕": "濒",
	"瀘": "泸",
	"瀝": "沥",
	"瀟": "潇",
	"瀠": "潆",
	"瀦": "潴",
	"瀧": "泷",
	"瀨": "濑",
	"瀰": "弥",
	"瀲": "潋",
	"瀾": "澜",
	"灃": "沣",
	"灄": "滠",
	"灑": "洒",
	"灕": "漓",
	"灘": "滩",
	"灝": "灏",
	"灠": "漤",
	"灣": "湾",
	"灤": "滦",
	"灧": "滟",
	"災": "灾",
	"為": "为",
	"烏": "乌",
	"烴": "烃",
	"無": "无",
	"煉": "炼",
	"煒": "炜",
	"煙": "烟",
	"煢": "茕",
	"煥": "焕",
	"煩": "烦",
	"煬": "炀",
	"熅": "煴",
	"熒": "荧",
	"熗": "炝",
	"熱": "热",
	"熲": "颎",
	"熾": "炽",
	"燁": "烨",
	"燈": "灯",
	"燉": "炖",
	"燒": "烧",
	"燙": "烫",
	"燜": "焖",
	"營": "营",
	"燦": "灿",
	"燭": "烛",
	"燴": "烩",
	"燼": "烬",
	"燾": "焘",
	"爍": "烁",
	"爐": "炉",
	"爛": "烂",
	"爭": "争",
	"爲": "为",
	"爺": "爷",
	"爾": "尔",
	"牆": "墙",
	"牘": "牍",
	"牽": "牵",
	"犖": "荦",
	"犢": "犊",
	"犧": "牺",
	"狀": "状",
	"狹": "狭",
	"狽": "狈",
	"猙": "狰",
	"猶": "犹",
	"猻": "狲",
	"獁": "犸",
	"獄": "狱",
	"獅": "狮",
	"獎": "奖",
	"獨": "独",
	"獪": "狯",
	"獫": "猃",
	"獮": "狝",
	"獰": "狞",
	"獲": "获",
	"獵": "猎",
	"獷": "犷",
	"獸": "兽",
	"獺": "獭",
	"獻": "献",
	"獼": "猕",
	"玀": "猡",
	"現": "现",
	"琺": "珐",
	"琿": "珲",
	"瑋": "玮",
	"瑒": "玚",
	"瑣": "琐",
	"瑤": "瑶",
	"瑩": "莹",
	"瑪": "玛",
	"瑲": "玱",
	"璉": "琏",
	"璣": "玑",
	"璦": "瑷",
	"璫": "珰",
	"環": "环",
	"璽": "玺",
	"瓊": "琼",
	"瓏": "珑",
	"瓔": "璎",
	"瓚": "瓒",
	"甌": "瓯",
	"產": "产",
	"産": "产",
	"畝": "亩",
	"畢": "毕",
	"異": "异",
	"畵": "画",
	"當": "当",
	"疇": "畴",
	"疊": "叠",
	"痙": "痉",
	"痾": "疴",
	"瘂": "痖",
	"瘋": "疯",
	"瘍": "疡",
	"瘓": "痪",
	"瘞": "瘗",
	"瘡": "疮",
	"瘧": "疟",
	"瘮": "瘆",
	"瘲": "疭",
	"瘺": "瘘",
	"瘻": "瘘",
	"療": "疗",
	"癆": "痨",
	"癇": "痫",
	"癉": "瘅",
	"癘": "疠",
	"癟": "瘪",
	"癢": "痒",
	"癤": "疖",
	"癥": "症",
	"癧": "疬",
	"癩": "癞",
	"癬": "癣",
	"癭": "瘿",
	"癮": "瘾",
	"癰": "痈",
	"癱": "瘫",
	"癲": "癫",
	"發": "发",
	"皚": "皑",
	"皰": "疱",
	"皸": "皲",
	"皺": "皱",
	"盃": "杯",
	"盜": "盗",
	"盞": "盏",
	"盡": "尽",
	"監": "监",
	"盤": "盘",
	"盧": "卢",
	"眥": "眦",
	"眾": "众",
	"睏": "困",
	"睜": "睁",
	"睞": "睐",
	"瞘": "眍",
	"瞜": "䁖",
	"瞞": "瞒",
	"瞭": "了",
	"瞶": "瞆",
	"瞼": "睑",
	"矇": "蒙",
	"矓": "眬",
	"矚": "瞩",
	"矯": "矫",
	"硃": "朱",
	"硜": "硁",
	"硤": "硖",
	"硨": "砗",
	"硯": "砚",
	"碩": "硕",
	"碭": "砀",
	"碸": "砜",
	"確": "确",
	"碼": "码",
	"磑": "硙",
	"磚": "砖",
	"磣": "碜",
	"磧": "碛",
	"磯": "矶",
	"磽": "硗",
	"礆": "硷",
	"礎": "础",
	"礙": "碍",
	"礦": "矿",
	"礪": "砺",
	"礫": "砾",
	"礬": "矾",
	"礱": "砻",
	"祿": "禄",
	"禍": "祸",
	"禎": "祯",
	"禕": "祎",
	"禡": "祃",
	"禦": "御",
	"禪": "禅",
	"禮": "礼",
	"禰": "祢",
	"禱": "祷",
	"禿": "秃",
	"秈": "籼",
	"稅": "税",
	"稈": "秆",
	"稟": "禀",
	"種": "种",
	"稱": "称",
	"穀": "谷",
	"穌": "稣",
	"積": "积",
	"穎": "颖",
	"穠": "秾",
	"穡": "穑",
	"穢": "秽",
	"穩": "稳",
	"穫": "获",
	"穭": "稆",
	"窩": "窝",
	"窪": "洼",
	"窮": "穷",
	"窯": "窑",
	"窵": "窎",
	"窶": "窭",
	"窺": "窥",
	"竄": "窜",
	"竅": "窍",
	"竇": "窦",
	"竈": "灶",
	"竊": "窃",
	"竪": "竖",
	"競": "竞",
	"筆": "笔",
	"筍": "笋",
	"筧": "笕",
	"筴": "䇲",
	"箋": "笺",
	"箏": "筝",
	"節": "节",
	"範": "范",
	"築": "筑",
	"篋": "箧",
	"篔": "筼",
	"篤": "笃",
	"篩": "筛",
	"篳": "筚",
	"簀": "箦",
	"簍": "篓",
	"簞": "箪",
	"簡": "简",
	"簣": "篑",
	"簫": "箫",
	"簹": "筜",
	"簽": "签",
	"簾": "帘",
	"籃": "篮",
	"籌": "筹",
	"籖": "签",
	"籙": "箓",
	"籜": "箨",
	"籟": "籁",
	"籠": "笼",
	"籩": "笾",
	"籪": "簖",
	"籬": "篱",
	"籮": "箩",
	"粵": "粤",
	"糝": "糁",
	"糞": "粪",
	"糧": "粮",
	"糰": "团",
	"糲": "粝",
	"糴": "籴",
	"糶": "粜",
	"糹": "纟",
	"糾": "纠",
	"紀": "纪",
	"紂": "纣",
	"約": "约",
	"紅": "红",
	"紆": "纡",
	"紇": "纥",
	"紈": "纨",
	"紉": "纫",
	"紋": "纹",
	"納": "纳",
	"紐": "纽",
	"紓": "纾",
	"純": "纯",
	"紕": "纰",
	"紖": "纼",
	"紗": "纱",
	"紘": "纮",
	"紙": "纸",
	"級": "级",
	"紛": "纷",
	"紜": "纭",
	"紝": "纴",
	"紡": "纺",
	"紬": "䌷",
	"細": "细",
	"紱": "绂",
	"紲": "绁",
	"紳": "绅",
	"紵": "纻",
	"紹": "绍",
	"紺": "绀",
	"紼": "绋",
	"紿": "绐",
	"絀": "绌",
	"終": "终",
	"組": "组",
	"絅": "䌹",
	"絆": "绊",
	"絎": "绗",
	"結": "结",
	"絕": "绝",
	"絛": "绦",
	"絝": "绔",
	"絞": "绞",
	"絡": "络",
	"絢": "绚",
	"給": "给",
	"絨": "绒",
	"絰": "绖",
	"統": "统",
	"絲": "丝",
	"絳": "绛",
	"絶": "绝",
	"絹": "绢",
	"綁": "绑",
	"綃": "绡",
	"綆": "绠",
	"綈": "绨",
	"綉": "绣",
	"綌": "绤",
	"綏": "绥",
	"經": "经",
	"綜": "综",
	"綞": "缍",
	"綠": "绿",
	"綢": "绸",
	"綣": "绻",
	"綫": "线",
	"綬": "绶",
	"維": "维",
	"綯": "绹",
	"綰": "绾",
	"綱": "纲",
	"網": "网",
	"綳": "绷",
	"綴": "缀",
	"綸": "纶",
	"綹": "绺",
	"綺": "绮",
	"綻": "绽",
	"綽": "绰",
	"綾": "绫",
	"綿": "绵",
	"緄": "绲",
	"緇": "缁",
	"緊": "紧",
	"緋": "绯",
	"緑": "绿",
	"緒": "绪",
	"緓": "绬",
	"緔": "绱",
	"緗": "缃",
	"緘": "缄",
	"緙": "缂",
	"線": "线",
	"緝": "缉",
	"緞": "缎",
	"締": "缔",
	"緡": "缗",
	"緣": "缘",
	"緦": "缌",
	"編": "编",
	"緩": "缓",
	"緬": "缅",
	"緯": "纬",
	"緱": "缑",
	"緲": "缈",
	"練": "练",
	"緶": "缏",
	"緹": "缇",
	"緻": "致",
	"縈": "萦",
	"縉": "缙",
	"縊": "缢",
	"縋": "缒",
	"縐": "绉",
	"縑": "缣",
	"縕": "缊",
	"縗": "缞",
	"縛": "缚",
	"縝": "缜",
	"縞": "缟",
	"縟": "缛",
	"縣": "县",
	"縧": "绦",
	"縫": "缝",
	"縭": "缡",
	"縮": "缩",
	"縱": "纵",
	"縲": "缧",
	"縳": "䌸",
	"縴": "纤",
	"縵": "缦",
	"縶": "絷",
	"縷": "缕",
	"縹": "缥",
	"總": "总",
	"績": "绩",
	"繃": "绷",
	"繅": "缫",
	"繆": "缪",
	"繒": "缯",
	"織": "织",
	"繕": "缮",
	"繚": "缭",
	"繞": "绕",
	"繡": "绣",
	"繢": "缋",
	"繩": "绳",
	"繪": "绘",
	"繫": "系",
	"繭": "茧",
	"繮": "缰",
	"繯": "缳",
	"繰": "缲",
	"繳": "缴",
	"繸": "䍁",
	"繹": "绎",
	"繼": "继",
	"繽": "缤",
	"繾": "缱",
	"纈": "缬",
	"纊": "纩",
	"續": "续",
	"纍": "累",
	"纏": "缠",
	"纓": "缨",
	"纔": "才",
	"纖": "纤",
	"纘": "缵",
	"纜": "缆",
	"缽": "钵",
	"罈": "坛",
	"罌": "罂",
	"罰": "罚",
	"罵": "骂",
	"罷": "罢",
	"羅": "罗",
	"羆": "罴",
	"羈": "羁",
	"羋": "芈",
	"羥": "羟",
	"義": "义",
	"習": "习",
	"翹": "翘",
	"耬": "耧",
	"耮": "耢",
	"聖": "圣",
	"聞": "闻",
	"聯": "联",
	"聰": "聪",
	"聲": "声",
	"聳": "耸",
	"聵": "聩",
	"聶": "聂",
	"職": "职",
	"聹": "聍",
	"聽": "听",
	"聾": "聋",
	"肅": "肃",
	"脅": "胁",
	"脈": "脉",
	"脛": "胫",
	"脩": "修",
	"脫": "脱",
	"脹": "胀",
	"腎": "肾",
	"腖": "胨",
	"腡": "脶",
	"腦": "脑",
	"腫": "肿",
	"腳": "脚",
	"腸": "肠",
	"膃": "腽",
	"膚": "肤",
	"膠": "胶",
	"膩": "腻",
	"膽": "胆",
	"膾": "脍",
	"膿": "脓",
	"臉": "脸",
	"臍": "脐",
	"臏": "膑",
	"臘": "腊",
	"臚": "胪",
	"臟": "脏",
	"臠": "脔",
	"臢": "臜",
	"臥": "卧",
	"臨": "临",
	"臺": "台",
	"與": "与",
	"興": "兴",
	"舉": "举",
	"舊": "旧",
	"艙": "舱",
	"艤": "舣",
	"艦": "舰",
	"艫": "舻",
	"艱": "艰",
	"艷": "艳",
	"芻": "刍",
	"苎": "苧",
	"苧": "苎",
	"茲": "兹",
	"荊": "荆",
	"莊": "庄",
	"莖": "茎",
	"莢": "荚",
	"莧": "苋",
	"華": "华",
	"萇": "苌",
	"萊": "莱",
	"萬": "万",
	"萵": "莴",
	"葉": "叶",
	"葒": "荭",
	"著": "着",
	"葤": "荮",
	"葦": "苇",
	"葯": "药",
	"葷": "荤",
	"蒓": "莼",
	"蒔": "莳",
	"蒞": "莅",
	"蒼": "苍",
	"蓀": "荪",
	"蓋": "盖",
	"蓮": "莲",
	"蓯": "苁",
	"蓴": "莼",
	"蓽": "荜",
	"蔔": "卜",
	"蔞": "蒌",
	"蔣": "蒋",
	"蔥": "葱",
	"蔦": "茑",
	"蔭": "荫",
	"蕁": "荨",
	"蕆": "蒇",
	"蕎": "荞",
	"蕒": "荬",
	"蕓": "芸",
	"蕕": "莸",
	"蕘": "荛",
	"蕢": "蒉",
	"蕩": "荡",
	"蕪": "芜",
	"蕭": "萧",
	"蕷": "蓣",
	"薀": "蕰",
	"薈": "荟",
	"薊": "蓟",
	"薌": "芗",
	"薑": "姜",
	"薔": "蔷",
	"薘": "荙",
	"薟": "莶",
	"薦": "荐",
	"薩": "萨",
	"薴": "苧",
	"薺": "荠",
	"藉": "借",
	"藍": "蓝",
	"藎": "荩",
	"藝": "艺",
	"藥": "药",
	"藪": "薮",
	"藴": "蕴",
	"藶": "苈",
	"藹": "蔼",
	"藺": "蔺",
	"蘄": "蕲",
	"蘆": "芦",
	"蘇": "苏",
	"蘊": "蕴",
	"蘋": "苹",
	"蘚": "藓",
	"蘞": "蔹",
	"蘢": "茏",
	"蘭": "兰",
	"蘺": "蓠",
	"蘿": "萝",
	"虆": "蔂",
	"處": "处",
	"虛": "虚",
	"虜": "虏",
	"號": "号",
	"虧": "亏",
	"虯": "虬",
	"蛺": "蛱",
	"蛻": "蜕",
	"蜆": "蚬",
	"蝕": "蚀",
	"蝟": "猬",
	"蝦": "虾",
	"蝸": "蜗",
	"螄": "蛳",
	"螞": "蚂",
	"螢": "萤",
	"螻": "蝼",
	"螿": "螀",
	"蟄": "蛰",
	"蟈": "蝈",
	"蟎": "螨",
	"蟣": "虮",
	"蟬": "蝉",
	"蟯": "蛲",
	"蟲": "虫",
	"蟶": "蛏",
	"蟻": "蚁",
	"蠅": "蝇",
	"蠆": "虿",
	"蠐": "蛴",
	"蠑": "蝾",
	"蠟": "蜡",
	"蠣": "蛎",
	"蠨": "蟏",
	"蠱": "蛊",
	"蠶": "蚕",
	"蠻": "蛮",
	"衆": "众",
	"衊": "蔑",
	"術": "术",
	"衕": "同",
	"衚": "胡",
	"衛": "卫",
	"衝": "冲",
	"衹": "只",
	"袞": "衮",
	"裊": "袅",
	"裏": "里",
	"補": "补",
	"裝": "装",
	"裡": "里",
	"製": "制",
	"複": "复",
	"褌": "裈",
	"褘": "袆",
	"褲": "裤",
	"褳": "裢",
	"褸": "褛",
	"褻": "亵",
	"襇": "裥",
	"襏": "袯",
	"襖": "袄",
	"襝": "裣",
	"襠": "裆",
	"襤": "褴",
	"襪": "袜",
	"襯": "衬",
	"襲": "袭",
	"覆": "复",
	"見": "见",
	"覎": "觃",
	"規": "规",
	"覓": "觅",
	"視": "视",
	"覘": "觇",
	"覡": "觋",
	"覥": "觍",
	"覦": "觎",
	"親": "亲",
	"覬": "觊",
	"覯": "觏",
	"覲": "觐",
	"覷": "觑",
	"覺": "觉",
	"覽": "览",
	"覿": "觌",
	"觀": "观",
	"觴": "觞",
	"觶": "觯",
	"觸": "触",
	"訁": "讠",
	"訂": "订",
	"訃": "讣",
	"計": "计",
	"訊": "讯",
	"訌": "讧",
	"討": "讨",
	"訐": "讦",
	"訒": "讱",
	"訓": "训",
	"訕": "讪",
	"訖": "讫",
	"託": "讬",
	"記": "记",
	"訛": "讹",
	"訝": "讶",
	"訟": "讼",
	"訢": "䜣",
	"訣": "诀",
	"訥": "讷",
	"訩": "讻",
	"訪": "访",
	"設": "设",
	"許": "许",
	"訴": "诉",
	"訶": "诃",
	"診": "诊",
	"註": "注",
	"詁": "诂",
	"詆": "诋",
	"詎": "讵",
	"詐": "诈",
	"詒": "诒",
	"詔": "诏",
	"評": "评",
	"詖": "诐",
	"詗": "诇",
	"詘": "诎",
	"詛": "诅",
	"詞": "词",
	"詠": "咏",
	"詡": "诩",
	"詢": "询",
	"詣": "诣",
	"試": "试",
	"詩": "诗",
	"詫": "诧",
	"詬": "诟",
	"詭": "诡",
	"詮": "诠",
	"詰": "诘",
	"話": "话",
	"該": "该",
	"詳": "详",
	"詵": "诜",
	"詼": "诙",
	"詿": "诖",
	"誄": "诔",
	"誅": "诛",
	"誆": "诓",
	"誇": "夸",
	"誌": "志",
	"認": "认",
	"誑": "诳",
	"誒": "诶",
	"誕": "诞",
	"誘": "诱",
	"誚": "诮",
	"語": "语",
	"誠": "诚",
	"誡": "诫",
	"誣": "诬",
	"誤": "误",
	"誥": "诰",
	"誦": "诵",
	"誨": "诲",
	"說": "说",
	"説": "说",
	"誰": "谁",
	"課": "课",
	"誶": "谇",
	"誹": "诽",
	"誼": "谊",
	"誾": "訚",
	"調": "调",
	"諂": "谄",
	"諄": "谆",
	"談": "谈",
	"諉": "诿",
	"請": "请",
	"諍": "诤",
	"諏": "诹",
	"諑": "诼",
	"諒": "谅",
	"論": "论",
	"諗": "谂",
	"諛": "谀",
	"諜": "谍",
	"諝": "谞",
	"諞": "谝",
	"諢": "诨",
	"諤": "谔",
	"諦": "谛",
	"諧": "谐",
	"諫": "谏",
	"諭": "谕",
	"諮": "谘",
	"諱": "讳",
	"諳": "谙",
	"諶": "谌",
	"諷": "讽",
	"諸": "诸",
	"諺": "谚",
	"諼": "谖",
	"諾": "诺",
	"謀": "谋",
	"謁": "谒",
	"謂": "谓",
	"謄": "誊",
	"謅": "诌",
	"謊": "谎",
	"謎": "谜",
	"謐": "谧",
	"謔": "谑",
	"謖": "谡",
	"謗": "谤",
	"謙": "谦",
	"謚": "谥",
	"講": "讲",
	"謝": "谢",
	"謠": "谣",
	"謡": "谣",
	"謨": "谟",
	"謫": "谪",
	"謬": "谬",
	"謭": "谫",
	"謳": "讴",
	"謹": "谨",
	"謾": "谩",
	"證": "证",
	"譎": "谲",
	"譏": "讥",
	"譖": "谮",
	"識": "识",
	"譙": "谯",
	"譚": "谭",
	"譜": "谱",
	"譫": "谵",
	"譯": "译",
	"議": "议",
	"譴": "谴",
	"護": "护",
	"譸": "诪",
	"譽": "誉",
	"譾": "谫",
	"讀": "读",
	"變": "变",
	"讎": "雠",
	"讒": "谗",
	"讓": "让",
	"讕": "谰",
	"讖": "谶",
	"讜": "谠",
	"讞": "谳",
	"豈": "岂",
	"豎": "竖",
	"豐": "丰",
	"豬": "猪",
	"豶": "豮",
	"貓": "猫",
	"貝": "贝",
	"貞": "贞",
	"貟": "贠",
	"負": "负",
	"財": "财",
	"貢": "贡",
	"貧": "贫",
	"貨": "货",
	"販": "贩",
	"貪": "贪",
	"貫": "贯",
	"責": "责",
	"貯": "贮",
	"貰": "贳",
	"貲": "赀",
	"貳": "贰",
	"貴": "贵",
	"貶": "贬",
	"買": "买",
	"貸": "贷",
	"貺": "贶",
	"費": "费",
	"貼": "贴",
	"貽": "贻",
	"貿": "贸",
	"賀": "贺",
	"賁": "贲",
	"賂": "赂",
	"賃": "赁",
	"賄": "贿",
	"賅": "赅",
	"資": "资",
	"賈": "贾",
	"賊": "贼",
	"賑": "赈",
	"賒": "赊",
	"賓": "宾",
	"賕": "赇",
	"賙": "赒",
	"賚": "赉",
	"賜": "赐",
	"賞": "赏",
	"賠": "赔",
	"賡": "赓",
	"賢": "贤",
	"賣": "卖",
	"賤": "贱",
	"賦": "赋",
	"賧": "赕",
	"質": "质",
	"賫": "赍",
	"賬": "账",
	"賭": "赌",
	"賴": "赖",
	"賵": "赗",
	"賺": "赚",
	"賻": "赙",
	"購": "购",
	"賽": "赛",
	"賾": "赜",
	"贄": "贽",
	"贅": "赘",
	"贇": "赟",
	"贈": "赠",
	"贊": "赞",
	"贋": "赝",
	"贍": "赡",
	"贏": "赢",
	"贐": "赆",
	"贓": "赃",
	"贔": "赑",
	"贖": "赎",
	"贗": "赝",
	"贛": "赣",
	"贜": "赃",
	"赬": "赪",
	"趕": "赶",
	"趙": "赵",
	"趨": "趋",
	"趲": "趱",
	"跡": "迹",
	"踐": "践",
	"踴": "踊",
	"蹌": "跄",
	"蹕": "跸",
	"蹣": "蹒",
	"蹤": "踪",
	"蹺": "跷",
	"躂": "跶",
	"躉": "趸",
	"躊": "踌",
	"躋": "跻",
	"躍": "跃",
	"躑": "踯",
	"躒": "跞",
	"躓": "踬",
	"躕": "蹰",
	"躚": "跹",
	"躡": "蹑",
	"躥": "蹿",
	"躦": "躜",
	"躪": "躏",
	"軀": "躯",
	"車": "车",
	"軋": "轧",
	"軌": "轨",
	"軍": "军",
	"軑": "轪",
	"軒": "轩",
	"軔": "轫",
	"軛": "轭",
	"軟": "软",
	"軤": "轷",
	"軫": "轸",
	"軲": "轱",
	"軸": "轴",
	"軹": "轵",
	"軺": "轺",
	"軻": "轲",
	"軼": "轶",
	"軾": "轼",
	"較": "较",
	"輅": "辂",
	"輇": "辁",
	"輈": "辀",
	"載": "载",
	"輊": "轾",
	"輒": "辄",
	"輓": "挽",
	"輔": "辅",
	"輕": "轻",
	"輛": "辆",
	"輜": "辎",
	"輝": "辉",
	"輞": "辋",
	"輟": "辍",
	"輥": "辊",
	"輦": "辇",
	"輩": "辈",
	"輪": "轮",
	"輬": "辌",
	"輯": "辑",
	"輳": "辏",
	"輸": "输",
	"輻": "辐",
	"輾": "辗",
	"輿": "舆",
	"轀": "辒",
	"轂": "毂",
	"轄": "辖",
	"轅": "辕",
	"轆": "辘",
	"轉": "转",
	"轍": "辙",
	"轎": "轿",
	"轔": "辚",
	"轟": "轰",
	"轡": "辔",
	"轢": "轹",
	"轤": "轳",
	"辦": "办",
	"辭": "辞",
	"辮": "辫",
	"辯": "辩",
	"農": "农",
	"迴": "回",
	"逕": "迳",
	"這": "这",
	"連": "连",
	"週": "周",
	"進": "进",
	"遊": "游",
	"運": "运",
	"過": "过",
	"達": "达",
	"違": "违",
	"遙": "遥",
	"遜": "逊",
	"遞": "递",
	"遠": "远",
	"適": "适",
	"遲": "迟",
	"遷": "迁",
	"選": "选",
	"遺": "遗",
	"遼": "辽",
	"邁": "迈",
	"還": "还",
	"邇": "迩",
	"邊": "边",
	"邏": "逻",
	"邐": "逦",
	"郟": "郏",
	"郵": "邮",
	"鄆": "郓",
	"鄉": "乡",
	"鄒": "邹",
	"鄔": "邬",
	"鄖": "郧",
	"鄧": "邓",
	"鄭": "郑",
	"鄰": "邻",
	"鄲": "郸",
	"鄴": "邺",
	"鄶": "郐",
	"鄺": "邝",
	"酇": "酂",
	"酈": "郦",
	"醖": "酝",
	"醜": "丑",
	"醞": "酝",
	"醫": "医",
	"醬": "酱",
	"醱": "酦",
	"釀": "酿",
	"釁": "衅",
	"釃": "酾",
	"釅": "酽",
	"釋": "释",
	"釐": "厘",
	"釒": "钅",
	"釓": "钆",
	"釔": "钇",
	"釕": "钌",
	"釗": "钊",
	"釘": "钉",
	"釙": "钋",
	"針": "针",
	"釣": "钓",
	"釤": "钐",
	"釧": "钏",
	"釩": "钒",
	"釵": "钗",
	"釷": "钍",
	"釹": "钕",
	"釺": "钎",
	"鈀": "钯",
	"鈁": "钫",
	"鈃": "钘",
	"鈄": "钭",
	"鈈": "钚",
	"鈉": "钠",
	"鈍": "钝",
	"鈎": "钩",
	"鈐": "钤",
	"鈑": "钣",
	"鈒": "钑",
	"鈔": "钞",
	"鈕": "钮",
	"鈞": "钧",
	"鈣": "钙",
	"鈥": "钬",
	"鈦": "钛",
	"鈧": "钪",
	"鈮": "铌",
	"鈰": "铈",
	"鈳": "钶",
	"鈴": "铃",
	"鈷": "钴",
	"鈸": "钹",
	"鈹": "铍",
	"鈺": "钰",
	"鈽": "钸",
	"鈾": "铀",
	"鈿": "钿",
	"鉀": "钾",
	"鉅": "钜",
	"鉈": "铊",
	"鉉": "铉",
	"鉋": "铇",
	"鉍": "铋",
	"鉑": "铂",
	"鉕": "钷",
	"鉗": "钳",
	"鉚": "铆",
	"鉛": "铅",
	"鉞": "钺",
	"鉢": "钵",
	"鉤": "钩",
	"鉦": "钲",
	"鉬": "钼",
	"鉭": "钽",
	"鉶": "铏",
	"鉸": "铰",
	"鉺": "铒",
	"鉻": "铬",
	"鉿": "铪",
	"銀": "银",
	"銃": "铳",
	"銅": "铜",
	"銍": "铚",
	"銑": "铣",
	"銓": "铨",
	"銖": "铢",
	"銘": "铭",
	"銚": "铫",
	"銛": "铦",
	"銜": "衔",
	"銠": "铑",
	"銣": "铷",
	"銥": "铱",
	"銦": "铟",
	"銨": "铵",
	"銩": "铥",
	"銪": "铕",
	"銫": "铯",
	"銬": "铐",
	"銱": "铞",
	"銳": "锐",
	"銷": "销",
	"銹": "锈",
	"銻": "锑",
	"銼": "锉",
	"鋁": "铝",
	"鋃": "锒",
	"鋅": "锌",
	"鋇": "钡",
	"鋌": "铤",
	"鋏": "铗",
	"鋒": "锋",
	"鋙": "铻",
	"鋝": "锊",
	"鋟": "锓",
	"鋣": "铘",
	"鋤": "锄",
	"鋥": "锃",
	"鋦": "锔",
	"鋨": "锇",
	"鋩": "铓",
	"鋪": "铺",
	"鋭": "锐",
	"鋮": "铖",
	"鋯": "锆",
	"鋰": "锂",
	"鋱": "铽",
	"鋶": "锍",
	"鋸": "锯",
	"鋼": "钢",
	"錁": "锞",
	"錄": "录",
	"錆": "锖",
	"錇": "锫",
	"錈": "锩",
	"錏": "铔",
	"錐": "锥",
	"錒": "锕",
	"錕": "锟",
	"錘": "锤",
	"錙": "锱",
	"錚": "铮",
	"錛": "锛",
	"錟": "锬",
	"錠": "锭",
	"錡": "锜",
	"錢": "钱",
	"錦": "锦",
	"錨": "锚",
	"錩": "锠",
	"錫": "锡",
	"錮": "锢",
	"錯": "错",
	"録": "录",
	"錳": "锰",
	"錶": "表",
	"錸": "铼",
	"鍀": "锝",
	"鍁": "锨",
	"鍃": "锪",
	"鍆": "钔",
	"鍇": "锴",
	"鍈": "锳",
	"鍋": "锅",
	"鍍": "镀",
	"鍔": "锷",
	"鍘": "铡",
	"鍚": "钖",
	"鍛": "锻",
	"鍠": "锽",
	"鍤": "锸",
	"鍥": "锲",
	"鍩": "锘",
	"鍬": "锹",
	"鍰": "锾",
	"鍵": "键",
	"鍶": "锶",
	"鍺": "锗",
	"鎂": "镁",
	"鎄": "锿",
	"鎇": "镅",
	"鎊": "镑",
	"鎔": "镕",
	"鎖": "锁",
	"鎘": "镉",
	"鎛": "镈",
	"鎡": "镃",
	"鎢": "钨",
	"鎣": "蓥",
	"鎦": "镏",
	"鎧": "铠",
	"鎩": "铩",
	"鎪": "锼",
	"鎬": "镐",
	"鎮": "镇",
	"鎰": "镒",
	"鎲": "镋",
	"鎳": "镍",
	"鎵": "镓",
	"鎸": "镌",
	"鎿": "镎",
	"鏃": "镞",
	"鏇": "镟",
	"鏈": "链",
	"鏌": "镆",
	"鏍": "镙",
	"鏐": "镠",
	"鏑": "镝",
	"鏗": "铿",
	"鏘": "锵",
	"鏜": "镗",
	"鏝": "镘",
	"鏞": "镛",
	"鏟": "铲",
	"鏡": "镜",
	"鏢": "镖",
	"鏤": "镂",
	"鏨": "錾",
	"鏰": "镚",
	"鏵": "铧",
	"鏷": "镤",
	"鏹": "镪",
	"鏽": "锈",
	"鐃": "铙",
	"鐋": "铴",
	"鐐": "镣",
	"鐒": "铹",
	"鐓": "镦",
	"鐔": "镡",
	"鐘": "钟",
	"鐙": "镫",
	"鐝": "镢",
	"鐠": "镨",
	"鐦": "锎",
	"鐧": "锏",
	"鐨": "镄",
	"鐫": "镌",
	"鐮": "镰",
	"鐲": "镯",
	"鐳": "镭",
	"鐵": "铁",
	"鐶": "镮",
	"鐸": "铎",
	"鐺": "铛",
	"鐿": "镱",
	"鑄": "铸",
	"鑊": "镬",
	"鑌": "镔",
	"鑒": "鉴",
	"鑔": "镲",
	"鑕": "锧",
	"鑞": "镴",
	"鑠": "铄",
	"鑣": "镳",
	"鑥": "镥",
	"鑭": "镧",
	"鑰": "钥",
	"鑱": "镵",
	"鑲": "镶",
	"鑷": "镊",
	"鑹": "镩",
	"鑼": "锣",
	"鑽": "钻",
	"鑾": "銮",
	"鑿": "凿",
	"钁": "镢",
	"長": "长",
	"門": "门",
	"閂": "闩",
	"閃": "闪",
	"閆": "闫",
	"閈": "闬",
	"閉": "闭",
	"開": "开",
	"閌": "闶",
	"閎": "闳",
	"閏": "闰",
	"閑": "闲",
	"間": "间",
	"閔": "闵",
	"閘": "闸",
	"閡": "阂",
	"閣": "阁",
	"閤": "合",
	"閥": "阀",
	"閨": "闺",
	"閩": "闽",
	"閫": "阃",
	"閬": "阆",
	"閭": "闾",
	"閱": "阅",
	"閲": "阅",
	"閶": "阊",
	"閹": "阉",
	"閻": "阎",
	"閼": "阏",
	"閽": "阍",
	"閾": "阈",
	"閿": "阌",
	"闃": "阒",
	"闆": "板",
	"闇": "暗",
	"闈": "闱",
	"闊": "阔",
	"闋": "阕",
	"闌": "阑",
	"闍": "阇",
	"闐": "阗",
	"闒": "阘",
	"闓": "闿",
	"闔": "阖",
	"闕": "阙",
	"闖": "闯",
	"關": "关",
	"闞": "阚",
	"闠": "阓",
	"闡": "阐",
	"闢": "辟",
	"闤": "阛",
	"闥": "闼",
	"阪": "坂",
	"陘": "陉",
	"陝": "陕",
	"陣": "阵",
	"陰": "阴",
	"陳": "陈",
	"陸": "陆",
	"陽": "阳",
	"隉": "陧",
	"隊": "队",
	"階": "阶",
	"隕": "陨",
	"際": "际",
	"隨": "随",
	"險": "险",
	"隱": "隐",
	"隴": "陇",
	"隸": "隶",
	"隻": "只",
	"雋": "隽",
	"雖": "虽",
	"雙": "双",
	"雛": "雏",
	"雜": "杂",
	"雞": "鸡",
	"離": "离",
	"難": "难",
	"雲": "云",
	"電": "电",
	"霢": "霡",
	"霧": "雾",
	"霽": "霁",
	"靂": "雳",
	"靄": "霭",
	"靈": "灵",
	"靚": "靓",
	"靜": "静",
	"靦": "腼",
	"靨": "靥",
	"鞀": "鼗",
	"鞏": "巩",
	"鞝": "绱",
	"鞽": "鞒",
	"韁": "缰",
	"韃": "鞑",
	"韉": "鞯",
	"韋": "韦",
	"韌": "韧",
	"韍": "韨",
	"韓": "韩",
	"韙": "韪",
	"韜": "韬",
	"韞": "韫",
	"韻": "韵",
	"響": "响",
	"頁": "页",
	"頂": "顶",
	"頃": "顷",
	"項": "项",
	"順": "顺",
	"頇": "顸",
	"須": "须",
	"頊": "顼",
	"頌": "颂",
	"頎": "颀",
	"頏": "颃",
	"預": "预",
	"頑": "顽",
	"頒": "颁",
	"頓": "顿",
	"頗": "颇",
	"領": "领",
	"頜": "颌",
	"頡": "颉",
	"頤": "颐",
	"頦": "颏",
	"頭": "头",
	"頮": "颒",
	"頰": "颊",
	"頲": "颋",
	"頴": "颕",
	"頷": "颔",
	"頸": "颈",
	"頹": "颓",
	"頻": "频",
	"頽": "颓",
	"顆": "颗",
	"題": "题",
	"額": "额",
	"顎": "颚",
	"顏": "颜",
	"顒": "颙",
	"顓": "颛",
	"顔": "颜",
	"願": "愿",
	"顙": "颡",
	"顛": "颠",
	"類": "类",
	"顢": "颟",
	"顥": "颢",
	"顧": "顾",
	"顫": "颤",
	"顬": "颥",
	"顯": "显",
	"顰": "颦",
	"顱": "颅",
	"顳": "颞",
	"顴": "颧",
	"風": "风",
	"颭": "飐",
	"颮": "飑",
	"颯": "飒",
	"颱": "台",
	"颳": "刮",
	"颶": "飓",
	"颸": "飔",
	"颺": "飏",
	"颻": "飖",
	"颼": "飕",
	"飀": "飗",
	"飄": "飘",
	"飆": "飙",
	"飈": "飚",
	"飛": "飞",
	"飠": "饣",
	"飢": "饥",
	"飣": "饤",
	"飥": "饦",
	"飩": "饨",
	"飪": "饪",
	"飫": "饫",
	"飭": "饬",
	"飯": "饭",
	"飲": "饮",
	"飴": "饴",
	"飼": "饲",
	"飽": "饱",
	"飾": "饰",
	"飿": "饳",
	"餃": "饺",
	"餄": "饸",
	"餅": "饼",
	"餉": "饷",
	"養": "养",
	"餌": "饵",
	"餎": "饹",
	"餏": "饻",
	"餑": "饽",
	"餒": "馁",
	"餓": "饿",
	"餕": "馂",
	"餖": "饾",
	"餘": "余",
	"餚": "肴",
	"餛": "馄",
	"餜": "馃",
	"餞": "饯",
	"餡": "馅",
	"館": "馆",
	"餱": "糇",
	"餳": "饧",
	"餶": "馉",
	"餷": "馇",
	"餺": "馎",
	"餼": "饩",
	"餾": "馏",
	"餿": "馊",
	"饁": "馌",
	"饃": "馍",
	"饅": "馒",
	"饈": "馐",
	"饉": "馑",
	"饊": "馓",
	"饋": "馈",
	"饌": "馔",
	"饑": "饥",
	"饒": "饶",
	"饗": "飨",
	"饜": "餍",
	"饞": "馋",
	"饢": "馕",
	"馬": "马",
	"馭": "驭",
	"馮": "冯",
	"馱": "驮",
	"馳": "驰",
	"馴": "驯",
	"馹": "驲",
	"駁": "驳",
	"駐": "驻",
	"駑": "驽",
	"駒": "驹",
	"駔": "驵",
	"駕": "驾",
	"駘": "骀",
	"駙": "驸",
	"駛": "驶",
	"駝": "驼",
	"駟": "驷",
	"駡": "骂",
	"駢": "骈",
	"駭": "骇",
	"駰": "骃",
	"駱": "骆",
	"駸": "骎",
	"駿": "骏",
	"騁": "骋",
	"騂": "骍",
	"騅": "骓",
	"騌": "骔",
	"騍": "骒",
	"騎": "骑",
	"騏": "骐",
	"騖": "骛",
	"騙": "骗",
	"騤": "骙",
	"騫": "骞",
	"騭": "骘",
	"騮": "骝",
	"騰": "腾",
	"騶": "驺",
	"騷": "骚",
	"騸": "骟",
	"騾": "骡",
	"驀": "蓦",
	"驁": "骜",
	"驂": "骖",
	"驃": "骠",
	"驄": "骢",
	"驅": "驱",
	"驊": "骅",
	"驌": "骕",
	"驍": "骁",
	"驏": "骣",
	"驕": "骄",
	"驗": "验",
	"驚": "惊",
	"驛": "驿",
	"驟": "骤",
	"驢": "驴",
	"驤": "骧",
	"驥": "骥",
	"驦": "骦",
	"驪": "骊",
	"驫": "骉",
	"骯": "肮",
	"髏": "髅",
	"髒": "脏",
	"體": "体",
	"髕": "髌",
	"髖": "髋",
	"髮": "发",
	"鬆": "松",
	"鬍": "胡",
	"鬚": "须",
	"鬢": "鬓",
	"鬥": "斗",
	"鬧": "闹",
	"鬩": "阋",
	"鬮": "阄",
	"鬱": "郁",
	"魎": "魉",
	"魘": "魇",
	"魚": "鱼",
	"魛": "鱽",
	"魢": "鱾",
	"魨": "鲀",
	"魯": "鲁",
	"魴": "鲂",
	"魷": "鱿",
	"魺": "鲄",
	"鮁": "鲅",
	"鮃": "鲆",
	"鮊": "鲌",
	"鮋": "鲉",
	"鮍": "鲏",
	"鮎": "鲇",
	"鮐": "鲐",
	"鮑": "鲍",
	"鮒": "鲋",
	"鮓": "鲊",
	"鮚": "鲒",
	"鮜": "鲘",
	"鮝": "鲞",
	"鮞": "鲕",
	"鮦": "鲖",
	"鮪": "鲔",
	"鮫": "鲛",
	"鮭": "鲑",
	"鮮": "鲜",
	"鮳": "鲓",
	"鮶": "鲪",
	"鮺": "鲝",
	"鯀": "鲧",
	"鯁": "鲠",
	"鯇": "鲩",
	"鯉": "鲤",
	"鯊": "鲨",
	"鯒": "鲬",
	"鯔": "鲻",
	"鯕": "鲯",
	"鯖": "鲭",
	"鯗": "鲞",
	"鯛": "鲷",
	"鯝": "鲴",
	"鯡": "鲱",
	"鯢": "鲵",
	"鯤": "鲲",
	"鯧": "鲳",
	"鯨": "鲸",
	"鯪": "鲮",
	"鯫": "鲰",
	"鯴": "鲺",
	"鯷": "鳀",
	"鯽": "鲫",
	"鯿": "鳊",
	"鰁": "鳈",
	"鰂": "鲗",
	"鰃": "鳂",
	"鰈": "鲽",
	"鰉": "鳇",
	"鰍": "鳅",
	"鰏": "鲾",
	"鰐": "鳄",
	"鰒": "鳆",
	"鰓": "鳃",
	"鰜": "鳒",
	"鰟": "鳑",
	"鰠": "鳋",
	"鰣": "鲥",
	"鰥": "鳏",
	"鰨": "鳎",
	"鰩": "鳐",
	"鰭": "鳍",
	"鰮": "鳁",
	"鰱": "鲢",
	"鰲": "鳌",
	"鰳": "鳓",
	"鰵": "鳘",
	"鰷": "鲦",
	"鰹": "鲣",
	"鰺": "鲹",
	"鰻": "鳗",
	"鰼": "鳛",
	"鰾": "鳔",
	"鱂": "鳉",
	"鱅": "鳙",
	"鱈": "鳕",
	"鱉": "鳖",
	"鱒": "鳟",
	"鱔": "鳝",
	"鱖": "鳜",
	"鱗": "鳞",
	"鱘": "鲟",
	"鱝": "鲼",
	"鱟": "鲎",
	"鱠": "鲙",
	"鱣": "鳣",
	"鱤": "鳡",
	"鱧": "鳢",
	"鱨": "鲿",
	"鱭": "鲚",
	"鱯": "鳠",
	"鱷": "鳄",
	"鱸": "鲈",
	"鱺": "鲡",
	"䰾": "鲃",
	"䲁": "鳚",
	"鳥": "鸟",
	"鳧": "凫",
	"鳩": "鸠",
	"鳬": "凫",
	"鳲": "鸤",
	"鳳": "凤",
	"鳴": "鸣",
	"鳶": "鸢",
	"鳾": "䴓",
	"鴆": "鸩",
	"鴇": "鸨",
	"鴉": "鸦",
	"鴒": "鸰",
	"鴕": "鸵",
	"鴛": "鸳",
	"鴝": "鸲",
	"鴞": "鸮",
	"鴟": "鸱",
	"鴣": "鸪",
	"鴦": "鸯",
	"鴨": "鸭",
	"鴯": "鸸",
	"鴰": "鸹",
	"鴴": "鸻",
	"鴷": "䴕",
	"鴻": "鸿",
	"鴿": "鸽",
	"鵁": "䴔",
	"鵂": "鸺",
	"鵃": "鸼",
	"鵐": "鹀",
	"鵑": "鹃",
	"鵒": "鹆",
	"鵓": "鹁",
	"鵜": "鹈",
	"鵝": "鹅",
	"鵠": "鹄",
	"鵡": "鹉",
	"鵪": "鹌",
	"鵬": "鹏",
	"鵮": "鹐",
	"鵯": "鹎",
	"鵲": "鹊",
	"鵷": "鹓",
	"鵾": "鹍",
	"鶄": "䴖",
	"鶇": "鸫",
	"鶉": "鹑",
	"鶊": "鹒",
	"鶓": "鹋",
	"鶖": "鹙",
	"鶘": "鹕",
	"鶚": "鹗",
	"鶡": "鹖",
	"鶥": "鹛",
	"鶩": "鹜",
	"鶪": "䴗",
	"鶬": "鸧",
	"鶯": "莺",
	"鶲": "鹟",
	"鶴": "鹤",
	"鶹": "鹠",
	"鶺": "鹡",
	"鶻": "鹘",
	"鶼": "鹣",
	"鶿": "鹚",
	"鷀": "鹚",
	"鷁": "鹢",
	"鷂": "鹞",
	"鷄": "鸡",
	"鷈": "䴘",
	"鷊": "鹝",
	"鷓": "鹧",
	"鷖": "鹥",
	"鷗": "鸥",
	"鷙": "鸷",
	"鷚": "鹨",
	"鷥": "鸶",
	"鷦": "鹪",
	"鷫": "鹔",
	"鷯": "鹩",
	"鷲": "鹫",
	"鷳": "鹇",
	"鷸": "鹬",
	"鷹": "鹰",
	"鷺": "鹭",
	"鷽": "鸴",
	"鷿": "䴙",
	"鸇": "鹯",
	"鸌": "鹱",
	"鸏": "鹲",
	"鸕": "鸬",
	"鸘": "鹴",
	"鸚": "鹦",
	"鸛": "鹳",
	"鸝": "鹂",
	"鸞": "鸾",
	"鹵": "卤",
	"鹹": "咸",
	"鹺": "鹾",
	"鹽": "盐",
	"麗": "丽",
	"麥": "麦",
	"麩": "麸",
	"麪": "面",
	"麫": "面",
	"麯": "曲",
	"麵": "面",
	"麽": "么",
	"黃": "黄",
	"黌": "黉",
	"點": "点",
	"黨": "党",
	"黲": "黪",
	"黴": "霉",
	"黶": "黡",
	"黷": "黩",
	"黽": "黾",
	"黿": "鼋",
	"鼉": "鼍",
	"鼕": "冬",
	"鼴": "鼹",
	"齊": "齐",
	"齋": "斋",
	"齎": "赍",
	"齏": "齑",
	"齒": "齿",
	"齔": "龀",
	"齕": "龁",
	"齗": "龂",
	"齙": "龅",
	"齜": "龇",
	"齟": "龃",
	"齠": "龆",
	"齡": "龄",
	"齣": "出",
	"齦": "龈",
	"齪": "龊",
	"齬": "龉",
	"齲": "龋",
	"齶": "腭",
	"齷": "龌",
	"龍": "龙",
	"龎": "厐",
	"龐": "庞",
	"龔": "龚",
	"龕": "龛",
	"龜": "龟",
};

export default exports as typeof import('./wikipedia');

